var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __accessCheck = (obj, member, msg) => {
  if (!member.has(obj))
    throw TypeError("Cannot " + msg);
};
var __privateGet = (obj, member, getter) => {
  __accessCheck(obj, member, "read from private field");
  return getter ? getter.call(obj) : member.get(obj);
};
var __privateAdd = (obj, member, value) => {
  if (member.has(obj))
    throw TypeError("Cannot add the same private member more than once");
  member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
};
var __privateSet = (obj, member, value, setter) => {
  __accessCheck(obj, member, "write to private field");
  setter ? setter.call(obj, value) : member.set(obj, value);
  return value;
};
var __privateWrapper = (obj, member, setter, getter) => {
  return {
    set _(value) {
      __privateSet(obj, member, value, setter);
    },
    get _() {
      return __privateGet(obj, member, getter);
    }
  };
};
var _instance, _uid, _notificationDefaults;
import Vue from "vue";
const consoleWarn = (message) => console.warn(`Wave UI: ${message}`);
const consoleError = (message) => console.error(`Wave UI: ${message}`);
const config = Vue.observable({
  breakpoints: {
    xs: 600,
    sm: 900,
    md: 1200,
    lg: 1700,
    xl: 9999
  },
  css: {
    colorShades: true,
    breakpointSpaces: false,
    breakpointLayoutClasses: true,
    grid: 12
  },
  colors: {
    primary: "#234781",
    secondary: "#d3ebff",
    info: "#3d9ff5",
    warning: "#f80",
    success: "#54b946",
    error: "#f65555"
  },
  icons: [],
  iconsLigature: false,
  notificationManager: {
    align: "right",
    transition: "default"
  },
  presets: {}
});
const mergeConfig = (options, conf = config) => {
  if (!Object.keys(conf).length)
    conf = Object.assign(conf, options);
  else {
    for (const key in options) {
      const option = options[key];
      if (typeof option === "object") {
        mergeConfig(options[key], conf[key]);
      } else
        conf[key] = option;
    }
  }
  return conf;
};
const _NotificationManager$1 = class {
  constructor() {
    __publicField(this, "notifications");
    __privateAdd(this, _uid, void 0);
    __privateAdd(this, _notificationDefaults, void 0);
    if (__privateGet(_NotificationManager$1, _instance))
      return __privateGet(_NotificationManager$1, _instance);
    __privateSet(_NotificationManager$1, _instance, this);
    this.notifications = [];
    __privateSet(this, _uid, 0);
    __privateSet(this, _notificationDefaults, {
      _uid: 0,
      _value: true,
      message: "",
      timeout: 4e3,
      dismiss: true
    });
  }
  notify(...args) {
    let notification = { ...__privateGet(this, _notificationDefaults), _uid: __privateWrapper(this, _uid)._++ };
    if (typeof args[0] === "object")
      notification = { ...notification, ...args[0] };
    else {
      const [message, type, timeout] = args;
      notification = {
        ...notification,
        message: message || "",
        [type === void 0 ? "info" : type]: true,
        timeout: timeout || timeout === 0 ? parseFloat(timeout) : 4e3
      };
    }
    Vue.set(this.notifications, this.notifications.length, notification);
    if (~~notification.timeout !== 0)
      setTimeout(() => this.dismiss(notification._uid), notification.timeout);
  }
  dismiss(uid2) {
    this.notifications = this.notifications.filter((item) => item._uid !== uid2);
  }
};
let NotificationManager$1 = _NotificationManager$1;
_instance = new WeakMap();
_uid = new WeakMap();
_notificationDefaults = new WeakMap();
__privateAdd(NotificationManager$1, _instance, void 0);
const shadeColor = (color, amount) => {
  return "#" + color.slice(1).match(/../g).map((x) => {
    x = +`0x${x}` + amount;
    return (x < 0 ? 0 : x > 255 ? 255 : x).toString(16).padStart(2, 0);
  }).join("");
};
const generateColorShades = (config2) => {
  config2.shades = {};
  for (let color in config2.colors) {
    color = { label: color, color: config2.colors[color].replace("#", "") };
    const col = color.color;
    if (col.length === 3)
      color.color = col[0] + "" + col[0] + col[1] + col[1] + col[2] + col[2];
    for (let i = 1; i <= 3; i++) {
      const lighterColor = shadeColor(`#${color.color}`, i * 40);
      const darkerColor = shadeColor(`#${color.color}`, -i * 40);
      config2.shades[`${color.label}-light${i}`] = lighterColor;
      config2.shades[`${color.label}-dark${i}`] = darkerColor;
    }
  }
};
const flattenColors = (themeColors, colorPalette2) => {
  const colors = {
    ...colorPalette2.reduce((obj, color) => {
      obj[color.label] = color.color;
      const shades = (color.shades || []).reduce((obj2, color2) => {
        obj2[color2.label] = color2.color;
        return obj2;
      }, {});
      return { ...obj, ...shades };
    }, { ...themeColors, ...themeColors.shades })
  };
  delete colors.shades;
  return colors;
};
const colorPalette = [
  {
    label: "pink",
    color: "#e91e63",
    shades: [
      { label: "pink-light6", color: "#fdebf1" },
      { label: "pink-light5", color: "#faccdc" },
      { label: "pink-light4", color: "#f7adc6" },
      { label: "pink-light3", color: "#f48eb1" },
      { label: "pink-light2", color: "#f16f9b" },
      { label: "pink-light1", color: "#ee5085" },
      { label: "pink-dark1", color: "#d31555" },
      { label: "pink-dark2", color: "#b6124a" },
      { label: "pink-dark3", color: "#990f3e" },
      { label: "pink-dark4", color: "#7c0c32" },
      { label: "pink-dark5", color: "#600927" },
      { label: "pink-dark6", color: "#43071b" }
    ]
  },
  {
    label: "purple",
    color: "#a741b9",
    shades: [
      { label: "purple-light6", color: "#f9f2fa" },
      { label: "purple-light5", color: "#eed9f2" },
      { label: "purple-light4", color: "#e3c1e9" },
      { label: "purple-light3", color: "#d8a8e1" },
      { label: "purple-light2", color: "#cd90d8" },
      { label: "purple-light1", color: "#c277cf" },
      { label: "purple-dark1", color: "#9239a2" },
      { label: "purple-dark2", color: "#7d318a" },
      { label: "purple-dark3", color: "#682873" },
      { label: "purple-dark4", color: "#53205b" },
      { label: "purple-dark5", color: "#3d1844" },
      { label: "purple-dark6", color: "#28102d" }
    ]
  },
  {
    label: "deep-purple",
    color: "#673ab7",
    shades: [
      { label: "deep-purple-light6", color: "#f1edf9" },
      { label: "deep-purple-light5", color: "#daceef" },
      { label: "deep-purple-light4", color: "#c2afe6" },
      { label: "deep-purple-light3", color: "#ab90dc" },
      { label: "deep-purple-light2", color: "#9471d2" },
      { label: "deep-purple-light1", color: "#7c52c8" },
      { label: "deep-purple-dark1", color: "#5b33a1" },
      { label: "deep-purple-dark2", color: "#4e2c8b" },
      { label: "deep-purple-dark3", color: "#422575" },
      { label: "deep-purple-dark4", color: "#351e5f" },
      { label: "deep-purple-dark5", color: "#291749" },
      { label: "deep-purple-dark6", color: "#1c1033" }
    ]
  },
  {
    label: "indigo",
    color: "#3f51b5",
    shades: [
      { label: "indigo-light6", color: "#eff1fa" },
      { label: "indigo-light5", color: "#d1d6ef" },
      { label: "indigo-light4", color: "#b3bae4" },
      { label: "indigo-light3", color: "#949fda" },
      { label: "indigo-light2", color: "#7684cf" },
      { label: "indigo-light1", color: "#5869c5" },
      { label: "indigo-dark1", color: "#37479f" },
      { label: "indigo-dark2", color: "#303e8a" },
      { label: "indigo-dark3", color: "#283474" },
      { label: "indigo-dark4", color: "#212a5f" },
      { label: "indigo-dark5", color: "#192149" },
      { label: "indigo-dark6", color: "#121734" }
    ]
  },
  {
    label: "blue",
    color: "#2196f3",
    shades: [
      { label: "blue-light6", color: "#e6f3fe" },
      { label: "blue-light5", color: "#c6e4fc" },
      { label: "blue-light4", color: "#a5d4fa" },
      { label: "blue-light3", color: "#84c5f8" },
      { label: "blue-light2", color: "#63b5f7" },
      { label: "blue-light1", color: "#42a6f5" },
      { label: "blue-dark1", color: "#0c85e5" },
      { label: "blue-dark2", color: "#0b72c4" },
      { label: "blue-dark3", color: "#095fa3" },
      { label: "blue-dark4", color: "#074c82" },
      { label: "blue-dark5", color: "#053961" },
      { label: "blue-dark6", color: "#032540" }
    ]
  },
  {
    label: "light-blue",
    color: "#03a9f4",
    shades: [
      { label: "light-blue-light6", color: "#e7f7ff" },
      { label: "light-blue-light5", color: "#c0ebfe" },
      { label: "light-blue-light4", color: "#98defe" },
      { label: "light-blue-light3", color: "#71d2fd" },
      { label: "light-blue-light2", color: "#4ac5fd" },
      { label: "light-blue-light1", color: "#22b9fc" },
      { label: "light-blue-dark1", color: "#0393d5" },
      { label: "light-blue-dark2", color: "#027eb6" },
      { label: "light-blue-dark3", color: "#026896" },
      { label: "light-blue-dark4", color: "#015277" },
      { label: "light-blue-dark5", color: "#013d58" },
      { label: "light-blue-dark6", color: "#012739" }
    ]
  },
  {
    label: "cyan",
    color: "#04cbe5",
    shades: [
      { label: "cyan-light6", color: "#e9fcff" },
      { label: "cyan-light5", color: "#baf6fe" },
      { label: "cyan-light4", color: "#8bf0fd" },
      { label: "cyan-light3", color: "#5ceafc" },
      { label: "cyan-light2", color: "#2ce3fb" },
      { label: "cyan-light1", color: "#04d8f4" },
      { label: "cyan-dark1", color: "#04b2c8" },
      { label: "cyan-dark2", color: "#0398ac" },
      { label: "cyan-dark3", color: "#037f8f" },
      { label: "cyan-dark4", color: "#026673" },
      { label: "cyan-dark5", color: "#024c56" },
      { label: "cyan-dark6", color: "#01333a" }
    ]
  },
  {
    label: "teal",
    color: "#1db3a8",
    shades: [
      { label: "teal-light6", color: "#e2faf9" },
      { label: "teal-light5", color: "#b8f3ef" },
      { label: "teal-light4", color: "#8eede6" },
      { label: "teal-light3", color: "#64e6dc" },
      { label: "teal-light2", color: "#39dfd3" },
      { label: "teal-light1", color: "#20c7bb" },
      { label: "teal-dark1", color: "#199b92" },
      { label: "teal-dark2", color: "#15847c" },
      { label: "teal-dark3", color: "#116c65" },
      { label: "teal-dark4", color: "#0e544f" },
      { label: "teal-dark5", color: "#0a3c39" },
      { label: "teal-dark6", color: "#062523" }
    ]
  },
  {
    label: "green",
    color: "#4caf50",
    shades: [
      { label: "green-light6", color: "#edf7ed" },
      { label: "green-light5", color: "#d2ebd3" },
      { label: "green-light4", color: "#b7e0b8" },
      { label: "green-light3", color: "#9bd49e" },
      { label: "green-light2", color: "#80c883" },
      { label: "green-light1", color: "#65bc69" },
      { label: "green-dark1", color: "#439b47" },
      { label: "green-dark2", color: "#3a863d" },
      { label: "green-dark3", color: "#327234" },
      { label: "green-dark4", color: "#295e2b" },
      { label: "green-dark5", color: "#204a22" },
      { label: "green-dark6", color: "#173518" }
    ]
  },
  {
    label: "light-green",
    color: "#90d73f",
    shades: [
      { label: "light-green-light6", color: "#f4fbec" },
      { label: "light-green-light5", color: "#e5f6d3" },
      { label: "light-green-light4", color: "#d7f1b9" },
      { label: "light-green-light3", color: "#c8eba0" },
      { label: "light-green-light2", color: "#b9e687" },
      { label: "light-green-light1", color: "#abe16d" },
      { label: "light-green-dark1", color: "#80cc2a" },
      { label: "light-green-dark2", color: "#70b225" },
      { label: "light-green-dark3", color: "#609820" },
      { label: "light-green-dark4", color: "#4f7d1a" },
      { label: "light-green-dark5", color: "#3f6315" },
      { label: "light-green-dark6", color: "#2e490f" }
    ]
  },
  {
    label: "lime",
    color: "#cee029",
    shades: [
      { label: "lime-light6", color: "#fafce9" },
      { label: "lime-light5", color: "#f4f8ce" },
      { label: "lime-light4", color: "#edf4b2" },
      { label: "lime-light3", color: "#e7f097" },
      { label: "lime-light2", color: "#e1ec7b" },
      { label: "lime-light1", color: "#dae85f" },
      { label: "lime-dark1", color: "#bbcc1e" },
      { label: "lime-dark2", color: "#a1b01a" },
      { label: "lime-dark3", color: "#889516" },
      { label: "lime-dark4", color: "#6f7912" },
      { label: "lime-dark5", color: "#565d0e" },
      { label: "lime-dark6", color: "#3c420a" }
    ]
  },
  {
    label: "yellow",
    color: "#ffe70f",
    shades: [
      { label: "yellow-light6", color: "#fffce0" },
      { label: "yellow-light5", color: "#fff9c4" },
      { label: "yellow-light4", color: "#fff6a8" },
      { label: "yellow-light3", color: "#fff38c" },
      { label: "yellow-light2", color: "#fff170" },
      { label: "yellow-light1", color: "#ffee54" },
      { label: "yellow-dark1", color: "#eed700" },
      { label: "yellow-dark2", color: "#cfba00" },
      { label: "yellow-dark3", color: "#af9e00" },
      { label: "yellow-dark4", color: "#908100" },
      { label: "yellow-dark5", color: "#706500" },
      { label: "yellow-dark6", color: "#504800" }
    ]
  },
  {
    label: "amber",
    color: "#ffc107",
    shades: [
      { label: "amber-light6", color: "#fffaed" },
      { label: "amber-light5", color: "#fff1c6" },
      { label: "amber-light4", color: "#ffe7a0" },
      { label: "amber-light3", color: "#ffde7a" },
      { label: "amber-light2", color: "#ffd454" },
      { label: "amber-light1", color: "#ffcb2d" },
      { label: "amber-dark1", color: "#e6ad00" },
      { label: "amber-dark2", color: "#c79500" },
      { label: "amber-dark3", color: "#a77d00" },
      { label: "amber-dark4", color: "#886600" },
      { label: "amber-dark5", color: "#684e00" },
      { label: "amber-dark6", color: "#483600" }
    ]
  },
  {
    label: "orange",
    color: "#ff9800",
    shades: [
      { label: "orange-light6", color: "#fff5e6" },
      { label: "orange-light5", color: "#ffe5bf" },
      { label: "orange-light4", color: "#ffd699" },
      { label: "orange-light3", color: "#ffc673" },
      { label: "orange-light2", color: "#ffb74d" },
      { label: "orange-light1", color: "#ffa726" },
      { label: "orange-dark1", color: "#df8500" },
      { label: "orange-dark2", color: "#c07200" },
      { label: "orange-dark3", color: "#a05f00" },
      { label: "orange-dark4", color: "#814d00" },
      { label: "orange-dark5", color: "#613a00" },
      { label: "orange-dark6", color: "#412700" }
    ]
  },
  {
    label: "deep-orange",
    color: "#ff6825",
    shades: [
      { label: "deep-orange-light6", color: "#fff0e9" },
      { label: "deep-orange-light5", color: "#ffd9c8" },
      { label: "deep-orange-light4", color: "#ffc2a8" },
      { label: "deep-orange-light3", color: "#ffac87" },
      { label: "deep-orange-light2", color: "#ff9566" },
      { label: "deep-orange-light1", color: "#ff7f46" },
      { label: "deep-orange-dark1", color: "#ff5205" },
      { label: "deep-orange-dark2", color: "#e54600" },
      { label: "deep-orange-dark3", color: "#c53d00" },
      { label: "deep-orange-dark4", color: "#a63300" },
      { label: "deep-orange-dark5", color: "#862900" },
      { label: "deep-orange-dark6", color: "#661f00" }
    ]
  },
  {
    label: "red",
    color: "#fa3317",
    shades: [
      { label: "red-light6", color: "#fee3df" },
      { label: "red-light5", color: "#fec6be" },
      { label: "red-light4", color: "#fdaa9e" },
      { label: "red-light3", color: "#fc8d7d" },
      { label: "red-light2", color: "#fc705d" },
      { label: "red-light1", color: "#fb543c" },
      { label: "red-dark1", color: "#ec2205" },
      { label: "red-dark2", color: "#cd1d04" },
      { label: "red-dark3", color: "#ae1904" },
      { label: "red-dark4", color: "#8f1403" },
      { label: "red-dark5", color: "#701002" },
      { label: "red-dark6", color: "#520c02" }
    ]
  },
  {
    label: "brown",
    color: "#845848",
    shades: [
      { label: "brown-light6", color: "#f2eae7" },
      { label: "brown-light5", color: "#e2d1ca" },
      { label: "brown-light4", color: "#d2b7ad" },
      { label: "brown-light3", color: "#c39e90" },
      { label: "brown-light2", color: "#b38473" },
      { label: "brown-light1", color: "#a16b58" },
      { label: "brown-dark1", color: "#744d3f" },
      { label: "brown-dark2", color: "#634236" },
      { label: "brown-dark3", color: "#53372d" },
      { label: "brown-dark4", color: "#422c24" },
      { label: "brown-dark5", color: "#32211b" },
      { label: "brown-dark6", color: "#211612" }
    ]
  },
  {
    label: "blue-grey",
    color: "#6c8693",
    shades: [
      { label: "blue-grey-light6", color: "#f0f3f4" },
      { label: "blue-grey-light5", color: "#dae1e4" },
      { label: "blue-grey-light4", color: "#c4cfd4" },
      { label: "blue-grey-light3", color: "#aebcc4" },
      { label: "blue-grey-light2", color: "#98aab3" },
      { label: "blue-grey-light1", color: "#8298a3" },
      { label: "blue-grey-dark1", color: "#5f7581" },
      { label: "blue-grey-dark2", color: "#51656f" },
      { label: "blue-grey-dark3", color: "#44545c" },
      { label: "blue-grey-dark4", color: "#36444a" },
      { label: "blue-grey-dark5", color: "#293338" },
      { label: "blue-grey-dark6", color: "#1c2226" }
    ]
  },
  {
    label: "grey",
    color: "#848484",
    shades: [
      { label: "grey-light6", color: "#f7f7f7" },
      { label: "grey-light5", color: "#e4e4e4" },
      { label: "grey-light4", color: "#d1d1d1" },
      { label: "grey-light3", color: "#bdbdbd" },
      { label: "grey-light2", color: "#aaaaaa" },
      { label: "grey-light1", color: "#979797" },
      { label: "grey-dark1", color: "#747474" },
      { label: "grey-dark2", color: "#646464" },
      { label: "grey-dark3", color: "#555555" },
      { label: "grey-dark4", color: "#454545" },
      { label: "grey-dark5", color: "#353535" },
      { label: "grey-dark6", color: "#252525" }
    ]
  },
  { label: "black", color: "#000" },
  { label: "white", color: "#fff" },
  { label: "transparent", color: "transparent" },
  { label: "inherit", color: "inherit" }
];
const injectPresets = (component, presets) => {
  var _a, _b;
  for (const preset in presets) {
    if (!((_a = component.props) == null ? void 0 : _a[preset])) {
      let foundProp = false;
      if (Array.isArray(component.mixins) && component.mixins.length) {
        for (const mixin of component.mixins) {
          if ((_b = mixin == null ? void 0 : mixin.props) == null ? void 0 : _b[preset]) {
            mixin.props[preset].default = presets[preset];
            foundProp = true;
            break;
          }
        }
        if (!foundProp)
          consoleWarn(`Attempting to set a preset on a prop that doesn't exist: \`${component.name}.${preset}\`.`);
        continue;
      }
    } else
      component.props[preset].default = presets[preset];
  }
};
const _WaveUI = class {
  constructor(options = {}) {
    __publicField(this, "$waveui", {
      breakpoint: {
        name: "",
        xs: false,
        sm: false,
        md: false,
        lg: false,
        xl: false
      },
      config: {},
      colors: {},
      _notificationManager: null,
      notify(...args) {
        this._notificationManager.notify(...args);
      }
    });
    if (_WaveUI.instance)
      return _WaveUI.instance;
    this.$waveui._notificationManager = new NotificationManager$1();
    this.$waveui.config = mergeConfig(options);
    const config2 = this.$waveui.config;
    if (config2.css.colorShades)
      generateColorShades(config2);
    this.$waveui.colors = flattenColors(config2.colors, colorPalette);
    _WaveUI.instance = this;
    const $waveui = _WaveUI.vueInstance.observable(this.$waveui);
    _WaveUI.vueInstance.prototype.$waveui = $waveui;
    delete _WaveUI.vueInstance;
  }
  static install(Vue2, options = {}) {
    var _a;
    Vue2.directive("focus", {
      inserted: (el) => setTimeout(() => el.focus(), 0)
    });
    Vue2.directive("scroll", {
      inserted: (el, binding) => {
        const f = (evt) => {
          if (binding.value(evt, el))
            window.removeEventListener("scroll", f);
        };
        window.addEventListener("scroll", f);
      }
    });
    const { components: components2 = {} } = options || {};
    for (const id in components2) {
      const component = components2[id];
      if ((_a = options.presets) == null ? void 0 : _a[component.name])
        injectPresets(component, options.presets[component.name]);
      Vue2.component(component.name, component);
    }
    _WaveUI.vueInstance = Vue2;
  }
};
let WaveUI = _WaveUI;
__publicField(WaveUI, "instance", null);
__publicField(WaveUI, "vueInstance", null);
var render$T = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-accordion", class: _vm.accordionClasses }, _vm._l(_vm.accordionItems, function(item, i) {
    return _c("div", { key: i, staticClass: "w-accordion__item", class: _vm.itemClasses(item), attrs: { "aria-expanded": item._expanded ? "true" : "false" } }, [_c("div", { staticClass: "w-accordion__item-title", class: _vm.titleClass, attrs: { "tabindex": !item._disabled && 0 }, on: { "click": function($event) {
      !item._disabled && _vm.toggleItem(item, $event);
    }, "focus": function($event) {
      _vm.$emit("focus", _vm.getOriginalItem(item));
    }, "keypress": function($event) {
      if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
        return null;
      }
      !item._disabled && _vm.toggleItem(item, $event);
    } } }, [_vm.expandIcon && !_vm.expandIconRight ? _c("w-button", { staticClass: "w-accordion__expand-icon", class: { "w-accordion__expand-icon--expanded": item._expanded, "w-accordion__expand-icon--rotate90": _vm.expandIconRotate90 }, attrs: { "icon": item._expanded && _vm.collapseIcon || _vm.expandIcon, "icon-props": _vm.expandIconProps, "disabled": item._disabled || null, "tabindex": -1, "text": "" }, on: { "keypress": function($event) {
      $event.stopPropagation();
    }, "click": function($event) {
      $event.stopPropagation();
      !item._disabled && _vm.toggleItem(item, $event);
    } } }) : _vm._e(), _vm.$scopedSlots["item-title." + (item.id || i + 1)] ? _vm._t("item-title." + (item.id || i + 1), null, { "item": _vm.getOriginalItem(item), "expanded": item._expanded, "index": i + 1 }) : _vm._t("item-title", function() {
      return [_c("div", { staticClass: "grow", domProps: { "innerHTML": _vm._s(item[_vm.itemTitleKey]) } })];
    }, { "item": _vm.getOriginalItem(item), "expanded": item._expanded, "index": i + 1 }), _vm.expandIcon && _vm.expandIconRight ? _c("w-button", { staticClass: "w-accordion__expand-icon", class: { "w-accordion__expand-icon--expanded": item._expanded, "w-accordion__expand-icon--rotate90": _vm.expandIconRotate90 }, attrs: { "icon": item._expanded && _vm.collapseIcon || _vm.expandIcon, "text": "" }, on: { "keypress": function($event) {
      $event.stopPropagation();
    }, "click": function($event) {
      $event.stopPropagation();
      !item._disabled && _vm.toggleItem(item, $event);
    } } }) : _vm._e()], 2), _c("w-transition-expand", { attrs: { "y": "", "duration": _vm.duration }, on: { "after-leave": function($event) {
      return _vm.onEndOfCollapse(item);
    } } }, [item._expanded ? _c("div", { staticClass: "w-accordion__item-content", class: _vm.contentClass }, [_vm.$scopedSlots["item-content." + (item.id || i + 1)] ? _vm._t("item-content." + (item.id || i + 1), null, { "item": _vm.getOriginalItem(item), "expanded": item._expanded, "index": i + 1 }) : _vm._t("item-content", function() {
      return [_c("div", { domProps: { "innerHTML": _vm._s(item[_vm.itemContentKey]) } })];
    }, { "item": _vm.getOriginalItem(item), "expanded": item._expanded, "index": i + 1 })], 2) : _vm._e()])], 1);
  }), 0);
};
var staticRenderFns$T = [];
var wAccordion_vue_vue_type_style_index_0_lang = "";
function normalizeComponent(scriptExports, render2, staticRenderFns2, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render2) {
    options.render = render2;
    options.staticRenderFns = staticRenderFns2;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function(context) {
      context = context || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(
        this,
        (options.functional ? this.parent : this).$root.$options.shadowRoot
      );
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}
const __vue2_script$T = {
  name: "w-accordion",
  props: {
    value: { type: Array },
    color: { type: String },
    bgColor: { type: String },
    items: { type: [Array, Number], required: true },
    itemColorKey: { type: String, default: "color" },
    itemTitleKey: { type: String, default: "title" },
    itemContentKey: { type: String, default: "content" },
    itemClass: { type: String },
    titleClass: { type: String },
    contentClass: { type: String },
    expandIcon: { type: [String, Boolean], default: "wi-triangle-down" },
    expandIconRight: { type: Boolean },
    expandIconRotate90: { type: Boolean },
    expandIconProps: { type: Object, default: () => ({}) },
    expandSingle: { type: Boolean },
    collapseIcon: { type: String },
    shadow: { type: Boolean },
    duration: { type: Number, default: 250 }
  },
  emits: ["input", "update:value", "focus", "item-expand", "item-collapsed"],
  data: () => ({
    accordionItems: []
  }),
  computed: {
    accordionClasses() {
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-accordion--shadow": this.shadow,
        "w-accordion--no-icon": !this.expandIcon && !this.collapseIcon,
        "w-accordion--icon-right": this.expandIcon && this.expandIconRight,
        "w-accordion--rotate-icon": this.expandIcon && !this.collapseIcon
      };
    }
  },
  methods: {
    toggleItem(item, e) {
      item._expanded = !item._expanded;
      if (this.expandSingle)
        this.accordionItems.forEach((obj) => obj._index !== item._index && (obj._expanded = false));
      const expandedItems = this.accordionItems.map((item2) => item2._expanded || false);
      this.$emit("update:value", expandedItems);
      this.$emit("input", expandedItems);
      this.$emit("item-expand", { item, expanded: item._expanded });
      e.target.blur();
      setTimeout(() => e.target.focus(), 300);
    },
    onEndOfCollapse(item) {
      this.$emit("item-collapsed", { item, expanded: item._expanded });
    },
    getOriginalItem(item) {
      return this.items[item._index];
    },
    itemClasses(item) {
      return {
        [this.itemClass]: this.itemClass || null,
        "w-accordion__item--expanded": item._expanded,
        "w-accordion__item--disabled": item._disabled,
        [item[this.itemColorKey]]: item[this.itemColorKey]
      };
    },
    updateItems() {
      const items = typeof this.items === "number" ? Array(this.items).fill({}) : this.items || [];
      this.$set(this, "accordionItems", items.map((item, _index) => ({
        ...item,
        _index,
        _expanded: this.value && this.value[_index],
        _disabled: !!item.disabled
      })));
    }
  },
  created() {
    this.updateItems();
  },
  watch: {
    value() {
      this.updateItems();
    },
    items: {
      handler() {
        this.updateItems();
      },
      deep: true
    }
  }
};
const __cssModules$T = {};
var __component__$T = /* @__PURE__ */ normalizeComponent(
  __vue2_script$T,
  render$T,
  staticRenderFns$T,
  false,
  __vue2_injectStyles$T,
  null,
  null,
  null
);
function __vue2_injectStyles$T(context) {
  for (let o in __cssModules$T) {
    this[o] = __cssModules$T[o];
  }
}
var wAccordion = /* @__PURE__ */ function() {
  return __component__$T.exports;
}();
var render$S = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.show ? _c("div", _vm._g({ staticClass: "w-alert", class: _vm.classes }, _vm.$listeners), [_vm.type || _vm.icon || _vm.dismiss ? [_vm.type || _vm.icon ? _c("w-icon", { staticClass: "w-alert__icon mr2" }, [_vm._v(_vm._s(_vm.type ? _vm.typeIcon : _vm.icon))]) : _vm._e(), _c("div", { staticClass: "w-alert__content" }, [_vm._t("default")], 2), _vm.dismiss ? _c("w-button", { staticClass: "w-alert__dismiss", attrs: { "icon": "wi-cross", "color": "inherit", "sm": "", "text": "" }, on: { "click": function($event) {
    _vm.$emit("update:modelValue", _vm.show = false);
    _vm.$emit("input", false);
    _vm.$emit("close", false);
  } } }) : _vm._e()] : _vm._t("default")], 2) : _vm._e();
};
var staticRenderFns$S = [];
var wAlert_vue_vue_type_style_index_0_lang = "";
const __vue2_script$S = {
  name: "w-alert",
  props: {
    value: { default: true },
    color: { type: String },
    bgColor: { type: String },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    icon: { type: String },
    iconOutside: { type: Boolean },
    plain: { type: Boolean },
    dismiss: { type: Boolean },
    success: { type: Boolean },
    info: { type: Boolean },
    warning: { type: Boolean },
    error: { type: Boolean },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    noBorder: { type: Boolean },
    borderLeft: { type: Boolean },
    borderRight: { type: Boolean },
    borderTop: { type: Boolean },
    borderBottom: { type: Boolean },
    outline: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "close"],
  data() {
    return {
      show: this.value
    };
  },
  computed: {
    typeIcon() {
      return this.type === "success" && "wi-check-circle" || this.type === "warning" && "wi-warning-circle" || this.type === "error" && "wi-cross-circle" || this.type === "info" && "wi-info-circle";
    },
    type() {
      return this.success && "success" || this.info && "info" || this.warning && "warning" || this.error && "error" || null;
    },
    presetSize() {
      return this.xs && "xs" || this.sm && "sm" || this.md && "md" || this.lg && "lg" || this.xl && "xl" || null;
    },
    hasSingleBorder() {
      return this.borderLeft || this.borderRight || this.borderTop || this.borderBottom;
    },
    classes() {
      return {
        [`${this.bgColor || this.plain && this.type}--bg w-alert--bg`]: this.bgColor || this.plain && this.type,
        [this.color || !this.plain && this.type]: this.color || !this.plain && this.type,
        [`size--${this.presetSize}`]: this.presetSize,
        [`w-alert--${this.type}`]: this.type,
        "w-alert--has-icon": this.type || this.icon || this.dismiss,
        "w-alert--icon-outside": this.iconOutside,
        "w-alert--plain": this.type && this.plain,
        "w-alert--outline": this.outline,
        "w-alert--tile": this.tile,
        "w-alert--round": this.round,
        "w-alert--no-border": this.noBorder || this.plain && this.type,
        "w-alert--one-border": this.hasSingleBorder || this.iconOutside,
        "w-alert--border-left": !this.noBorder && this.borderLeft || this.iconOutside,
        "w-alert--border-right": !this.noBorder && this.borderRight,
        "w-alert--border-top": !this.noBorder && this.borderTop,
        "w-alert--border-bottom": !this.noBorder && this.borderBottom,
        "w-alert--shadow": this.shadow
      };
    }
  },
  watch: {
    value(value) {
      this.show = value;
    }
  }
};
const __cssModules$S = {};
var __component__$S = /* @__PURE__ */ normalizeComponent(
  __vue2_script$S,
  render$S,
  staticRenderFns$S,
  false,
  __vue2_injectStyles$S,
  null,
  null,
  null
);
function __vue2_injectStyles$S(context) {
  for (let o in __cssModules$S) {
    this[o] = __cssModules$S[o];
  }
}
var wAlert = /* @__PURE__ */ function() {
  return __component__$S.exports;
}();
var render$R = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-autocomplete", class: _vm.classes, on: { "click": _vm.onClick } }, [_vm.selection.length ? _vm._l(_vm.selection, function(item, i) {
    return _c("div", { staticClass: "w-autocomplete__selection" }, [_vm._t("selection", function() {
      return [_c("span", { domProps: { "innerHTML": _vm._s(item[_vm.itemLabelKey]) } }), _c("w-button", { attrs: { "icon": "wi-cross", "xs": "", "text": "", "color": "currentColor" }, on: { "click": function($event) {
        $event.stopPropagation();
        return _vm.unselectItem(i);
      } } })];
    }, { "item": item, "unselect": function(i2) {
      return _vm.unselectItem(i2);
    } })], 2);
  }) : _vm._e(), !_vm.selection.length && !_vm.keywords && _vm.placeholder ? _c("div", { staticClass: "w-autocomplete__placeholder", domProps: { "innerHTML": _vm._s(_vm.placeholder) } }) : _vm._e(), _c("input", _vm._g({ ref: "input", staticClass: "w-autocomplete__input", domProps: { "value": _vm.keywords } }, _vm.inputEventListeners)), _c("w-transition-slide-fade", [_vm.menuOpen ? _c("ul", { ref: "menu", staticClass: "w-autocomplete__menu", on: { "mousedown": function($event) {
    _vm.menuIsBeingClicked = true;
  }, "mouseup": _vm.setEndOfMenuClick, "touchstart": function($event) {
    _vm.menuIsBeingClicked = true;
  }, "touchend": _vm.setEndOfMenuClick } }, [_vm._l(_vm.filteredItems, function(item, i) {
    return _c("li", { key: i, class: { highlighted: _vm.highlightedItem === item.uid }, on: { "click": function($event) {
      $event.stopPropagation();
      _vm.selectItem(item), _vm.$emit("item-click", item);
    } } }, [_vm._t("item", function() {
      return [_c("span", { domProps: { "innerHTML": _vm._s(item[_vm.itemLabelKey]) } })];
    }, { "item": item, "highlighted": _vm.highlightedItem === item.uid })], 2);
  }), !_vm.filteredItems.length ? _c("li", { staticClass: "w-autocomplete__no-match", class: { "w-autocomplete__no-match--default": !_vm.$slots.noMatch } }, [_vm._t("no-match", function() {
    return [_c("div", { staticClass: "caption", domProps: { "innerHTML": _vm._s(_vm.noMatch !== void 0 ? _vm.noMatch : "No match.") } })];
  })], 2) : _vm._e(), _vm.$slots["extra-item"] ? _c("li", { staticClass: "w-autocomplete__extra-item", class: { highlighted: _vm.highlightedItem === "extra-item" }, on: { "click": _vm.selectExtraItem } }, [_vm._t("extra-item")], 2) : _vm._e()], 2) : _vm._e()])], 2);
};
var staticRenderFns$R = [];
var wAutocomplete_vue_vue_type_style_index_0_lang = "";
const __vue2_script$R = {
  name: "w-autocomplete",
  props: {
    items: { type: Array, required: true },
    value: { type: [String, Number, Array] },
    placeholder: { type: String },
    openOnKeydown: { type: Boolean },
    multiple: { type: Boolean },
    allowDuplicates: { type: Boolean },
    noMatch: { type: String },
    itemValueKey: { type: String, default: "value" },
    itemLabelKey: { type: String, default: "label" },
    itemSearchableKey: { type: String, default: "searchable" }
  },
  emits: ["update:modelValue", "input", "focus", "blur", "keydown", "item-click", "item-select", "extra-item-select"],
  data: () => ({
    keywords: "",
    selection: [],
    menuOpen: false,
    highlightedItem: null,
    menuIsBeingClicked: false
  }),
  computed: {
    normalizedKeywords() {
      return this.normalize(this.keywords);
    },
    normalizedSelection() {
      return this.selection.map((item) => this.normalize(item == null ? void 0 : item.searchable));
    },
    optimizedItemsForSearch() {
      return this.items.map((item, i) => ({
        ...item,
        uid: i,
        searchable: this.normalize(item[this.itemSearchableKey] || "")
      }));
    },
    filteredItems() {
      let items = this.optimizedItemsForSearch;
      const selection = this.normalizedSelection.join(",");
      const isItemNotSelected = (item) => !selection.includes(item.searchable);
      if (this.keywords) {
        items = items.filter((item) => {
          if (!item.searchable.includes(this.normalizedKeywords))
            return false;
          else if (this.multiple && !this.allowDuplicates)
            return isItemNotSelected(item);
          else
            return true;
        });
      } else if (this.multiple && !this.allowDuplicates)
        items = items.filter(isItemNotSelected);
      return items;
    },
    highlightedItemIndex() {
      if (this.highlightedItem === null)
        return -1;
      else if (this.highlightedItem === "extra-item")
        return this.filteredItems.length;
      return this.filteredItems.findIndex((item) => item.uid === this.highlightedItem);
    },
    inputEventListeners() {
      return {
        ...this.$attrs,
        input: (e) => {
          this.keywords = e.target.value;
        },
        focus: (e) => {
          if (this.menuIsBeingClicked)
            return;
          this.onFocus(e);
          this.$emit("focus", e);
        },
        blur: (e) => {
          if (!this.menuIsBeingClicked)
            this.$emit("blur", e);
        },
        keydown: (e) => {
          this.onKeydown(e);
          this.$emit("keydown", e);
        },
        drop: this.onDrop,
        compositionstart: this.onCompositionStart,
        compositionupdate: this.onCompositionUpdate
      };
    },
    classes() {
      return {
        "w-autocomplete--open": this.menuOpen,
        "w-autocomplete--filled": this.selection.length,
        "w-autocomplete--has-keywords": this.keywords,
        "w-autocomplete--empty": !this.selection.length && !this.keywords
      };
    }
  },
  methods: {
    normalize(string) {
      return string.toLowerCase().normalize("NFKD").replace(/\p{Diacritic}/gu, "").replace(/œ/g, "oe");
    },
    selectItem(item) {
      if (!this.multiple)
        this.selection = [];
      this.selection.push(item);
      this.highlightedItem = item.uid;
      this.keywords = "";
      const emitPayload = this.multiple ? this.selection.map((item2) => item2[this.itemValueKey]) : item[this.itemValueKey];
      this.$emit("item-select", item);
      this.$emit("update:modelValue", emitPayload);
      this.$emit("input", emitPayload);
      this.$refs.input.focus();
      if (!this.multiple)
        this.closeMenu();
    },
    unselectItem(i) {
      this.selection.splice(i != null ? i : this.selection.length - 1, 1);
      this.highlightedItem = null;
      this.$emit("update:modelValue", null);
      this.$emit("input", null);
      this.$refs.input.focus();
    },
    selectExtraItem() {
      this.keywords = "";
      this.$emit("extra-item-select");
      this.closeMenu();
    },
    setEndOfMenuClick() {
      setTimeout(() => this.menuIsBeingClicked = false, 100);
    },
    onClick() {
      if (!this.openOnKeydown)
        this.openMenu();
      this.$refs.input.focus();
    },
    onFocus() {
      if (!this.openOnKeydown)
        this.openMenu();
    },
    onKeydown(e) {
      var _a;
      const itemsCount = this.filteredItems.length + (this.$slots["extra-item"] ? 1 : 0);
      if (!this.openOnKeydown || (this.keywords || e.key.length === 1) && !this.menuOpen)
        this.openMenu();
      if (e.keyCode === 9)
        this.closeMenu();
      else if (e.keyCode === 8 && (!this.keywords || !e.target.selectionStart && !e.target.selectionEnd)) {
        this.unselectItem();
      } else if (e.keyCode === 13) {
        e.preventDefault();
        if (this.highlightedItem === "extra-item")
          this.selectExtraItem();
        else if (this.highlightedItemIndex >= 0)
          this.selectItem(this.filteredItems[this.highlightedItemIndex]);
      } else if ([38, 40].includes(e.keyCode)) {
        e.preventDefault();
        let index2 = this.highlightedItemIndex;
        if (index2 === -1)
          index2 = e.keyCode === 38 ? itemsCount - 1 : 0;
        else
          index2 = (index2 + (e.keyCode === 38 ? -1 : 1) + itemsCount) % itemsCount;
        if (this.$slots["extra-item"] && index2 === itemsCount - 1)
          this.highlightedItem = "extra-item";
        else
          this.highlightedItem = ((_a = this.filteredItems[index2]) == null ? void 0 : _a.uid) || 0;
        const menuEl = this.$refs.menu;
        if (menuEl) {
          if (this.$slots["extra-item"] && index2 === itemsCount - 1)
            menuEl.scrollTop = menuEl.scrollHeight;
          else {
            const { offsetHeight: itemElHeight, offsetTop: itemElTop } = menuEl.childNodes[index2] || {};
            if (menuEl.scrollTop + menuEl.offsetHeight - itemElHeight < itemElTop) {
              menuEl.scrollTop = itemElTop - menuEl.offsetHeight + itemElHeight;
            } else if (menuEl.scrollTop > itemElTop)
              menuEl.scrollTop = itemElTop;
          }
        }
      } else if (!this.multiple && this.selection.length && e.key.length === 1)
        e.preventDefault();
    },
    onDrop(e) {
      if (!this.multiple && this.selection.length)
        e.preventDefault();
    },
    onCompositionStart(e) {
      if (!this.multiple && this.selection.length)
        e.target.setAttribute("readonly", true);
    },
    onCompositionUpdate(e) {
      if (!this.multiple && this.selection.length)
        setTimeout(() => e.target.removeAttribute("readonly"), 200);
    },
    openMenu() {
      if (this.menuOpen)
        return;
      this.menuOpen = true;
      document.addEventListener("click", this.onDocumentClick);
    },
    closeMenu() {
      this.menuOpen = false;
      document.removeEventListener("click", this.onDocumentClick);
    },
    onDocumentClick(e) {
      if (!this.$el.contains(e.target) && !this.$el.isSameNode(e.target))
        this.closeMenu();
    }
  },
  created() {
    if (this.value) {
      const arrayOfValues = Array.isArray(this.value) ? this.value : [this.value];
      arrayOfValues.forEach((value) => {
        this.selection.push(this.optimizedItemsForSearch.find((item) => item[this.itemValueKey] === +value));
      });
    }
  },
  beforeDestroy() {
    document.removeEventListener("click", this.onDocumentClick);
  },
  watch: {
    value(value) {
      this.selection = [];
      if (value) {
        const arrayOfValues = Array.isArray(value) ? value : [value];
        arrayOfValues.forEach((value2) => {
          this.selection.push(this.optimizedItemsForSearch.find((item) => item[this.itemValueKey] === +value2));
        });
      }
    }
  }
};
const __cssModules$R = {};
var __component__$R = /* @__PURE__ */ normalizeComponent(
  __vue2_script$R,
  render$R,
  staticRenderFns$R,
  false,
  __vue2_injectStyles$R,
  null,
  null,
  null
);
function __vue2_injectStyles$R(context) {
  for (let o in __cssModules$R) {
    this[o] = __cssModules$R[o];
  }
}
var wAutocomplete = /* @__PURE__ */ function() {
  return __component__$R.exports;
}();
var render$Q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition-group", { staticClass: "w-notification-manager", class: { "w-notification-manager--left": _vm.conf.align === "left" }, attrs: { "tag": "div", "name": _vm.transition, "appear": "" } }, [_vm._l(_vm.notifications, function(notif) {
    return [notif._value ? _c("w-alert", _vm._b({ key: notif._uid, staticClass: "white--bg", on: { "close": function($event) {
      return _vm.$waveui._notificationManager.dismiss(notif._uid);
    } }, model: { value: notif._value, callback: function($$v) {
      _vm.$set(notif, "_value", $$v);
    }, expression: "notif._value" } }, "w-alert", _vm.notifProps(notif), false), [_c("div", { domProps: { "innerHTML": _vm._s(notif.message) } })]) : _vm._e()];
  })], 2);
};
var staticRenderFns$Q = [];
var wNotificationManager_vue_vue_type_style_index_0_lang = "";
const __vue2_script$Q = {
  name: "w-notification-manager",
  computed: {
    conf() {
      return this.$waveui.config.notificationManager;
    },
    notifications() {
      return this.$waveui._notificationManager.notifications || [];
    },
    transition() {
      return this.conf.transition ? this.conf.transition.replace("default", `slide-${this.conf.align === "left" ? "right" : "left"}`) : "";
    }
  },
  methods: {
    notifProps(notif) {
      const { _value, _uid: _uid2, message, timeout, ...props } = notif;
      return props;
    }
  }
};
const __cssModules$Q = {};
var __component__$Q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$Q,
  render$Q,
  staticRenderFns$Q,
  false,
  __vue2_injectStyles$Q,
  null,
  null,
  null
);
function __vue2_injectStyles$Q(context) {
  for (let o in __cssModules$Q) {
    this[o] = __cssModules$Q[o];
  }
}
var NotificationManager = /* @__PURE__ */ function() {
  return __component__$Q.exports;
}();
const cssVars = {
  cssScope: ".w-app",
  baseIncrement: 4
};
const generateColors = (config2) => {
  let styles = "";
  const cssVariables = {};
  const { cssScope } = cssVars;
  const { info, warning, success, error, ...colors } = config2.colors;
  for (const colorName in colors) {
    styles += `${cssScope} .${colorName}--bg{background-color:${config2.colors[colorName]}}${cssScope} .${colorName}{color:${config2.colors[colorName]}}`;
  }
  if (config2.css.colorShades && config2.shades) {
    Object.entries(config2.shades).forEach(([label, color]) => {
      styles += `${cssScope} .${label}--bg{background-color:${color}}${cssScope} .${label}{color:${color}}`;
    });
  }
  const statusColors = { info, warning, success, error };
  for (const color in statusColors) {
    styles += `${cssScope} .${color}--bg{background-color:${config2.colors[color]}}${cssScope} .${color}{color:${config2.colors[color]}}`;
  }
  const allColors = { ...colors, info, warning, success, error };
  for (const colorName in allColors)
    cssVariables[colorName] = allColors[colorName];
  let cssVariablesString = "";
  Object.entries(cssVariables).forEach(([colorName, colorHex]) => {
    cssVariablesString += `--w-${colorName}-color: ${colorHex};`;
  });
  return `:root{${cssVariablesString}}${styles}`;
};
const generateBreakpoints = (breakpoints, grid) => {
  let styles = "";
  const { cssScope } = cssVars;
  breakpoints.forEach(({ min, label }) => {
    if (label === "xs") {
      for (let i = 0; i < grid; i++) {
        styles += `${cssScope} .${label}${grid - i}{width:${parseFloat(((grid - i) * 100 / grid).toFixed(4))}%;}`;
      }
    } else {
      styles += `@media(min-width:${min}px){`;
      for (let i = 0; i < grid; i++) {
        styles += `${cssScope} .${label}${grid - i}{width:${parseFloat(((grid - i) * 100 / grid).toFixed(4))}%;}`;
      }
      styles += "}";
    }
  });
  return styles;
};
const genBreakpointLayoutClasses = (breakpoints) => {
  let styles = "";
  const { cssScope, baseIncrement } = cssVars;
  const layoutClasses = [
    "show{display:block}",
    "hide{display:none}",
    "d-flex{display:flex}",
    "d-iflex{display:inline-flex}",
    "d-block{display:block}",
    "d-iblock{display:inline-block}",
    "text-left{text-align:left}",
    "text-center{text-align:center}",
    "text-right{text-align:right}",
    "text-nowrap{white-space:nowrap}",
    "row{flex-direction:row}",
    "column{flex-direction:column}",
    "column-reverse{flex-direction:column-reverse}",
    "grow{flex-grow:1;flex-basis:auto}",
    "no-grow{flex-grow:0}",
    "shrink{flex-shrink:1;margin-left:auto;margin-right:auto}",
    "no-shrink{flex-shrink:0}",
    "fill-width{width:100%}",
    "fill-height{height:100%}",
    "basis-zero{flex-basis:0}",
    "align-start{align-items:flex-start}",
    "align-center{align-items:center}",
    "align-end{align-items:flex-end}",
    "align-self-start{align-self:flex-start}",
    "align-self-center{align-self:center}",
    "align-self-end{align-self:flex-end}",
    "align-self-stretch{align-self:stretch}",
    "justify-start{justify-content:flex-start}",
    "justify-center{justify-content:center}",
    "justify-end{justify-content:flex-end}",
    "justify-space-between{justify-content:space-between}",
    "justify-space-around{justify-content:space-around}",
    "justify-space-evenly{justify-content:space-evenly}"
  ];
  const array12 = Array(12).fill();
  breakpoints.forEach(({ label, min }) => {
    if (label !== "xs") {
      styles += `@media(min-width:${min}px){` + layoutClasses.map((rule) => `${cssScope} .${label}u-${rule}`).join("") + array12.map((item, i) => `.w-grid.${label}u-columns${i + 1}{grid-template-columns:repeat(${i + 1},1fr);}`).join("") + array12.map((item, i) => `.w-flex.${label}u-gap${i + 1},.w-grid.${label}u-gap${i + 1}{gap:${(i + 1) * baseIncrement}px;}`).join("") + `.w-flex.${label}u-gap0,.w-flex.${label}u-gap0{gap:0}}`;
    }
  });
  breakpoints.forEach(({ label, min, max }) => {
    styles += `@media (min-width:${min}px) and (max-width:${max}px){` + layoutClasses.map((rule) => `${cssScope} .${label}-${rule}`).join("") + array12.map((item, i) => `.w-grid.${label}-columns${i + 1}{grid-template-columns:repeat(${i + 1},1fr);}`).join("") + array12.map((item, i) => `.w-flex.${label}-gap${i + 1},.w-grid.${label}-gap${i + 1}{gap:${(i + 1) * baseIncrement}px;}`).join("") + `.w-flex.${label}-gap0,.w-flex.${label}-gap0{gap:0}}`;
  });
  breakpoints.forEach(({ label, max }) => {
    if (label !== "xl") {
      styles += `@media (max-width:${max}px){` + layoutClasses.map((rule) => `${cssScope} .${label}d-${rule}`).join("") + array12.map((item, i) => `.w-grid.${label}d-columns${i + 1}{grid-template-columns:repeat(${i + 1},1fr);}`).join("") + array12.map((item, i) => `.w-flex.${label}d-gap${i + 1},.w-grid.${label}d-gap${i + 1}{gap:${(i + 1) * baseIncrement}px;}`).join("") + `.w-flex.${label}d-gap0,.w-flex.${label}d-gap0{gap:0}}`;
    }
  });
  return styles;
};
var dynamicCSS = (config2) => {
  const entries = Object.entries(config2.breakpoints);
  const breakpointsDef2 = entries.map(([label, max], i) => {
    const [, value = 0] = entries[i - 1] || [];
    return { label, min: value ? value + 1 : 0, max };
  });
  const computedStyles = getComputedStyle(document.documentElement);
  cssVars.cssScope = computedStyles.getPropertyValue("--css-scope");
  cssVars.baseIncrement = parseInt(computedStyles.getPropertyValue("--base-increment"));
  let styles = "";
  styles += generateColors(config2);
  styles += generateBreakpoints(breakpointsDef2, config2.css.grid);
  if (config2.css.breakpointLayoutClasses)
    styles += genBreakpointLayoutClasses(breakpointsDef2);
  return styles;
};
var render$P = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-app", class: _vm.classes }, [_vm._t("default"), _c("notification-manager")], 2);
};
var staticRenderFns$P = [];
var wApp_vue_vue_type_style_index_0_lang = "";
let breakpointsDef = { keys: [], values: [] };
const __vue2_script$P = {
  name: "w-app",
  props: {
    dark: { type: Boolean },
    block: { type: Boolean },
    row: { type: Boolean },
    alignCenter: { type: Boolean },
    alignEnd: { type: Boolean },
    justifyCenter: { type: Boolean },
    justifyEnd: { type: Boolean },
    justifySpaceBetween: { type: Boolean },
    justifySpaceAround: { type: Boolean },
    justifySpaceEvenly: { type: Boolean },
    textCenter: { type: Boolean },
    textRight: { type: Boolean }
  },
  components: { NotificationManager },
  data: () => ({
    currentBreakpoint: null,
    notifManager: null
  }),
  computed: {
    classes() {
      return {
        "d-block": this.block,
        row: this.row,
        "align-center": this.alignCenter,
        "align-end": this.alignEnd,
        "justify-center": this.justifyCenter,
        "justify-end": this.justifyEnd,
        "justify-space-between": this.justifySpaceBetween,
        "justify-space-around": this.justifySpaceAround,
        "justify-space-evenly": this.justifySpaceEvenly,
        "text-center": this.textCenter,
        "text-right": this.textRight,
        "theme--dark": this.dark
      };
    }
  },
  methods: {
    getBreakpoint() {
      const width = window.innerWidth;
      const breakpoints = breakpointsDef.values.slice(0);
      breakpoints.push(width);
      breakpoints.sort((a, b) => a - b);
      const breakpoint = breakpointsDef.keys[breakpoints.indexOf(width)] || "xl";
      if (breakpoint !== this.currentBreakpoint) {
        this.currentBreakpoint = breakpoint;
        this.$waveui.breakpoint = {
          name: breakpoint,
          xs: breakpoint === "xs",
          sm: breakpoint === "sm",
          md: breakpoint === "md",
          lg: breakpoint === "lg",
          xl: breakpoint === "xl",
          width
        };
      }
      this.$waveui.breakpoint.width = width;
    }
  },
  mounted() {
    const { config: config2 } = this.$waveui;
    breakpointsDef = { keys: Object.keys(config2.breakpoints), values: Object.values(config2.breakpoints) };
    if (!document.getElementById("wave-ui-styles")) {
      const css = document.createElement("style");
      css.id = "wave-ui-styles";
      css.innerHTML = dynamicCSS(config2);
      const firstStyle = document.head.querySelectorAll('style,link[rel="stylesheet"]')[0];
      if (firstStyle)
        firstStyle.before(css);
      else
        document.head.appendChild(css);
    }
    this.getBreakpoint(window.innerWidth);
    window.addEventListener("resize", this.getBreakpoint);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getBreakpoint);
  }
};
const __cssModules$P = {};
var __component__$P = /* @__PURE__ */ normalizeComponent(
  __vue2_script$P,
  render$P,
  staticRenderFns$P,
  false,
  __vue2_injectStyles$P,
  null,
  null,
  null
);
function __vue2_injectStyles$P(context) {
  for (let o in __cssModules$P) {
    this[o] = __cssModules$P[o];
  }
}
var wApp = /* @__PURE__ */ function() {
  return __component__$P.exports;
}();
var render$O = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._g({ staticClass: "w-badge-wrap" }, _vm.$listeners), [_vm._t("default"), _c("transition", { attrs: { "name": "" + _vm.transition } }, [_vm.value ? _c("div", { staticClass: "w-badge", class: _vm.classes, style: _vm.styles, attrs: { "aria-atomic": "true", "aria-label": "Badge", "aria-live": "polite", "role": "status" } }, [!_vm.dot ? _vm._t("badge", function() {
    return [_vm._v(_vm._s(_vm.value === true ? "" : _vm.value || ""))];
  }) : _vm._e()], 2) : _vm._e()])], 2);
};
var staticRenderFns$O = [];
var wBadge_vue_vue_type_style_index_0_lang = "";
const __vue2_script$O = {
  name: "w-badge",
  props: {
    value: { default: true },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    top: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    bottom: { type: Boolean },
    overlap: { type: Boolean },
    inline: { type: Boolean },
    color: { type: String },
    size: { type: [Number, String] },
    bgColor: { type: String, default: "primary" },
    dark: { type: Boolean },
    badgeClass: { type: String },
    outline: { type: Boolean },
    shadow: { type: Boolean },
    dot: { type: Boolean },
    round: { type: Boolean },
    transition: { type: String, default: "fade" }
  },
  emits: [],
  computed: {
    forcedSize() {
      return this.size && (!isNaN(this.size) ? `${this.size}px` : this.size);
    },
    presetSize() {
      return this.xs && "xs" || this.sm && "sm" || this.md && "md" || this.lg && "lg" || this.xl && "xl" || "md";
    },
    position() {
      return [
        this.top && "top" || this.bottom && "bottom" || "top",
        this.left && "left" || this.right && "right" || "right"
      ];
    },
    classes() {
      const slotText = this.$slots.badge && this.$slots.badge.map((item) => item.text).join("");
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        [this.badgeClass]: this.badgeClass || null,
        "w-badge--round": this.round || (slotText || this.value + "" || "").length < 2,
        "w-badge--dark": this.dark && !this.outline,
        "w-badge--outline": this.outline,
        "w-badge--inline": this.inline,
        "w-badge--shadow": this.shadow,
        "w-badge--overlap": this.overlap,
        "w-badge--dot": this.dot,
        [`size--${this.presetSize}`]: this.presetSize && !this.forcedSize,
        [`w-badge--${this.position.join(" w-badge--")}`]: true
      };
    },
    styles() {
      return this.forcedSize && `font-size: ${this.forcedSize}`;
    }
  }
};
const __cssModules$O = {};
var __component__$O = /* @__PURE__ */ normalizeComponent(
  __vue2_script$O,
  render$O,
  staticRenderFns$O,
  false,
  __vue2_injectStyles$O,
  null,
  null,
  null
);
function __vue2_injectStyles$O(context) {
  for (let o in __cssModules$O) {
    this[o] = __cssModules$O[o];
  }
}
var wBadge = /* @__PURE__ */ function() {
  return __component__$O.exports;
}();
var render$N = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-breadcrumbs", class: _vm.classes }, [_vm._l(_vm.items, function(item, i) {
    return [i && _vm.$scopedSlots.separator ? _c("span", { key: i + "a", staticClass: "w-breadcrumbs__separator", class: _vm.separatorColor }, [_vm._t("separator", null, { "index": i })], 2) : i ? _c("w-icon", { key: i + "b", staticClass: "w-breadcrumbs__separator", class: _vm.separatorColor }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), item[_vm.itemRouteKey] && (i < _vm.items.length - 1 || _vm.linkLastItem) ? [_vm.$scopedSlots.item ? _c(_vm.hasRouter ? "router-link" : "a", { key: i + "c", tag: "component", staticClass: "w-breadcrumbs__item", class: _vm.color || null, attrs: { "to": _vm.hasRouter && item[_vm.itemRouteKey], "href": item[_vm.itemRouteKey] } }, [_vm._t("item", null, { "item": item, "index": i + 1, "isLast": i === _vm.items.length - 1 })], 2) : _c(_vm.hasRouter ? "router-link" : "a", { key: i + "d", tag: "component", staticClass: "w-breadcrumbs__item", class: _vm.color || null, attrs: { "to": _vm.hasRouter && item[_vm.itemRouteKey], "href": item[_vm.itemRouteKey] }, domProps: { "innerHTML": _vm._s(item[_vm.itemLabelKey]) } })] : _vm.$scopedSlots.item ? _vm._t("item", null, { "item": item, "index": i + 1, "isLast": i === _vm.items.length - 1 }) : _c("span", { key: i + "f", domProps: { "innerHTML": _vm._s(item[_vm.itemLabelKey]) } })];
  })], 2);
};
var staticRenderFns$N = [];
var wBreadcrumbs_vue_vue_type_style_index_0_lang = "";
const __vue2_script$N = {
  name: "w-breadcrumbs",
  props: {
    items: { type: Array, required: true },
    linkLastItem: { type: Boolean },
    color: { type: String },
    separatorColor: { type: String, default: "grey-light1" },
    icon: { type: String, default: "wi-chevron-right" },
    itemRouteKey: { type: String, default: "route" },
    itemLabelKey: { type: String, default: "label" },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean }
  },
  emits: [],
  computed: {
    hasRouter() {
      return "$router" in this;
    },
    size() {
      return this.xs && "xs" || this.sm && "sm" || this.lg && "lg" || this.xl && "xl" || "md";
    },
    classes() {
      return {
        [`size--${this.size}`]: true
      };
    }
  }
};
const __cssModules$N = {};
var __component__$N = /* @__PURE__ */ normalizeComponent(
  __vue2_script$N,
  render$N,
  staticRenderFns$N,
  false,
  __vue2_injectStyles$N,
  null,
  null,
  null
);
function __vue2_injectStyles$N(context) {
  for (let o in __cssModules$N) {
    this[o] = __cssModules$N[o];
  }
}
var wBreadcrumbs = /* @__PURE__ */ function() {
  return __component__$N.exports;
}();
var render$M = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.route ? "a" : "button", _vm._g({ tag: "component", staticClass: "w-button", class: _vm.classes, style: _vm.styles, attrs: { "type": !_vm.route && _vm.type, "href": _vm.route && (_vm.externalLink ? _vm.route : _vm.resolvedRoute) || null, "disabled": !!_vm.disabled || null } }, _vm.listeners), [_vm.icon ? _c("w-icon", _vm._b({}, "w-icon", _vm.iconProps || {}, false), [_vm._v(_vm._s(_vm.icon))]) : _vm._t("default"), _c("transition", { attrs: { "name": "scale-fade" } }, [_vm.loading ? _c("div", { staticClass: "w-button__loader" }, [_vm._t("loading", function() {
    return [_c("svg", { attrs: { "viewBox": "0 0 40 40" } }, [_c("circle", { attrs: { "cx": "20", "cy": "20", "r": "18", "fill": "transparent", "stroke": "currentColor", "stroke-width": "4", "stroke-linecap": "round" } })])];
  })], 2) : _vm._e()])], 2);
};
var staticRenderFns$M = [];
var button_vue_vue_type_style_index_0_lang = "";
const __vue2_script$M = {
  props: {
    color: { type: String },
    bgColor: { type: String },
    dark: { type: Boolean },
    outline: { type: Boolean },
    text: { type: Boolean },
    round: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    route: { type: [String, Object] },
    forceLink: { type: Boolean },
    type: { type: String, default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { type: String, default: null },
    iconProps: { type: Object, default: () => ({}) },
    absolute: { type: Boolean },
    fixed: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    zIndex: { type: [Number, String] },
    width: { type: [Number, String] },
    height: { type: [Number, String] },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean }
  },
  emits: [],
  computed: {
    hasRouter() {
      return "$router" in this;
    },
    resolvedRoute() {
      return this.hasRouter ? this.$router.resolve(this.route).href : this.route;
    },
    listeners() {
      return this.route && this.hasRouter && !this.forceLink && !this.externalLink ? {
        ...this.$listeners,
        click: (e) => {
          if (this.$listeners.click)
            this.$listeners.click(e);
          this.$router.push(this.route);
          e.stopPropagation();
          e.preventDefault();
        }
      } : this.$listeners;
    },
    size() {
      return this.xs && "xs" || this.sm && "sm" || this.lg && "lg" || this.xl && "xl" || "md";
    },
    position() {
      return [
        this.top && "top" || this.bottom && "bottom" || "top",
        this.left && "left" || this.right && "right" || "right"
      ];
    },
    externalLink() {
      return /^(https?:)?\/\/|mailto:|tel:/.test(this.route);
    },
    classes() {
      return {
        "primary--bg": !this.bgColor && !this.color && !this.dark && !(this.outline || this.text),
        primary: !this.bgColor && !this.color && !this.dark && (this.outline || this.text),
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-button--dark": this.dark && !this.outline,
        "w-button--outline": this.outline,
        "w-button--text": this.text,
        "w-button--round": this.round,
        "w-button--tile": this.tile,
        "w-button--shadow": this.shadow,
        "w-button--loading": this.loading,
        "w-button--icon": this.icon,
        [`size--${this.size}`]: true,
        "w-button--absolute": this.absolute,
        "w-button--fixed": this.fixed,
        [`w-button--${this.position.join(" w-button--")}`]: this.absolute || this.fixed
      };
    },
    styles() {
      return {
        width: (!isNaN(this.width) ? `${this.width}px` : this.width) || null,
        height: (!isNaN(this.height) ? `${this.height}px` : this.height) || null,
        zIndex: this.zIndex || this.zIndex === 0 || null
      };
    }
  }
};
const __cssModules$M = {};
var __component__$M = /* @__PURE__ */ normalizeComponent(
  __vue2_script$M,
  render$M,
  staticRenderFns$M,
  false,
  __vue2_injectStyles$M,
  null,
  null,
  null
);
function __vue2_injectStyles$M(context) {
  for (let o in __cssModules$M) {
    this[o] = __cssModules$M[o];
  }
}
var ButtonPartial = /* @__PURE__ */ function() {
  return __component__$M.exports;
}();
var render$L = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.tooltip ? _c("w-tooltip", _vm._b({ tag: "component", scopedSlots: _vm._u([{ key: "activator", fn: function(ref) {
    var on = ref.on;
    return [_c("button-partial", _vm._g(_vm._b({}, "button-partial", _vm.buttonProps, false), Object.assign({}, _vm.$listeners, on)), [_vm._t("default")], 2)];
  } }], null, true) }, "component", _vm.tooltipProps || {}, false), [_c("div", { domProps: { "innerHTML": _vm._s(_vm.tooltip) } })]) : _c("button-partial", _vm._g(_vm._b({ scopedSlots: _vm._u([{ key: "loading", fn: function() {
    return [_vm._t("loading")];
  }, proxy: true }], null, true) }, "button-partial", _vm.buttonProps, false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns$L = [];
const __vue2_script$L = {
  name: "w-button",
  inheritAttrs: false,
  props: {
    color: { type: String },
    bgColor: { type: String },
    dark: { type: Boolean },
    outline: { type: Boolean },
    text: { type: Boolean },
    round: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    tooltip: { type: String },
    tooltipProps: { type: Object, default: () => ({}) },
    route: { type: [String, Object] },
    forceLink: { type: Boolean },
    type: { type: String, default: "button" },
    disabled: { type: Boolean },
    loading: { type: Boolean },
    icon: { type: String, default: null },
    iconProps: { type: Object, default: () => ({}) },
    absolute: { type: Boolean },
    fixed: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    zIndex: { type: [Number, String] },
    width: { type: [Number, String] },
    height: { type: [Number, String] },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean }
  },
  components: { ButtonPartial },
  emits: [],
  computed: {
    buttonProps() {
      const { tooltip, tooltipProps, ...props } = this.$props;
      return {
        ...props,
        ...this.$attrs,
        class: this.tooltip && [this.$vnode.data.staticClass, this.$vnode.data.class]
      };
    }
  }
};
const __cssModules$L = {};
var __component__$L = /* @__PURE__ */ normalizeComponent(
  __vue2_script$L,
  render$L,
  staticRenderFns$L,
  false,
  __vue2_injectStyles$L,
  null,
  null,
  null
);
function __vue2_injectStyles$L(context) {
  for (let o in __cssModules$L) {
    this[o] = __cssModules$L[o];
  }
}
var index$1 = /* @__PURE__ */ function() {
  return __component__$L.exports;
}();
const objectifyClasses = (classes = {}) => {
  if (typeof classes === "string")
    classes = { [classes]: true };
  else if (Array.isArray(classes))
    classes = { [classes.join(" ")]: true };
  return classes;
};
var render$K = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-card", class: _vm.classes }, [_vm.$slots.title ? _c("div", { staticClass: "w-card__title", class: Object.assign({}, { "w-card__title--has-toolbar": _vm.$slots.title && _vm.titleHasToolbar }, _vm.titleClasses) }, [_vm._t("title")], 2) : _vm.title ? _c("div", { staticClass: "w-card__title", class: Object.assign({}, { "w-card__title--has-toolbar": _vm.title && _vm.titleHasToolbar }, _vm.titleClasses), domProps: { "innerHTML": _vm._s(_vm.title) } }) : _vm._e(), _vm.image ? _c("w-image", _vm._b({ staticClass: "w-card__image", attrs: { "src": _vm.image } }, "w-image", _vm.imgProps, false), [_vm._t("image-content")], 2) : _vm._e(), _c("div", { staticClass: "w-card__content", class: _vm.contentClasses }, [_vm._t("default")], 2), _vm.$slots.actions ? _c("div", { staticClass: "w-card__actions", class: { "w-card__actions--has-toolbar": _vm.actionsHasToolbar } }, [_vm._t("actions")], 2) : _vm._e()], 1);
};
var staticRenderFns$K = [];
var wCard_vue_vue_type_style_index_0_lang = "";
const __vue2_script$K = {
  name: "w-card",
  props: {
    color: { type: String },
    bgColor: { type: String },
    shadow: { type: Boolean },
    noBorder: { type: Boolean },
    tile: { type: Boolean },
    title: { type: String },
    image: { type: String },
    imageProps: { type: Object },
    titleClass: { type: [String, Object, Array] },
    contentClass: { type: [String, Object, Array] }
  },
  emits: [],
  computed: {
    titleClasses() {
      return objectifyClasses(this.titleClass);
    },
    contentClasses() {
      return objectifyClasses(this.contentClass);
    },
    titleHasToolbar() {
      const { title } = this.$slots;
      return title && title.map((vnode) => vnode.tag).join("").includes("w-toolbar");
    },
    actionsHasToolbar() {
      const { actions } = this.$slots;
      return actions && actions.map((vnode) => vnode.tag).join("").includes("w-toolbar");
    },
    imgProps() {
      return {
        tag: "div",
        ratio: 1 / 2,
        ...this.imageProps
      };
    },
    classes() {
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-card--no-border": this.noBorder,
        "w-card--tile": this.tile,
        "w-card--shadow": this.shadow
      };
    }
  }
};
const __cssModules$K = {};
var __component__$K = /* @__PURE__ */ normalizeComponent(
  __vue2_script$K,
  render$K,
  staticRenderFns$K,
  false,
  __vue2_injectStyles$K,
  null,
  null,
  null
);
function __vue2_injectStyles$K(context) {
  for (let o in __cssModules$K) {
    this[o] = __cssModules$K[o];
  }
}
var wCard = /* @__PURE__ */ function() {
  return __component__$K.exports;
}();
var FormElementMixin = {
  inject: {
    formRegister: { default: null },
    formProps: { default: () => ({ disabled: false, readonly: false }) }
  },
  props: {
    name: { type: String },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    required: { type: Boolean },
    tabindex: { type: String },
    validators: { type: Array }
  },
  data: () => ({
    valid: null
  }),
  computed: {
    inputName() {
      return this.name || `${this.$options.name}--${this._uid}`;
    },
    isDisabled() {
      return this.disabled || this.formProps.disabled;
    },
    isReadonly() {
      return this.readonly || this.formProps.readonly;
    },
    validationColor() {
      return this.formProps.validationColor;
    },
    labelClasses() {
      return {
        [this.labelColor]: this.labelColor && this.valid !== false,
        [this.validationColor]: this.valid === false
      };
    }
  },
  methods: {
    validate() {
      this.$refs.formEl.validate(this);
    }
  }
};
var render$J = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister && !_vm.wCheckboxes ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.isChecked = null);
    _vm.$emit("input", null);
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.isChecked, disabled: _vm.isDisabled, readonly: _vm.isReadonly }, false), [_c("input", { ref: "input", attrs: { "id": "w-checkbox--" + _vm._uid, "type": "checkbox", "name": _vm.inputName, "disabled": _vm.isDisabled || _vm.isReadonly || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null, "aria-checked": _vm.isChecked || "false", "role": "checkbox" }, domProps: { "checked": _vm.isChecked || null }, on: { "focus": function($event) {
    return _vm.$emit("focus", $event);
  }, "blur": function($event) {
    return _vm.$emit("blur", $event);
  }, "change": function($event) {
    _vm.onInput();
  }, "keypress": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    return _vm.onInput.apply(null, arguments);
  } } }), _vm.hasLabel && _vm.labelOnLeft ? [_vm.$slots.default ? _c("label", { staticClass: "w-checkbox__label w-form-el-shakable pr2", class: _vm.labelClasses, attrs: { "for": "w-checkbox--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm.label ? _c("label", { staticClass: "w-checkbox__label w-form-el-shakable pr2", class: _vm.labelClasses, attrs: { "for": "w-checkbox--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.label) } }) : _vm._e()] : _vm._e(), _c("div", { staticClass: "w-checkbox__input", class: this.color, on: { "click": function($event) {
    _vm.$refs.input.focus();
    _vm.$refs.input.click();
  } } }, [_c("svg", { attrs: { "viewBox": "-0.5 0 12 10" } }, [_c("polyline", { attrs: { "points": "1 5 4 8 10 2" } })])]), _vm.hasLabel && !_vm.labelOnLeft ? [_vm.$slots.default ? _c("label", { staticClass: "w-checkbox__label w-form-el-shakable pl2", class: _vm.labelClasses, attrs: { "for": "w-checkbox--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm.label ? _c("label", { staticClass: "w-checkbox__label w-form-el-shakable pl2", class: _vm.labelClasses, attrs: { "for": "w-checkbox--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.label) } }) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns$J = [];
var wCheckbox_vue_vue_type_style_index_0_lang = "";
const __vue2_script$J = {
  name: "w-checkbox",
  mixins: [FormElementMixin],
  inject: { wCheckboxes: { default: null } },
  props: {
    value: { default: false },
    returnValue: {},
    label: { type: String },
    labelOnLeft: { type: Boolean },
    color: { type: String, default: "primary" },
    labelColor: { type: String, default: "primary" },
    noRipple: { type: Boolean },
    indeterminate: { type: Boolean },
    round: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "focus", "blur"],
  data() {
    return {
      isChecked: this.value,
      ripple: {
        start: false,
        end: false,
        timeout: null
      }
    };
  },
  computed: {
    hasLabel() {
      return this.$slots.default && this.$slots.default.length || this.label;
    },
    classes() {
      return {
        [`w-checkbox w-checkbox--${this.isChecked ? "checked" : "unchecked"}`]: true,
        "w-checkbox--disabled": this.isDisabled,
        "w-checkbox--readonly": this.isReadonly,
        "w-checkbox--indeterminate": this.indeterminate,
        "w-checkbox--ripple": this.ripple.start,
        "w-checkbox--rippled": this.ripple.end,
        "w-checkbox--round": this.round
      };
    }
  },
  methods: {
    onInput() {
      this.isChecked = !this.isChecked;
      const returnValue = this.isChecked && this.returnValue !== void 0 ? this.returnValue : this.isChecked;
      this.$emit("update:modelValue", returnValue);
      this.$emit("input", returnValue);
      if (!this.noRipple) {
        if (this.isChecked) {
          this.ripple.start = true;
          this.ripple.timeout = setTimeout(() => {
            this.ripple.start = false;
            this.ripple.end = true;
            setTimeout(() => this.ripple.end = false, 100);
          }, 700);
        } else {
          this.ripple.start = false;
          clearTimeout(this.ripple.timeout);
        }
      }
    }
  },
  watch: {
    value(value) {
      this.isChecked = value;
    }
  }
};
const __cssModules$J = {};
var __component__$J = /* @__PURE__ */ normalizeComponent(
  __vue2_script$J,
  render$J,
  staticRenderFns$J,
  false,
  __vue2_injectStyles$J,
  null,
  null,
  null
);
function __vue2_injectStyles$J(context) {
  for (let o in __cssModules$J) {
    this[o] = __cssModules$J[o];
  }
}
var wCheckbox = /* @__PURE__ */ function() {
  return __component__$J.exports;
}();
var render$I = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid, "column": !_vm.inline, "wrap": _vm.inline }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": _vm.reset } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.checkboxItems.some(function(item) {
    return item._isChecked;
  }), disabled: _vm.isDisabled }, false), _vm._l(_vm.checkboxItems, function(item, i) {
    return _c("w-checkbox", _vm._b({ key: i, class: { mt1: !_vm.inline && i }, attrs: { "value": item._isChecked, "name": _vm.inputName + "[]", "disabled": _vm.isDisabled || null, "readonly": _vm.isReadonly || null }, on: { "input": function($event) {
      return _vm.toggleCheck(item, $event);
    }, "focus": function($event) {
      return _vm.$emit("focus", $event);
    } } }, "w-checkbox", { label: item.label, color: item.color, labelOnLeft: _vm.labelOnLeft, labelColor: _vm.labelColor, round: _vm.round }, false), [_vm.$scopedSlots["item." + (i + 1)] || _vm.$scopedSlots.item ? _vm._t(_vm.$scopedSlots["item." + (i + 1)] ? "item." + (i + 1) : "item", null, { "item": _vm.getOriginalItem(item), "checked": !!item._isChecked, "index": i + 1 }) : _vm._e()], 2);
  }), 1);
};
var staticRenderFns$I = [];
var wCheckboxes_vue_vue_type_style_index_0_lang = "";
const __vue2_script$I = {
  name: "w-checkboxes",
  mixins: [FormElementMixin],
  props: {
    items: { type: Array, required: true },
    value: { type: Array },
    returnValues: { type: Boolean },
    labelOnLeft: { type: Boolean },
    itemLabelKey: { type: String, default: "label" },
    itemValueKey: { type: String, default: "value" },
    itemColorKey: { type: String, default: "color" },
    inline: { type: Boolean },
    round: { type: Boolean },
    color: { type: String, default: "primary" },
    labelColor: { type: String, default: "primary" }
  },
  emits: ["input", "update:modelValue", "focus"],
  provide() {
    return { wCheckboxes: true };
  },
  computed: {
    checkboxItems() {
      return (this.items || []).map((item, i) => {
        const itemValue = item[this.itemValueKey] === void 0 ? item[this.itemLabelKey] || i : item[this.itemValueKey];
        return Vue.observable({
          ...item,
          label: item[this.itemLabelKey],
          _index: i,
          value: itemValue,
          color: item[this.itemColorKey] || this.color,
          _isChecked: this.value && this.value.includes(itemValue)
        });
      });
    },
    classes() {
      return [
        "w-checkboxes",
        `w-checkboxes--${this.inline ? "inline" : "column"}`
      ];
    }
  },
  methods: {
    reset() {
      this.checkboxItems.forEach((item) => item._isChecked = null);
      this.$emit("update:modelValue", []);
      this.$emit("input", []);
    },
    toggleCheck(checkbox, isChecked) {
      checkbox._isChecked = isChecked;
      const selection = this.checkboxItems.filter((item) => item._isChecked).map((item) => this.returnValues ? item.returnValue : item.value);
      this.$emit("update:modelValue", selection);
      this.$emit("input", selection);
    },
    getOriginalItem(item) {
      return this.items[item._index];
    }
  }
};
const __cssModules$I = {};
var __component__$I = /* @__PURE__ */ normalizeComponent(
  __vue2_script$I,
  render$I,
  staticRenderFns$I,
  false,
  __vue2_injectStyles$I,
  null,
  null,
  null
);
function __vue2_injectStyles$I(context) {
  for (let o in __cssModules$I) {
    this[o] = __cssModules$I[o];
  }
}
var wCheckboxes = /* @__PURE__ */ function() {
  return __component__$I.exports;
}();
var render$H = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("w-menu", _vm._b({ scopedSlots: _vm._u([{ key: "activator", fn: function(ref) {
    var on = ref.on;
    return [_c("w-button", _vm._g(_vm._b({ staticClass: "w-confirm" }, "w-button", _vm.buttonProps, false), Object.assign({}, _vm.$listeners, _vm.disablePrompt ? {} : on)), [_vm._t("default")], 2)];
  } }], null, true), model: { value: _vm.showPopup, callback: function($$v) {
    _vm.showPopup = $$v;
  }, expression: "showPopup" } }, "w-menu", _vm.wMenuProps, false), [_c("w-flex", { attrs: { "column": !_vm.inline, "align-center": "" } }, [_c("div", [_vm._t("question", function() {
    return [_vm._v(_vm._s(_vm.question))];
  })], 2), _c("div", { staticClass: "w-flex justify-end", class: _vm.inline ? "ml2" : "mt2" }, [_vm.cancel !== false ? _c("w-button", _vm._b({ staticClass: "mr2", attrs: { "bg-color": (_vm.cancelButton || {}).bgColor || "error" }, on: { "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "escape", void 0, $event.key, void 0)) {
      return null;
    }
    !_vm.persistent && _vm.onCancel();
  }, "click": _vm.onCancel } }, "w-button", _vm.cancelButtonProps, false), [_vm._t("cancel", function() {
    return [_vm._v(_vm._s(_vm.cancelButton.label))];
  })], 2) : _vm._e(), _c("w-button", _vm._b({ directives: [{ name: "focus", rawName: "v-focus" }], attrs: { "bg-color": (_vm.confirmButton || {}).bgColor || "success" }, on: { "keyup": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "escape", void 0, $event.key, void 0)) {
      return null;
    }
    !_vm.persistent && _vm.onCancel();
  }, "click": _vm.onConfirm } }, "w-button", _vm.confirmButtonProps, false), [_vm._t("confirm", function() {
    return [_vm._v(_vm._s(_vm.confirmButton.label))];
  })], 2)], 1)])], 1);
};
var staticRenderFns$H = [];
const __vue2_script$H = {
  name: "w-confirm",
  inheritAttrs: false,
  props: {
    bgColor: { type: String },
    color: { type: String },
    icon: { type: String },
    disablePrompt: { type: Boolean },
    mainButton: { type: Object },
    question: { type: String, default: "Are you sure?" },
    cancel: { type: [Boolean, Object, String], default: void 0 },
    confirm: { type: [Object, String] },
    inline: { type: Boolean },
    menu: { type: Object, default: () => ({}) },
    tooltip: { type: [Boolean, Object, String] },
    noArrow: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    alignTop: { type: Boolean },
    alignBottom: { type: Boolean },
    alignLeft: { type: Boolean },
    alignRight: { type: Boolean },
    persistent: { type: Boolean },
    transition: { type: String }
  },
  emits: ["cancel", "confirm"],
  data: () => ({
    showPopup: false,
    props: []
  }),
  computed: {
    cancelButton() {
      let button = { label: typeof this.cancel === "string" ? this.cancel : "Cancel" };
      if (typeof this.cancel === "object")
        button = Object.assign({}, button, this.cancel);
      return button;
    },
    cancelButtonProps() {
      const { label, ...props } = this.cancelButton;
      return props;
    },
    confirmButton() {
      let button = { label: typeof this.confirm === "string" ? this.confirm : "Confirm" };
      if (typeof this.confirm === "object")
        button = Object.assign({}, button, this.confirm);
      return button;
    },
    confirmButtonProps() {
      const { label, ...props } = this.confirmButton;
      return props;
    },
    wMenuProps() {
      return {
        top: this.top,
        bottom: this.bottom,
        left: this.left,
        right: this.right,
        arrow: !this.noArrow,
        alignTop: this.alignTop,
        alignBottom: this.alignBottom,
        alignLeft: this.alignLeft,
        alignRight: this.alignRight,
        persistent: this.persistent,
        transition: this.transition,
        ...this.menu
      };
    },
    tooltipObject() {
      let tooltip = { label: typeof this.tooltip === "string" ? this.tooltip : "" };
      if (typeof this.tooltip === "object")
        tooltip = Object.assign({}, tooltip, this.tooltip);
      return tooltip;
    },
    buttonProps() {
      const { label, ...tooltipProps } = this.tooltipObject;
      return {
        bgColor: this.bgColor,
        color: this.color,
        icon: this.icon,
        tooltip: label,
        tooltipProps,
        ...this.mainButton,
        ...this.$attrs,
        class: [this.$vnode.data.staticClass, this.$vnode.data.class]
      };
    }
  },
  methods: {
    onCancel() {
      this.$emit("cancel");
      this.showPopup = false;
    },
    onConfirm() {
      this.$emit("confirm");
      this.showPopup = false;
    }
  }
};
const __cssModules$H = {};
var __component__$H = /* @__PURE__ */ normalizeComponent(
  __vue2_script$H,
  render$H,
  staticRenderFns$H,
  false,
  __vue2_injectStyles$H,
  null,
  null,
  null
);
function __vue2_injectStyles$H(context) {
  for (let o in __cssModules$H) {
    this[o] = __cssModules$H[o];
  }
}
var wConfirm = /* @__PURE__ */ function() {
  return __component__$H.exports;
}();
var render$G = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-date-picker", class: _vm.classes, style: _vm.styles }, [_vm._t("default")], 2);
};
var staticRenderFns$G = [];
var wDatePicker_vue_vue_type_style_index_0_lang = "";
const __vue2_script$G = {
  name: "w-date-picker",
  props: {},
  emits: [],
  computed: {
    classes() {
      return {};
    },
    styles() {
      return false;
    }
  }
};
const __cssModules$G = {};
var __component__$G = /* @__PURE__ */ normalizeComponent(
  __vue2_script$G,
  render$G,
  staticRenderFns$G,
  false,
  __vue2_injectStyles$G,
  null,
  null,
  null
);
function __vue2_injectStyles$G(context) {
  for (let o in __cssModules$G) {
    this[o] = __cssModules$G[o];
  }
}
var wDatePicker = /* @__PURE__ */ function() {
  return __component__$G.exports;
}();
var render$F = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("w-overlay", { staticClass: "w-dialog", class: _vm.classes, attrs: { "value": _vm.showWrapper, "persistent": _vm.persistent, "persistent-no-animation": _vm.persistentNoAnimation, "bg-color": _vm.overlayColor, "opacity": _vm.overlayOpacity }, on: { "click": _vm.onOutsideClick, "close": _vm.onClose } }, [_c("transition", { attrs: { "name": _vm.transition, "appear": "" }, on: { "after-leave": _vm.onBeforeClose } }, [_c("w-card", { directives: [{ name: "show", rawName: "v-show", value: _vm.showContent, expression: "showContent" }], ref: "dialog", staticClass: "w-dialog__content", class: _vm.dialogClass, style: _vm.contentStyles, attrs: { "no-border": "", "color": _vm.color, "bg-color": _vm.bgColor, "title-class": _vm.titleClass, "content-class": _vm.contentClass, "title": _vm.title || void 0 }, scopedSlots: _vm._u([_vm.$slots.title ? { key: "title", fn: function() {
    return [_vm._t("title")];
  }, proxy: true } : null, _vm.$slots.actions ? { key: "actions", fn: function() {
    return [_vm._t("actions")];
  }, proxy: true } : null], null, true) }, [_vm._t("default")], 2)], 1)], 1);
};
var staticRenderFns$F = [];
var wDialog_vue_vue_type_style_index_0_lang = "";
const __vue2_script$F = {
  name: "w-dialog",
  props: {
    value: { default: true },
    width: { type: [Number, String], default: 0 },
    fullscreen: { type: Boolean },
    persistent: { type: Boolean },
    persistentNoAnimation: { type: Boolean },
    tile: { type: Boolean },
    title: { type: String },
    transition: { type: String, default: "fade" },
    titleClass: { type: String },
    contentClass: { type: String },
    dialogClass: { type: String },
    overlayColor: { type: String },
    color: { type: String },
    bgColor: { type: String },
    overlayOpacity: { type: [Number, String, Boolean] }
  },
  provide() {
    return {
      detachableDefaultRoot: () => this.$refs.dialog.$el || null
    };
  },
  emits: ["input", "update:modelValue", "before-close", "close"],
  data() {
    return {
      showWrapper: this.value,
      showContent: this.value
    };
  },
  computed: {
    maxWidth() {
      let width = this.width;
      if (width && parseInt(width) == width)
        width += "px";
      return width;
    },
    classes() {
      return {
        "w-dialog--fullscreen": this.fullscreen
      };
    },
    contentStyles() {
      return {
        maxWidth: !this.fullscreen && this.maxWidth ? this.maxWidth : null
      };
    }
  },
  methods: {
    onOutsideClick() {
      if (!this.persistent) {
        this.showContent = false;
        if (this.transition === "fade")
          this.onBeforeClose();
      }
    },
    onBeforeClose() {
      this.showWrapper = false;
      this.$emit("before-close");
    },
    onClose() {
      this.$emit("update:modelValue", false);
      this.$emit("input", false);
      this.$emit("close");
    }
  },
  watch: {
    value(value) {
      this.showWrapper = value;
      this.showContent = value;
    }
  }
};
const __cssModules$F = {};
var __component__$F = /* @__PURE__ */ normalizeComponent(
  __vue2_script$F,
  render$F,
  staticRenderFns$F,
  false,
  __vue2_injectStyles$F,
  null,
  null,
  null
);
function __vue2_injectStyles$F(context) {
  for (let o in __cssModules$F) {
    this[o] = __cssModules$F[o];
  }
}
var wDialog = /* @__PURE__ */ function() {
  return __component__$F.exports;
}();
var render$E = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-divider", class: _vm.classes, attrs: { "role": _vm.$slots.default ? null : "presentation", "aria-orientation": _vm.vertical ? "vertical" : "horizontal" } }, [_vm._t("default")], 2);
};
var staticRenderFns$E = [];
var wDivider_vue_vue_type_style_index_0_lang = "";
const __vue2_script$E = {
  name: "w-divider",
  props: {
    vertical: { type: Boolean },
    color: { type: String }
  },
  emits: [],
  computed: {
    classes() {
      return {
        [`w-divider--has-color ${this.color}`]: this.color,
        [`w-divider--${this.vertical ? "vertical" : "horizontal"}`]: true,
        "w-divider--has-content": this.$slots.default
      };
    }
  }
};
const __cssModules$E = {};
var __component__$E = /* @__PURE__ */ normalizeComponent(
  __vue2_script$E,
  render$E,
  staticRenderFns$E,
  false,
  __vue2_injectStyles$E,
  null,
  null,
  null
);
function __vue2_injectStyles$E(context) {
  for (let o in __cssModules$E) {
    this[o] = __cssModules$E[o];
  }
}
var wDivider = /* @__PURE__ */ function() {
  return __component__$E.exports;
}();
var render$D = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.showWrapper || _vm.pushContent ? _c("div", { staticClass: "w-drawer-wrap", class: _vm.wrapperClasses }, [_vm.pushContent ? _c("div", { staticClass: "w-drawer-wrap__track", style: _vm.trackStyles }, [_c("div", { staticClass: "w-drawer-wrap__pushable" }, [!_vm.noOverlay ? _c("w-overlay", { attrs: { "persistent": _vm.persistent, "persistent-no-animation": "", "bg-color": _vm.overlayColor || "transparent", "opacity": _vm.overlayOpacity }, on: { "click": _vm.onOutsideClick, "before-close": _vm.onBeforeClose }, model: { value: _vm.showDrawer, callback: function($$v) {
    _vm.showDrawer = $$v;
  }, expression: "showDrawer" } }) : _vm._e(), _vm._t("pushable")], 2), _c("transition", { attrs: { "name": "fade" }, on: { "before-leave": function($event) {
    _vm.noOverlay && _vm.onBeforeClose();
  }, "after-leave": _vm.onClose } }, [_vm.showDrawer ? _c(_vm.tag || "aside", { ref: "drawer", tag: "component", staticClass: "w-drawer", class: _vm.drawerClasses, style: _vm.styles }, [_vm._t("default")], 2) : _vm._e()], 1)], 1) : [!_vm.noOverlay ? _c("w-overlay", { attrs: { "persistent": _vm.persistent, "persistent-no-animation": "", "bg-color": _vm.overlayColor, "opacity": _vm.overlayOpacity }, on: { "click": _vm.onOutsideClick, "before-close": _vm.onBeforeClose }, model: { value: _vm.showDrawer, callback: function($$v) {
    _vm.showDrawer = $$v;
  }, expression: "showDrawer" } }) : _vm._e(), _c("transition", { attrs: { "name": _vm.transitionName, "appear": "" }, on: { "before-leave": function($event) {
    _vm.noOverlay && _vm.onBeforeClose();
  }, "after-leave": _vm.onClose } }, [_vm.showDrawer ? _c(_vm.tag || "aside", { ref: "drawer", tag: "component", staticClass: "w-drawer", class: _vm.drawerClasses, style: _vm.styles }, [_vm._t("default")], 2) : _vm._e()], 1)]], 2) : _vm._e();
};
var staticRenderFns$D = [];
var wDrawer_vue_vue_type_style_index_0_lang = "";
const oppositeSides = { left: "right", right: "left", top: "down", bottom: "up" };
const __vue2_script$D = {
  name: "w-drawer",
  props: {
    value: { default: true },
    left: { type: Boolean },
    right: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    persistent: { type: Boolean },
    persistentNoAnimation: { type: Boolean },
    fitContent: { type: Boolean },
    width: { type: [Number, String, Boolean] },
    height: { type: [Number, String, Boolean] },
    zIndex: { type: [Number, String, Boolean] },
    color: { type: String },
    bgColor: { type: String },
    noOverlay: { type: Boolean },
    pushContent: { type: Boolean },
    absolute: { type: Boolean },
    overlayColor: { type: String },
    overlayOpacity: { type: [Number, String, Boolean] },
    drawerClass: { type: String },
    tag: { type: String, default: "aside" }
  },
  provide() {
    return {
      detachableDefaultRoot: () => this.$refs.drawer || null
    };
  },
  emits: ["input", "update:modelValue", "before-close", "close"],
  data() {
    return {
      showWrapper: this.value,
      showDrawer: this.value,
      persistentAnimate: false
    };
  },
  computed: {
    size() {
      let size = this.width || this.height;
      if (size && parseInt(size) == size)
        size += "px";
      return size || false;
    },
    sizeProperty() {
      return ["left", "right"].includes(this.position) && "width" || "height";
    },
    position() {
      return this.left && "left" || this.right && "right" || this.top && "top" || this.bottom && "bottom" || "right";
    },
    wrapperClasses() {
      return {
        "w-drawer-wrap--fixed": !this.absolute && !this.pushContent,
        "w-drawer-wrap--absolute": this.absolute,
        "w-drawer-wrap--push-content": this.pushContent
      };
    },
    drawerClasses() {
      return {
        [this.drawerClass]: true,
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-drawer--open": !!this.showDrawer,
        [`w-drawer--${this.position}`]: true,
        "w-drawer--fit-content": this.fitContent,
        "w-drawer--persistent": this.persistent,
        "w-drawer--persistent-animate": this.persistent && this.persistentAnimate
      };
    },
    trackStyles() {
      return this.pushContent && this.showDrawer && {
        transform: `translateX(${this.position === "left" ? "" : "-"}${this.size || "200px"})`
      };
    },
    styles() {
      return {
        [`max-${this.sizeProperty}`]: this.size || null,
        zIndex: this.zIndex || this.zIndex === 0 || null
      };
    },
    unmountDrawer() {
      return !this.showWrapper;
    },
    transitionName() {
      return `slide-${oppositeSides[this.position]}`;
    }
  },
  methods: {
    onOutsideClick() {
      if (this.persistent && !this.persistentNoAnimation) {
        this.persistentAnimate = true;
        setTimeout(() => this.persistentAnimate = false, 200);
      }
    },
    onBeforeClose() {
      this.$emit("before-close");
      this.showDrawer = false;
    },
    onClose() {
      this.showWrapper = false;
      this.$emit("update:modelValue", false);
      this.$emit("input", false);
      this.$emit("close");
    }
  },
  watch: {
    value(value) {
      if (value)
        this.showWrapper = true;
      this.showDrawer = value;
    }
  }
};
const __cssModules$D = {};
var __component__$D = /* @__PURE__ */ normalizeComponent(
  __vue2_script$D,
  render$D,
  staticRenderFns$D,
  false,
  __vue2_injectStyles$D,
  null,
  null,
  null
);
function __vue2_injectStyles$D(context) {
  for (let o in __cssModules$D) {
    this[o] = __cssModules$D[o];
  }
}
var wDrawer = /* @__PURE__ */ function() {
  return __component__$D.exports;
}();
var render$C = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, { tag: "component", staticClass: "w-flex", class: _vm.classes }, [_vm._t("default")], 2);
};
var staticRenderFns$C = [];
var wFlex_vue_vue_type_style_index_0_lang = "";
const __vue2_script$C = {
  name: "w-flex",
  props: {
    tag: { type: String, default: "div" },
    column: { type: Boolean },
    grow: { type: Boolean },
    noGrow: { type: Boolean },
    shrink: { type: Boolean },
    noShrink: { type: Boolean },
    fillHeight: { type: Boolean },
    wrap: { type: Boolean },
    alignStart: { type: Boolean },
    alignCenter: { type: Boolean },
    alignEnd: { type: Boolean },
    justifyStart: { type: Boolean },
    justifyCenter: { type: Boolean },
    justifyEnd: { type: Boolean },
    justifySpaceBetween: { type: Boolean },
    justifySpaceAround: { type: Boolean },
    justifySpaceEvenly: { type: Boolean },
    basisZero: { type: Boolean },
    gap: { type: [Number, String], default: 0 }
  },
  computed: {
    classes() {
      return {
        column: this.column,
        grow: this.grow,
        "no-grow": this.noGrow,
        shrink: this.shrink,
        "no-shrink": this.noShrink,
        "fill-height": this.fillHeight,
        wrap: this.wrap,
        "align-start": this.alignStart,
        "align-center": this.alignCenter,
        "align-end": this.alignEnd,
        "justify-start": this.justifyStart,
        "justify-center": this.justifyCenter,
        "justify-end": this.justifyEnd,
        "justify-space-between": this.justifySpaceBetween,
        "justify-space-around": this.justifySpaceAround,
        "justify-space-evenly": this.justifySpaceEvenly,
        "basis-zero": this.basisZero,
        [`gap${this.gap}`]: ~~this.gap
      };
    }
  }
};
const __cssModules$C = {};
var __component__$C = /* @__PURE__ */ normalizeComponent(
  __vue2_script$C,
  render$C,
  staticRenderFns$C,
  false,
  __vue2_injectStyles$C,
  null,
  null,
  null
);
function __vue2_injectStyles$C(context) {
  for (let o in __cssModules$C) {
    this[o] = __cssModules$C[o];
  }
}
var wFlex = /* @__PURE__ */ function() {
  return __component__$C.exports;
}();
var render$B = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("form", { staticClass: "w-form", class: _vm.classes, attrs: { "novalidate": "" }, on: { "submit": _vm.onSubmit, "reset": _vm.reset } }, [_vm._t("default")], 2);
};
var staticRenderFns$B = [];
const asyncSome = async (array, predicate) => {
  for (const item of array) {
    if (await predicate(item))
      return true;
  }
  return false;
};
const __vue2_script$B = {
  name: "w-form",
  props: {
    value: {},
    allowSubmit: { type: Boolean },
    noKeyupValidation: { type: Boolean },
    noBlurValidation: { type: Boolean },
    errorPlaceholders: { type: Boolean },
    validationColor: { type: String, default: "error" },
    disabled: { type: Boolean },
    readonly: { type: Boolean }
  },
  provide() {
    return {
      formRegister: this.register,
      formUnregister: this.unregister,
      validateElement: this.validateElement,
      formProps: this.$props
    };
  },
  emits: [
    "submit",
    "before-validate",
    "validate",
    "success",
    "error",
    "reset",
    "input",
    "update:modelValue",
    "update:errorsCount"
  ],
  data: () => ({
    formElements: [],
    status: null,
    errorsCount: 0
  }),
  computed: {
    classes() {
      return {
        "w-form--pristine": this.status === null,
        "w-form--error": this.status === false,
        "w-form--success": this.status === true,
        "w-form--error-placeholders": this.errorPlaceholders
      };
    }
  },
  methods: {
    register(formElement) {
      this.formElements.push(formElement);
    },
    unregister(formElement) {
      this.formElements = this.formElements.filter((item) => item._uid !== formElement._uid);
    },
    async validate(e) {
      this.$emit("before-validate", { e, errorsCount: this.errorsCount });
      let errorsCount = 0;
      await (async () => {
        var _a;
        for (const el of this.formElements) {
          if (!((_a = el.validators) == null ? void 0 : _a.length) || el.disabled || el.readonly)
            continue;
          await this.checkElementValidators(el);
          errorsCount += ~~!el.Validation.isValid;
          el.$emit("update:valid", el.Validation.isValid);
        }
      })();
      this.updateErrorsCount(errorsCount);
      this.status = !errorsCount;
      this.$emit("validate", { e, errorsCount });
      this.$emit(this.status ? "success" : "error", { e, errorsCount });
      return this.status;
    },
    async validateElement(el) {
      await this.checkElementValidators(el);
      this.updateErrorsCount();
      return el.Validation.isValid;
    },
    async checkElementValidators(el) {
      let validationsPassed = false;
      let validationMessage = "";
      await asyncSome(el.validators, async (validator) => {
        const result = await (typeof validator === "function" && validator(el.inputValue));
        validationsPassed = typeof result !== "string";
        validationMessage = validationsPassed ? "" : result;
        return !validationsPassed;
      });
      el.hasJustReset = false;
      el.Validation.isValid = validationsPassed;
      el.Validation.message = validationMessage;
    },
    reset(e) {
      this.status = null;
      this.formElements.forEach((item) => item.reset());
      this.updateErrorsCount(0, true);
      this.$emit("reset", e);
    },
    updateErrorsCount(count = null, reset = false) {
      this.errorsCount = count !== null ? count : this.formElements.reduce((sum, el) => sum + ~~(el.Validation.isValid === false), 0);
      this.status = reset ? null : !this.errorsCount;
      this.$emit("update:modelValue", this.status);
      this.$emit("input", this.status);
      this.$emit("update:errorsCount", this.errorsCount);
    },
    onSubmit(e) {
      this.validate(e);
      this.$emit("submit", e);
      if (!this.allowSubmit || !this.status)
        e.preventDefault();
    }
  },
  created() {
    this.status = this.value || null;
  },
  watch: {
    value(value) {
      if (this.status === false && value || value === null && this.status !== null)
        this.reset();
      this.status = value;
    }
  }
};
const __cssModules$B = {};
var __component__$B = /* @__PURE__ */ normalizeComponent(
  __vue2_script$B,
  render$B,
  staticRenderFns$B,
  false,
  __vue2_injectStyles$B,
  null,
  null,
  null
);
function __vue2_injectStyles$B(context) {
  for (let o in __cssModules$B) {
    this[o] = __cssModules$B[o];
  }
}
var wForm = /* @__PURE__ */ function() {
  return __component__$B.exports;
}();
var render$A = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { class: _vm.classes }, [_c("div", { staticClass: "w-flex grow", class: [_vm.column ? "column" : "align-center", _vm.wrap ? "wrap" : ""] }, [_vm._t("default")], 2), _c("w-transition-expand", { attrs: { "y": "" } }, [_vm.Validation.message ? [_vm.$scopedSlots["error-message"] ? _c("div", { staticClass: "w-form-el__error", class: _vm.formProps.validationColor }, [_vm._t("error-message", null, { "message": _vm.Validation.message })], 2) : _c("div", { staticClass: "w-form-el__error error", class: _vm.formProps.validationColor, domProps: { "innerHTML": _vm._s(_vm.Validation.message) } })] : _vm._e()], 2)], 1);
};
var staticRenderFns$A = [];
var wFormElement_vue_vue_type_style_index_0_lang = "";
const __vue2_script$A = {
  name: "w-form-element",
  props: {
    valid: { required: true },
    disabled: { type: Boolean },
    readonly: { type: Boolean },
    inputValue: { required: true },
    validators: { type: Array },
    isFocused: { default: false },
    column: { default: false },
    wrap: { default: false }
  },
  inject: {
    formRegister: { default: null },
    formUnregister: { default: null },
    validateElement: { default: null },
    formProps: {
      default: () => ({
        noKeyupValidation: false,
        noBlurValidation: false,
        validationColor: "error",
        disabled: false,
        readonly: false
      })
    }
  },
  emits: ["reset", "update:valid"],
  data: () => ({
    Validation: {
      isValid: null,
      message: ""
    },
    hasJustReset: false
  }),
  computed: {
    classes() {
      const classes = ["w-form-el--error error", "w-form-el--success", "w-form-el--pristine"];
      return [
        "w-form-el",
        classes[this.Validation.isValid === null ? 2 : ~~this.Validation.isValid]
      ];
    }
  },
  methods: {
    reset() {
      this.$emit("reset");
      this.$emit("update:valid", null);
      this.Validation.message = "";
      this.Validation.isValid = null;
      this.hasJustReset = true;
    },
    async validate() {
      this.$emit("update:valid", await this.validateElement(this));
    }
  },
  watch: {
    async inputValue() {
      if (this.hasJustReset)
        return this.hasJustReset = false;
      if (!this.formProps.noKeyupValidation && this.validators) {
        this.$emit("update:valid", await this.validateElement(this));
      }
    },
    async isFocused(val) {
      if (val)
        this.hasJustReset = false;
      else if (!this.formProps.noBlurValidation && this.validators && !this.readonly) {
        this.$emit("update:valid", await this.validateElement(this));
      }
    }
  },
  created() {
    if (this.formRegister)
      this.formRegister(this);
  },
  beforeDestroy() {
    if (this.formUnregister)
      this.formUnregister(this);
  }
};
const __cssModules$A = {};
var __component__$A = /* @__PURE__ */ normalizeComponent(
  __vue2_script$A,
  render$A,
  staticRenderFns$A,
  false,
  __vue2_injectStyles$A,
  null,
  null,
  null
);
function __vue2_injectStyles$A(context) {
  for (let o in __cssModules$A) {
    this[o] = __cssModules$A[o];
  }
}
var wFormElement = /* @__PURE__ */ function() {
  return __component__$A.exports;
}();
var render$z = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag, { tag: "component", staticClass: "w-grid", class: _vm.classes }, [_vm._t("default")], 2);
};
var staticRenderFns$z = [];
var wGrid_vue_vue_type_style_index_0_lang = "";
const __vue2_script$z = {
  name: "w-grid",
  props: {
    tag: { type: String, default: "div" },
    columns: { type: [Number, Object, String] },
    gap: { type: [Number, Object, String], default: 0 }
  },
  computed: {
    breakpointsColumns() {
      let columns = { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 };
      switch (typeof this.columns) {
        case "object":
          columns = Object.assign(columns, this.columns);
          break;
        case "number":
        case "string":
          columns = Object.keys(columns).reduce((obj, breakpoint) => obj[breakpoint] = ~~this.columns, {});
          break;
      }
      return columns;
    },
    breakpointsGap() {
      let gap = { xs: 0, sm: 0, md: 0, lg: 0, xl: 0 };
      switch (typeof this.gap) {
        case "object":
          gap = Object.assign(gap, this.gap);
          break;
        case "number":
        case "string":
          gap = Object.keys(gap).reduce((obj, breakpoint) => obj[breakpoint] = ~~this.gap, {});
          break;
      }
      return gap;
    },
    classes() {
      let breakpointsColumns = null;
      if (typeof this.columns === "object") {
        breakpointsColumns = Object.entries(this.breakpointsColumns).reduce((obj, [breakpoint, columns]) => {
          obj[`${breakpoint}-columns${columns}`] = true;
          return obj;
        }, {});
      }
      let breakpointsGap = null;
      if (typeof this.gap === "object") {
        breakpointsGap = Object.entries(this.breakpointsGap).reduce((obj, [breakpoint, gap]) => {
          obj[`${breakpoint}-gap${gap}`] = true;
          return obj;
        }, {});
      }
      return {
        ...breakpointsColumns || { [`columns${this.columns}`]: this.columns },
        ...breakpointsGap || { [`gap${this.gap}`]: this.gap }
      };
    }
  }
};
const __cssModules$z = {};
var __component__$z = /* @__PURE__ */ normalizeComponent(
  __vue2_script$z,
  render$z,
  staticRenderFns$z,
  false,
  __vue2_injectStyles$z,
  null,
  null,
  null
);
function __vue2_injectStyles$z(context) {
  for (let o in __cssModules$z) {
    this[o] = __cssModules$z[o];
  }
}
var wGrid = /* @__PURE__ */ function() {
  return __component__$z.exports;
}();
var render$y = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.tag || "i", _vm._g({ tag: "component", staticClass: "w-icon", class: _vm.classes, style: _vm.readIcon() && _vm.styles, attrs: { "role": "icon", "aria-hidden": "true" } }, _vm.$listeners), [_vm.hasLigature ? [_vm._v(_vm._s(_vm.icon))] : _vm._e()], 2);
};
var staticRenderFns$y = [];
var wIcon_vue_vue_type_style_index_0_lang = "";
const __vue2_script$y = {
  name: "w-icon",
  props: {
    tag: { type: String, default: "i" },
    color: { type: String },
    bgColor: { type: String },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    spin: { type: Boolean },
    spinA: { type: Boolean },
    rotate135a: { type: Boolean },
    rotate90a: { type: Boolean },
    rotate45a: { type: Boolean },
    rotate45: { type: Boolean },
    rotate90: { type: Boolean },
    rotate135: { type: Boolean },
    rotate180: { type: Boolean },
    flipX: { type: Boolean },
    flipY: { type: Boolean },
    size: { type: [Number, String] }
  },
  emits: [],
  data: () => ({
    icon: "",
    fontName: ""
  }),
  computed: {
    hasLigature() {
      return this.$waveui.config.iconsLigature === this.fontName;
    },
    forcedSize() {
      return this.size && (!isNaN(this.size) ? `${this.size}px` : this.size);
    },
    presetSize() {
      return this.xs && "xs" || this.sm && "sm" || this.md && "md" || this.lg && "lg" || this.xl && "xl" || null;
    },
    classes() {
      return {
        [this.fontName]: true,
        [!this.hasLigature && this.icon]: !this.hasLigature && this.icon,
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        [`size--${this.presetSize}`]: this.presetSize && !this.forcedSize,
        "w-icon--spin": this.spin,
        "w-icon--spin-a": this.spinA,
        "w-icon--rotate45": this.rotate45,
        "w-icon--rotate90": this.rotate90,
        "w-icon--rotate135": this.rotate135,
        "w-icon--rotate180": this.rotate180,
        "w-icon--rotate-45": this.rotate45a,
        "w-icon--rotate-90": this.rotate90a,
        "w-icon--rotate-135": this.rotate135a,
        "w-icon--flip-x": this.flipX,
        "w-icon--flip-y": this.flipY
      };
    },
    styles() {
      return this.forcedSize && `font-size: ${this.forcedSize}`;
    }
  },
  methods: {
    readIcon() {
      const { default: slot } = this.$slots;
      const [fontName = "", icon = ""] = slot[0].text.trim().split(" ") || [];
      this.fontName = fontName;
      this.icon = icon;
      return true;
    }
  }
};
const __cssModules$y = {};
var __component__$y = /* @__PURE__ */ normalizeComponent(
  __vue2_script$y,
  render$y,
  staticRenderFns$y,
  false,
  __vue2_injectStyles$y,
  null,
  null,
  null
);
function __vue2_injectStyles$y(context) {
  for (let o in __cssModules$y) {
    this[o] = __cssModules$y[o];
  }
}
var wIcon = /* @__PURE__ */ function() {
  return __component__$y.exports;
}();
var render$x = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.wrapperTag, { tag: "component", staticClass: "w-image-wrap", class: _vm.wrapperClasses, style: _vm.wrapperStyles }, [_c("transition", { attrs: { "name": _vm.transition, "appear": "" } }, [_vm.loaded ? _c(_vm.tag, { tag: "component", staticClass: "w-image", class: _vm.imageClasses, style: _vm.imageStyles, attrs: { "src": _vm.tag === "img" ? _vm.imgSrc : null } }) : _vm._e()], 1), !_vm.noSpinner && _vm.loading ? _c("div", { staticClass: "w-image__loader" }, [_vm.$slots.loading ? _vm._t("loading") : _c("w-progress", _vm._b({ attrs: { "circle": "", "indeterminate": "" } }, "w-progress", _vm.spinnerColor ? { color: _vm.spinnerColor } : {}, false))], 2) : _vm._e(), _vm.$slots.default ? _c(_vm.wrapperTag, { tag: "component", staticClass: "w-image__content", class: _vm.contentClass }, [_vm._t("default")], 2) : _vm._e()], 1);
};
var staticRenderFns$x = [];
var wImage_vue_vue_type_style_index_0_lang = "";
const __vue2_script$x = {
  name: "w-image",
  props: {
    tag: { type: String, default: "span" },
    src: { type: String },
    width: { type: [Number, String] },
    height: { type: [Number, String] },
    ratio: { type: [Number, String] },
    lazy: { type: Boolean },
    absolute: { type: Boolean },
    fixed: { type: Boolean },
    contain: { type: Boolean },
    noSpinner: { type: Boolean },
    spinnerColor: { type: String },
    fallback: { type: String },
    transition: { type: String, default: "fade" },
    contentClass: { type: [String, Array, Object] }
  },
  emits: ["loading", "loaded", "error"],
  data() {
    return {
      loading: false,
      loaded: false,
      imgSrc: "",
      imgWidth: this.width || 0,
      imgHeight: this.height || 0,
      imgComputedRatio: 0
    };
  },
  computed: {
    imgGivenRatio() {
      return parseFloat(this.ratio);
    },
    wrapperTag() {
      return ["span", "div"].includes(this.tag) ? this.tag : "span";
    },
    wrapperClasses() {
      return {
        "w-image-wrap--absolute": this.absolute,
        "w-image-wrap--fixed": this.fixed,
        "w-image-wrap--has-ratio": this.imgGivenRatio
      };
    },
    wrapperStyles() {
      return {
        width: this.imgGivenRatio ? null : (!isNaN(this.imgWidth) ? `${this.imgWidth}px` : this.imgWidth) || null,
        height: this.imgGivenRatio || this.tag === "img" ? null : (!isNaN(this.imgHeight) ? `${this.imgHeight}px` : this.imgHeight) || null,
        "padding-bottom": this.imgGivenRatio && `${this.imgGivenRatio * 100}%`
      };
    },
    imageClasses() {
      return {
        "w-image--loading": this.loading,
        "w-image--loaded": this.loaded,
        "w-image--contain": this.contain
      };
    },
    imageStyles() {
      return {
        "background-image": this.tag !== "img" && this.loaded ? `url('${this.imgSrc}')` : null
      };
    }
  },
  methods: {
    loadImage(loadFallback = false) {
      if (this.loading)
        return;
      this.loading = true;
      this.loaded = false;
      this.$emit("loading", loadFallback ? this.fallback : this.src);
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = (e) => {
          if (!this.width && !this.height && !this.imgGivenRatio) {
            this.imgWidth = e.target.width;
            this.imgHeight = e.target.height;
          }
          this.imgComputedRatio = e.target.height / e.target.width;
          this.loading = false;
          this.loaded = true;
          this.imgSrc = loadFallback ? this.fallback : this.src;
          this.$emit("loaded", this.imgSrc);
          return resolve(img);
        };
        img.onerror = (error) => {
          this.$emit("error", error);
          if (this.fallback && !loadFallback) {
            this.loading = false;
            this.loadImage(true);
          } else {
            this.loading = false;
            this.loaded = false;
          }
        };
        img.src = loadFallback ? this.fallback : this.src;
      });
    }
  },
  mounted() {
    if (!this.src)
      return consoleWarn("The w-image component was used without src.");
    if (this.lazy) {
      const IntersectObserver = new IntersectionObserver((entry) => {
        if (entry[0] && entry[0].isIntersecting) {
          this.loadImage();
          IntersectObserver.disconnect();
        }
      }, this.intersectionConfig);
      IntersectObserver.observe(this.$el);
    } else
      this.loadImage();
  },
  watch: {
    src() {
      this.loadImage();
    },
    width(value) {
      this.imgWidth = value;
    },
    height(value) {
      this.imgHeight = value;
    }
  }
};
const __cssModules$x = {};
var __component__$x = /* @__PURE__ */ normalizeComponent(
  __vue2_script$x,
  render$x,
  staticRenderFns$x,
  false,
  __vue2_injectStyles$x,
  null,
  null,
  null
);
function __vue2_injectStyles$x(context) {
  for (let o in __cssModules$x) {
    this[o] = __cssModules$x[o];
  }
}
var wImage = /* @__PURE__ */ function() {
  return __component__$x.exports;
}();
var render$w = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid, "wrap": _vm.hasLabel && _vm.labelPosition !== "inside" }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.inputValue = "");
    _vm.$emit("input", "");
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.inputValue, disabled: _vm.isDisabled, readonly: _vm.isReadonly, isFocused: _vm.isFocused }, false), [_vm.type === "hidden" ? _c("input", { directives: [{ name: "model", rawName: "v-model", value: _vm.inputValue, expression: "inputValue" }], attrs: { "type": "hidden", "name": _vm.name || null }, domProps: { "value": _vm.inputValue }, on: { "input": function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.inputValue = $event.target.value;
  } } }) : [_vm.labelPosition === "left" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-input__label w-input__label--left w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-input--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e(), _c("div", { staticClass: "w-input__input-wrap", class: _vm.inputWrapClasses }, [_vm._t("icon-left", function() {
    return [_vm.innerIconLeft ? _c("w-icon", { staticClass: "w-input__icon w-input__icon--inner-left", attrs: { "tag": "label", "for": "w-input--" + _vm._uid }, on: { "click": function($event) {
      return _vm.$emit("click:inner-icon-left", $event);
    } } }, [_vm._v(_vm._s(_vm.innerIconLeft))]) : _vm._e()];
  }, { "inputId": "w-input--" + _vm._uid }), _vm.type === "checkbox" && _vm.type !== "file" ? _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _vm.inputValue, expression: "inputValue" }], ref: "input", staticClass: "w-input__input", attrs: { "id": "w-input--" + _vm._uid, "name": _vm.inputName, "placeholder": _vm.placeholder || null, "step": _vm.step || null, "min": _vm.min || null, "max": _vm.max || null, "minlength": _vm.minlength || null, "maxlength": _vm.maxlength || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "disabled": _vm.isDisabled || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null, "type": "checkbox" }, domProps: { "checked": Array.isArray(_vm.inputValue) ? _vm._i(_vm.inputValue, null) > -1 : _vm.inputValue }, on: { "input": _vm.onInput, "focus": _vm.onFocus, "blur": _vm.onBlur, "change": function($event) {
    var $$a = _vm.inputValue, $$el = $event.target, $$c = $$el.checked ? true : false;
    if (Array.isArray($$a)) {
      var $$v = null, $$i = _vm._i($$a, $$v);
      if ($$el.checked) {
        $$i < 0 && (_vm.inputValue = $$a.concat([$$v]));
      } else {
        $$i > -1 && (_vm.inputValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
      }
    } else {
      _vm.inputValue = $$c;
    }
  } } }, "input", _vm.attrs, false), _vm.listeners)) : _vm.type === "radio" && _vm.type !== "file" ? _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _vm.inputValue, expression: "inputValue" }], ref: "input", staticClass: "w-input__input", attrs: { "id": "w-input--" + _vm._uid, "name": _vm.inputName, "placeholder": _vm.placeholder || null, "step": _vm.step || null, "min": _vm.min || null, "max": _vm.max || null, "minlength": _vm.minlength || null, "maxlength": _vm.maxlength || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "disabled": _vm.isDisabled || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null, "type": "radio" }, domProps: { "checked": _vm._q(_vm.inputValue, null) }, on: { "input": _vm.onInput, "focus": _vm.onFocus, "blur": _vm.onBlur, "change": function($event) {
    _vm.inputValue = null;
  } } }, "input", _vm.attrs, false), _vm.listeners)) : _vm.type !== "file" ? _c("input", _vm._g(_vm._b({ directives: [{ name: "model", rawName: "v-model", value: _vm.inputValue, expression: "inputValue" }], ref: "input", staticClass: "w-input__input", attrs: { "id": "w-input--" + _vm._uid, "name": _vm.inputName, "placeholder": _vm.placeholder || null, "step": _vm.step || null, "min": _vm.min || null, "max": _vm.max || null, "minlength": _vm.minlength || null, "maxlength": _vm.maxlength || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "disabled": _vm.isDisabled || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null, "type": _vm.type }, domProps: { "value": _vm.inputValue }, on: { "input": [function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.inputValue = $event.target.value;
  }, _vm.onInput], "focus": _vm.onFocus, "blur": _vm.onBlur } }, "input", _vm.attrs, false), _vm.listeners)) : [_c("input", _vm._b({ ref: "input", attrs: { "id": "w-input--" + _vm._uid, "type": "file", "name": _vm.name || null, "multiple": _vm.multiple || null, "disabled": _vm.isDisabled || null, "data-progress": _vm.overallFilesProgress }, on: { "focus": _vm.onFocus, "blur": _vm.onBlur, "change": _vm.onFileChange } }, "input", _vm.attrs, false)), _c("transition-group", { staticClass: "w-input__input w-input__input--file", attrs: { "tag": "label", "name": "fade", "for": "w-input--" + _vm._uid } }, [!_vm.inputFiles.length && _vm.isFocused ? _c("span", { key: "no-file", staticClass: "w-input__no-file" }, [_vm._t("no-file", function() {
    return [_vm.$slots["no-file"] === void 0 ? [_vm._v("No file")] : _vm._e()];
  })], 2) : _vm._e(), _vm._l(_vm.inputFiles, function(file, i) {
    return _c("span", { key: file.lastModified }, [_vm._v(_vm._s(i ? ", " : "")), _c("span", { key: i + "b", staticClass: "filename" }, [_vm._v(_vm._s(file.base))]), _vm._v(_vm._s(file.extension ? "." + file.extension : ""))]);
  })], 2)], _vm.labelPosition === "inside" && _vm.showLabelInside && (_vm.$slots.default || _vm.label) ? _c("label", { staticClass: "w-input__label w-input__label--inside w-form-el-shakable", class: _vm.labelClasses }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e(), _vm._t("icon-right", function() {
    return [_vm.innerIconRight ? _c("w-icon", { staticClass: "w-input__icon w-input__icon--inner-right", attrs: { "tag": "label", "for": "w-input--" + _vm._uid }, on: { "click": function($event) {
      return _vm.$emit("click:inner-icon-right", $event);
    } } }, [_vm._v(_vm._s(_vm.innerIconRight))]) : _vm._e()];
  }, { "inputId": "w-input--" + _vm._uid }), _vm.hasLoading || _vm.showProgress && (_vm.uploadInProgress || _vm.uploadComplete) ? _c("w-progress", { staticClass: "fill-width", attrs: { "size": "2", "color": _vm.progressColor || _vm.color, "value": _vm.showProgress ? (_vm.uploadInProgress || _vm.uploadComplete) && _vm.overallFilesProgress : _vm.loadingValue } }) : _vm._e()], 2), _vm.type === "file" && _vm.preview && _vm.inputFiles.length ? _c("label", { staticClass: "d-flex", attrs: { "for": "w-input--" + _vm._uid } }, [_vm._l(_vm.inputFiles, function(file, i) {
    return [file.progress < 100 ? _c("i", { key: i, staticClass: "w-icon wi-spinner w-icon--spin size--sm w-input__file-preview primary" }) : file.preview ? _c("img", { key: i, staticClass: "w-input__file-preview", attrs: { "src": file.preview, "alt": "" } }) : _c("i", { key: i, staticClass: "w-icon w-input__file-preview primary size--md", class: _vm.preview && typeof _vm.preview === "string" ? _vm.preview : "wi-file" })];
  })], 2) : _vm._e(), _vm.labelPosition === "right" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-input__label w-input__label--right w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-input--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e()]], 2);
};
var staticRenderFns$w = [];
var wInput_vue_vue_type_style_index_0_lang = "";
const __vue2_script$w = {
  name: "w-input",
  mixins: [FormElementMixin],
  props: {
    value: { default: "" },
    type: { type: String, default: "text" },
    label: { type: String },
    labelPosition: { type: String, default: "inside" },
    innerIconLeft: { type: String },
    innerIconRight: { type: String },
    staticLabel: { type: Boolean },
    placeholder: { type: String },
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    labelColor: { type: String, default: "primary" },
    progressColor: { type: String },
    minlength: { type: [Number, String] },
    maxlength: { type: [Number, String] },
    step: { type: [Number, String] },
    min: { type: [Number, String] },
    max: { type: [Number, String] },
    dark: { type: Boolean },
    outline: { type: Boolean },
    round: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    multiple: { type: Boolean },
    preview: { type: [Boolean, String], default: true },
    loading: { type: [Boolean, Number], default: false },
    showProgress: { type: [Boolean] },
    files: { type: Array }
  },
  emits: ["input", "update:modelValue", "focus", "blur", "click:inner-icon-left", "click:inner-icon-right", "update:overallProgress"],
  data() {
    return {
      inputValue: this.value,
      inputNumberError: false,
      isFocused: false,
      inputFiles: [],
      fileReader: null,
      isAutofilled: false
    };
  },
  computed: {
    attrs() {
      const { class: classes, ...htmlAttrs } = this.$attrs;
      if (this.type === "file" && !this.inputFiles.length)
        htmlAttrs.value = null;
      return htmlAttrs;
    },
    listeners() {
      const { input, focus, blur, ...listeners } = this.$listeners;
      return listeners;
    },
    hasValue() {
      switch (this.type) {
        case "file":
          return !!this.inputFiles.length;
        case "number":
          return this.inputValue || this.inputValue === 0 || this.inputNumberError;
        case "date":
        case "time":
          return true;
        default:
          return this.inputValue || this.inputValue === 0;
      }
    },
    hasLabel() {
      return this.label || this.$slots.default;
    },
    hasLoading() {
      return ![void 0, false].includes(this.loading);
    },
    loadingValue() {
      let value;
      if (typeof this.loading === "number")
        value = this.loading;
      else if (this.loading) {
        value = this.type === "file" && this.overallFilesProgress ? this.overallFilesProgress : void 0;
      }
      return value;
    },
    showLabelInside() {
      return !this.staticLabel || !this.hasValue && !this.placeholder;
    },
    overallFilesProgress() {
      const progress = +this.inputFiles.reduce((total2, file) => total2 + file.progress, 0);
      const total = progress / this.inputFiles.length;
      this.$emit("update:overallProgress", this.inputFiles.length ? total : 0);
      return total;
    },
    uploadInProgress() {
      return this.overallFilesProgress > 0 && this.overallFilesProgress < 100;
    },
    uploadComplete() {
      return this.overallFilesProgress === 100;
    },
    classes() {
      return {
        "w-input": true,
        "w-input--file": this.type === "file",
        "w-input--disabled": this.isDisabled,
        "w-input--readonly": this.isReadonly,
        [`w-input--${this.hasValue || this.isAutofilled ? "filled" : "empty"}`]: true,
        "w-input--focused": this.isFocused && !this.isReadonly,
        "w-input--dark": this.dark,
        "w-input--floating-label": this.hasLabel && this.labelPosition === "inside" && !this.staticLabel,
        "w-input--no-padding": !this.outline && !this.bgColor && !this.shadow && !this.round,
        "w-input--has-placeholder": this.placeholder,
        "w-input--inner-icon-left": this.innerIconLeft,
        "w-input--inner-icon-right": this.innerIconRight
      };
    },
    inputWrapClasses() {
      return {
        [this.valid === false ? this.validationColor : this.color]: this.color || this.valid === false,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-input__input-wrap--file": this.type === "file",
        "w-input__input-wrap--round": this.round,
        "w-input__input-wrap--tile": this.tile,
        "w-input__input-wrap--box": this.outline || this.bgColor || this.shadow,
        "w-input__input-wrap--underline": !this.outline,
        "w-input__input-wrap--shadow": this.shadow,
        "w-input__input-wrap--no-padding": !this.outline && !this.bgColor && !this.shadow && !this.round,
        "w-input__input-wrap--loading": this.loading || this.showProgress && this.uploadInProgress,
        "w-input__input-wrap--upload-complete": this.uploadComplete
      };
    }
  },
  methods: {
    onInput(e) {
      this.inputNumberError = e.target.validity.badInput;
      this.$emit("update:modelValue", this.inputValue);
      this.$emit("input", this.inputValue);
    },
    onFocus(e) {
      this.isFocused = true;
      this.$emit("focus", e);
    },
    onBlur(e) {
      this.isFocused = false;
      this.$emit("blur", e);
    },
    onFileChange(e) {
      this.$set(this, "inputFiles", [...e.target.files].map((original) => {
        const [, base = "", extension = "", full = ""] = original.name.match(/^(.*?)\.([^.]*)$|(.*)/);
        const file = Object.assign({}, {
          name: original.name,
          base: base || full,
          extension,
          type: original.type,
          size: original.size,
          lastModified: original.lastModified,
          preview: null,
          progress: 0,
          file: original
        });
        this.readFile(original, file);
        return file;
      }));
      const filesPayload = this.multiple ? this.inputFiles : this.inputFiles[0];
      this.$emit("update:modelValue", filesPayload);
      this.$emit("input", filesPayload);
    },
    readFile(original, file) {
      const reader = new FileReader();
      const isPreviewAnIcon = typeof this.preview === "string";
      const isFileAnImage = original.type && original.type.startsWith("image/");
      if (this.preview && !isPreviewAnIcon && isFileAnImage) {
        reader.addEventListener("load", (e) => {
          this.$set(file, "preview", e.target.result);
        });
      } else
        delete file.preview;
      reader.addEventListener("progress", (event) => {
        if (event.loaded && event.total) {
          this.$set(file, "progress", event.loaded * 100 / event.total);
        }
      });
      reader.readAsDataURL(original);
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.input && this.$refs.input.matches(":-webkit-autofill"))
        this.isAutofilled = true;
    }, 400);
  },
  watch: {
    value(value) {
      this.inputValue = value;
      if (!value && value !== 0) {
        this.isAutofilled = false;
        this.inputFiles = [];
      }
    }
  }
};
const __cssModules$w = {};
var __component__$w = /* @__PURE__ */ normalizeComponent(
  __vue2_script$w,
  render$w,
  staticRenderFns$w,
  false,
  __vue2_injectStyles$w,
  null,
  null,
  null
);
function __vue2_injectStyles$w(context) {
  for (let o in __cssModules$w) {
    this[o] = __cssModules$w[o];
  }
}
var wInput = /* @__PURE__ */ function() {
  return __component__$w.exports;
}();
var render$v = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", { staticClass: "w-list", class: _vm.classes }, _vm._l(_vm.listItems, function(li, i) {
    return _c("li", { key: i, staticClass: "w-list__item", class: { "w-list__item--parent": (li.children || []).length } }, [_vm.icon ? _c("w-icon", { staticClass: "w-list__item-bullet" }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e(), _vm.$scopedSlots["item." + (i + 1)] || _vm.$scopedSlots.item || _vm.$scopedSlots.default ? [_vm.checklist ? _c("w-checkbox", _vm._g(_vm._b({ staticClass: "w-list__item-label", nativeOn: { "click": function($event) {
      return _vm.onCheckboxWrapperClick.apply(null, arguments);
    } } }, "w-checkbox", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li)), [_vm.$scopedSlots["item." + (i + 1)] && _vm.$scopedSlots["item." + (i + 1)]() ? _vm._t("item." + (i + 1), null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm.$scopedSlots.item ? _vm._t("item", null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm._t("default", function() {
      return [_vm._v(_vm._s(li._label))];
    }, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected })], 2) : _vm.nav && !li.disabled && li[_vm.itemRouteKey] && _vm.hasRouter ? _c("router-link", _vm._g(_vm._b({ staticClass: "w-list__item-label", nativeOn: { "click": function($event) {
      _vm.$emit("item-select", _vm.cleanLi(li));
    } } }, "router-link", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li)), [_vm.$scopedSlots["item." + (i + 1)] && _vm.$scopedSlots["item." + (i + 1)]() ? _vm._t("item." + (i + 1), null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm.$scopedSlots.item ? _vm._t("item", null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm._t("default", function() {
      return [_vm._v(_vm._s(li._label))];
    }, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected })], 2) : _c(_vm.nav && !li.disabled && li[_vm.itemRouteKey] ? "a" : "div", _vm._g(_vm._b({ tag: "component", staticClass: "w-list__item-label" }, "component", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li)), [_vm.$scopedSlots["item." + (i + 1)] && _vm.$scopedSlots["item." + (i + 1)]() ? _vm._t("item." + (i + 1), null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm.$scopedSlots.item ? _vm._t("item", null, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected }) : _vm._t("default", function() {
      return [_vm._v(_vm._s(li._label))];
    }, { "item": _vm.cleanLi(li), "index": i + 1, "selected": li._selected })], 2)] : [_vm.checklist ? _c("w-checkbox", _vm._g(_vm._b({ staticClass: "w-list__item-label", nativeOn: { "click": function($event) {
      return _vm.onCheckboxWrapperClick.apply(null, arguments);
    } } }, "w-checkbox", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li))) : _vm.nav && !li.disabled && li[_vm.itemRouteKey] && _vm.hasRouter ? _c("router-link", _vm._g(_vm._b({ staticClass: "w-list__item-label", domProps: { "innerHTML": _vm._s(li._label) }, nativeOn: { "click": function($event) {
      _vm.$emit("item-select", _vm.cleanLi(li));
    } } }, "router-link", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li))) : _c(_vm.nav && !li.disabled && li[_vm.itemRouteKey] ? "a" : "div", _vm._g(_vm._b({ tag: "component", staticClass: "w-list__item-label", domProps: { "innerHTML": _vm._s(li._label) } }, "component", _vm.liLabelProps(li, i, li._selected), false), _vm.liLabelEvents(li)))], (li.children || []).length ? _c("w-list", _vm._b({ attrs: { "items": li.children, "depth": _vm.depth + 1 }, on: { "update:model-value": function($event) {
      return _vm.$emit("update:modelValue", $event);
    }, "input": function($event) {
      return _vm.$emit("input", $event);
    }, "item-select": function($event) {
      return _vm.$emit("item-select", $event);
    } }, scopedSlots: _vm._u([_vm.$scopedSlots.item ? { key: "item", fn: function(ref) {
      var item = ref.item;
      var index2 = ref.index;
      var selected = ref.selected;
      return [_vm._t("item", null, { "item": _vm.cleanLi(item), "index": index2, "selected": selected })];
    } } : { key: "default", fn: function(ref) {
      var item = ref.item;
      var index2 = ref.index;
      var selected = ref.selected;
      return [_vm._t("default", function() {
        return [_vm._v(_vm._s(item[_vm.itemLabelKey]))];
      }, { "item": _vm.cleanLi(item), "index": index2, "selected": selected })];
    } }], null, true) }, "w-list", _vm.$props, false)) : _vm._e()], 2);
  }), 0);
};
var staticRenderFns$v = [];
var wList_vue_vue_type_style_index_0_lang = "";
const __vue2_script$v = {
  name: "w-list",
  props: {
    items: { type: [Array, Number], required: true },
    value: {},
    checklist: { type: Boolean },
    roundCheckboxes: { type: Boolean },
    multiple: { type: Boolean },
    addIds: { type: [Boolean, String] },
    hover: { type: Boolean },
    color: { type: String },
    selectionColor: { type: String },
    bgColor: { type: String },
    nav: { type: Boolean },
    icon: { type: String, default: "" },
    itemLabelKey: { type: String, default: "label" },
    itemValueKey: { type: String, default: "value" },
    itemClassKey: { type: String, default: "class" },
    itemColorKey: { type: String, default: "color" },
    itemRouteKey: { type: String, default: "route" },
    itemClass: { type: String },
    depth: { type: Number, default: 0 },
    returnObject: { type: Boolean },
    noUnselect: { type: Boolean },
    arrowsNavigation: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "item-click", "item-select", "keydown:escape", "keydown:enter"],
  data: () => ({
    listItems: []
  }),
  computed: {
    hasRouter() {
      return "$router" in this;
    },
    listId() {
      return this.addIds ? typeof this.addIds === "string" ? this.addIds : `w-list--${this.uid}` : null;
    },
    selectedItems() {
      return this.listItems.filter((item) => item._selected);
    },
    enabledItemsIndexes() {
      return this.listItems.filter((item) => !item.disabled).map((item) => item.index);
    },
    isMultipleSelect() {
      return this.multiple || this.checklist;
    },
    isSelectable() {
      return this.value !== void 0 || this.checklist || this.nav;
    },
    SelectionColor() {
      const selectionColor = this.selectionColor === void 0 ? !this.color && "primary" : this.selectionColor;
      return this.isSelectable && selectionColor;
    },
    classes() {
      return {
        [this.color]: this.color || null,
        [`${this.bgColor}--bg`]: this.bgColor || null,
        "w-list--checklist": this.checklist,
        "w-list--navigation": this.nav,
        "w-list--icon": this.icon,
        [`w-list--child w-list--depth-${this.depth}`]: this.depth
      };
    }
  },
  methods: {
    getItemValue(item) {
      if (item && typeof item === "object") {
        if (item[this.itemValueKey] !== void 0)
          return item[this.itemValueKey];
        else
          return item[this.itemLabelKey] !== void 0 ? item[this.itemLabelKey] : item.index;
      } else
        return item;
    },
    selectItem(item, forcedValue) {
      if (item._selected && !this.multiple && this.noUnselect)
        return;
      item._selected = forcedValue !== void 0 ? forcedValue : !item._selected;
      if (item._selected && !this.isMultipleSelect) {
        this.listItems.forEach((i) => i._index !== item._index && (i._selected = false));
      }
      this.emitSelection();
    },
    liLabelClasses(item) {
      return {
        "w-list__item-label--disabled": item.disabled || this.nav && !item[this.itemRouteKey] && !item.children,
        "w-list__item-label--active": this.isSelectable && item._selected || null,
        "w-list__item-label--focused": item._focused,
        "w-list__item-label--hoverable": this.hover,
        "w-list__item-label--selectable": this.isSelectable,
        [item[this.itemColorKey]]: !!item[this.itemColorKey],
        [this.SelectionColor]: item._selected && !item[this.itemColorKey] && this.SelectionColor,
        [item[this.itemClassKey] || this.itemClass]: item[this.itemClassKey] || this.itemClass
      };
    },
    liLabelProps(li, index2, selected) {
      const props = {
        class: this.liLabelClasses(li),
        tabindex: li.disabled || this.checklist ? null : "0",
        "aria-selected": selected ? "true" : "false",
        id: this.listId ? `${this.listId}_item-${index2 + 1}` : null,
        role: "option"
      };
      if (this.checklist) {
        props.value = li._selected;
        props.color = li[this.itemColorKey] || this.color;
        props.round = this.roundCheckboxes;
        props.disabled = li.disabled;
        const hasSlot = this.$scopedSlots[`item.${index2 + 1}`] || this.$scopedSlots.item;
        if (!hasSlot)
          props.label = li._label || null;
      } else if (this.nav && !li.disabled && li[this.itemRouteKey]) {
        if (this.$router)
          props.to = li[this.itemRouteKey];
        else
          props.href = li[this.itemRouteKey];
      } else if (this.isSelectable && !li.disabled)
        props.tabindex = 0;
      return props;
    },
    liLabelEvents(li) {
      const click = () => {
        if (!li.disabled) {
          const cleanLi = this.cleanLi(li);
          this.$emit("item-click", cleanLi);
          this.$emit("item-select", cleanLi);
        }
      };
      const mousedown = this.isSelectable && ((e) => {
        e.stopPropagation();
        !li.disabled && this.selectItem(li);
      });
      const keydown = this.isSelectable && ((e) => {
        if (!li.disabled && e.keyCode === 13) {
          this.selectItem(li);
          this.$emit("keydown:enter");
          this.$emit("item-select", this.cleanLi(li));
        } else if (e.keyCode === 27)
          this.$emit("keydown:escape");
        else if (this.arrowsNavigation && [38, 40].includes(e.keyCode)) {
          e.preventDefault();
          if (e.keyCode === 38)
            this.focusPrevNextItem(li._index, false);
          if (e.keyCode === 40)
            this.focusPrevNextItem(li._index, true);
        }
      });
      const events = {};
      if (this.nav) {
        if (!li.disabled && li[this.itemRouteKey]) {
          events.keydown = keydown;
          events.mousedown = mousedown;
          if (!this.$router)
            events.click = click;
        }
      } else if (this.checklist) {
        events.focus = () => li._focused = true;
        events.blur = () => li._focused = false;
        events.input = (value) => this.selectItem(li, value);
      } else if (this.isSelectable && !li.disabled) {
        events.click = click;
        events.keydown = keydown;
        events.mousedown = mousedown;
      }
      return events;
    },
    onCheckboxWrapperClick(e) {
      const checkbox = e.target.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.focus();
        checkbox.click();
      }
    },
    checkSelection(items) {
      items = Array.isArray(items) ? items : items ? [items] : [];
      if (this.returnObject)
        items = items.map(this.getItemValue);
      return items;
    },
    emitSelection() {
      const items = this.selectedItems.map((item) => {
        if (!this.returnObject)
          return item._value;
        const { _value, _selected, ...Item } = item;
        return Item;
      });
      const selection = this.isMultipleSelect ? items : items[0] !== void 0 ? items[0] : null;
      this.$emit("update:modelValue", selection);
      this.$emit("input", selection);
    },
    focusPrevNextItem(index2, next = true) {
      index2 = this.enabledItemsIndexes[this.enabledItemsIndexes.indexOf(index2) + (next ? 1 : -1)];
      const firstOrLastIndex = next ? 0 : this.enabledItemsIndexes.length - 1;
      if (index2 === void 0)
        index2 = this.enabledItemsIndexes[firstOrLastIndex];
      this.$el.querySelector(`#${this.listId}_item-${index2 + 1}`).focus();
    },
    cleanLi(li) {
      const { _index, _value, _label, _selected, _focused, ...cleanLi } = li;
      return cleanLi;
    },
    refreshListItems() {
      const items = typeof this.items === "number" ? Array(this.items).fill({}) : this.items || [];
      this.listItems = items.map((item, i) => ({
        ...item,
        _index: i,
        _value: item[this.itemValueKey] === void 0 ? item[this.itemLabelKey] || i : item[this.itemValueKey],
        _selected: item._selected || false,
        _label: item[this.itemLabelKey] || "",
        _focused: false
      }));
    },
    applySelectionOnItems(selection) {
      if (!this.isMultipleSelect)
        this.listItems.forEach((item) => item._selected = false);
      const selectedItems = this.checkSelection(selection);
      this.listItems.forEach((item) => {
        item._selected = selectedItems.find((val) => item._value === val) !== void 0;
      });
    }
  },
  created() {
    this.refreshListItems();
    this.applySelectionOnItems(this.value);
  },
  watch: {
    items() {
      this.refreshListItems();
      this.applySelectionOnItems(this.value);
    },
    value(items) {
      this.applySelectionOnItems(items);
    },
    multiple(boolean) {
      if (!boolean) {
        let firstSelected = null;
        this.listItems.forEach((item) => {
          if (item._selected && !firstSelected)
            firstSelected = item;
          else if (item._selected)
            item._selected = false;
        });
        this.emitSelection();
      }
    }
  }
};
const __cssModules$v = {};
var __component__$v = /* @__PURE__ */ normalizeComponent(
  __vue2_script$v,
  render$v,
  staticRenderFns$v,
  false,
  __vue2_injectStyles$v,
  null,
  null,
  null
);
function __vue2_injectStyles$v(context) {
  for (let o in __cssModules$v) {
    this[o] = __cssModules$v[o];
  }
}
var wList = /* @__PURE__ */ function() {
  return __component__$v.exports;
}();
var DetachableMixin = {
  props: {
    appendTo: { type: [String, Boolean, Object] },
    fixed: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    alignTop: { type: Boolean },
    alignBottom: { type: Boolean },
    alignLeft: { type: Boolean },
    alignRight: { type: Boolean },
    noPosition: { type: Boolean },
    zIndex: { type: [Number, String, Boolean] },
    activator: { type: [String, Object] }
  },
  inject: {
    detachableDefaultRoot: { default: null }
  },
  data: () => ({
    docEventListenersHandlers: [],
    openTimeout: null
  }),
  computed: {
    appendToTarget() {
      let defaultTarget = ".w-app";
      if (typeof this.detachableDefaultRoot === "function") {
        defaultTarget = this.detachableDefaultRoot() || defaultTarget;
      }
      let target = this.appendTo || defaultTarget;
      if (target === true)
        target = defaultTarget;
      else if (this.appendTo === "activator")
        target = this.$el.previousElementSibling;
      else if (target && !["object", "string"].includes(typeof target))
        target = defaultTarget;
      else if (typeof target === "object" && !target.nodeType) {
        target = defaultTarget;
        consoleWarn(`Invalid node provided in ${this.$options.name} \`append-to\`. Falling back to .w-app.`);
      }
      if (typeof target === "string")
        target = document.querySelector(target);
      if (!target) {
        consoleWarn(`Unable to locate ${this.appendTo ? `target ${this.appendTo}` : defaultTarget}`);
        target = document.querySelector(defaultTarget);
      }
      return target;
    },
    detachableParentEl() {
      return this.appendToTarget;
    },
    hasSeparateActivator() {
      var _a;
      if (this.$scopedSlots.activator)
        return false;
      const activatorIsString = typeof this.activator === "string";
      const activatorIsDomEl = (((_a = this.activator) == null ? void 0 : _a.$el) || this.activator) instanceof HTMLElement;
      return activatorIsString || activatorIsDomEl;
    },
    activatorEl: {
      get() {
        var _a;
        if (this.hasSeparateActivator) {
          const activator = ((_a = this.activator) == null ? void 0 : _a.$el) || this.activator;
          if (activator instanceof HTMLElement)
            return activator;
          return document.querySelector(this.activator);
        }
        return this.$el.firstElementChild;
      },
      set() {
      }
    },
    position() {
      return this.top && "top" || this.bottom && "bottom" || this.left && "left" || this.right && "right" || "bottom";
    },
    alignment() {
      return ["top", "bottom"].includes(this.position) && this.alignLeft && "left" || ["top", "bottom"].includes(this.position) && this.alignRight && "right" || ["left", "right"].includes(this.position) && this.alignTop && "top" || ["left", "right"].includes(this.position) && this.alignBottom && "bottom" || "";
    },
    shouldShowOnClick() {
      return this.$options.props.showOnHover && !this.showOnHover || this.$options.props.showOnClick && this.showOnClick;
    }
  },
  methods: {
    async open(e) {
      if (this.delay)
        await new Promise((resolve) => this.openTimeout = setTimeout(resolve, this.delay));
      if (this.delay && !this.openTimeout)
        return;
      this.detachableVisible = true;
      if (this.activator)
        this.activatorEl = e.target;
      await this.insertInDOM();
      if (this.minWidth === "activator")
        this.activatorWidth = this.activatorEl.offsetWidth;
      if (!this.noPosition)
        this.computeDetachableCoords();
      this.timeoutId = setTimeout(() => {
        this.$emit("update:modelValue", true);
        this.$emit("input", true);
        this.$emit("open");
      }, 0);
      if (!this.persistent)
        document.addEventListener("mousedown", this.onOutsideMousedown);
      if (!this.noPosition)
        window.addEventListener("resize", this.onResize);
    },
    getActivatorCoordinates() {
      const { top, left, width, height } = this.activatorEl.getBoundingClientRect();
      let coords = { top, left, width, height };
      if (!this.fixed) {
        const { top: targetTop, left: targetLeft } = this.detachableParentEl.getBoundingClientRect();
        const computedStyles = window.getComputedStyle(this.detachableParentEl, null);
        coords = {
          ...coords,
          top: top - targetTop + this.detachableParentEl.scrollTop - parseInt(computedStyles.getPropertyValue("border-top-width")),
          left: left - targetLeft + this.detachableParentEl.scrollLeft - parseInt(computedStyles.getPropertyValue("border-left-width"))
        };
      }
      return coords;
    },
    computeDetachableCoords() {
      let { top, left, width, height } = this.getActivatorCoordinates();
      if (!this.detachableEl)
        return;
      this.detachableEl.style.visibility = "hidden";
      this.detachableEl.style.display = "flex";
      const computedStyles = window.getComputedStyle(this.detachableEl, null);
      switch (this.position) {
        case "top": {
          top -= this.detachableEl.offsetHeight;
          if (this.alignRight) {
            left += width - this.detachableEl.offsetWidth + parseInt(computedStyles.getPropertyValue("border-right-width"));
          } else if (!this.alignLeft)
            left += (width - this.detachableEl.offsetWidth) / 2;
          break;
        }
        case "bottom": {
          top += height;
          if (this.alignRight) {
            left += width - this.detachableEl.offsetWidth + parseInt(computedStyles.getPropertyValue("border-right-width"));
          } else if (!this.alignLeft)
            left += (width - this.detachableEl.offsetWidth) / 2;
          break;
        }
        case "left": {
          left -= this.detachableEl.offsetWidth;
          if (this.alignBottom)
            top += height - this.detachableEl.offsetHeight;
          else if (!this.alignTop)
            top += (height - this.detachableEl.offsetHeight) / 2;
          break;
        }
        case "right": {
          left += width;
          if (this.alignBottom) {
            top += height - this.detachableEl.offsetHeight + parseInt(computedStyles.getPropertyValue("margin-top"));
          } else if (!this.alignTop) {
            top += (height - this.detachableEl.offsetHeight) / 2 + parseInt(computedStyles.getPropertyValue("margin-top"));
          }
          break;
        }
      }
      this.detachableEl.style.visibility = null;
      if (!this.detachableVisible)
        this.detachableEl.style.display = "none";
      this.detachableCoords = { top, left };
    },
    onResize() {
      if (this.minWidth === "activator")
        this.activatorWidth = this.activatorEl.offsetWidth;
      this.computeDetachableCoords();
    },
    onOutsideMousedown(e) {
      if (!this.detachableEl.contains(e.target) && !this.activatorEl.contains(e.target)) {
        this.$emit("update:modelValue", this.detachableVisible = false);
        this.$emit("input", false);
        this.$emit("close");
        document.removeEventListener("mousedown", this.onOutsideMousedown);
        window.removeEventListener("resize", this.onResize);
      }
    },
    insertInDOM() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          var _a;
          this.detachableEl = ((_a = this.$refs.detachable) == null ? void 0 : _a.$el) || this.$refs.detachable;
          if (this.detachableEl)
            this.appendToTarget.appendChild(this.detachableEl);
          resolve();
        });
      });
    },
    removeFromDOM() {
      document.removeEventListener("mousedown", this.onOutsideMousedown);
      window.removeEventListener("resize", this.onResize);
      if (this.detachableEl && this.detachableEl.parentNode) {
        this.detachableVisible = false;
        this.detachableEl.remove();
        this.detachableEl = null;
      }
    },
    bindActivatorEvents() {
      const activatorIsString = typeof this.activator === "string";
      Object.entries(this.activatorEventHandlers).forEach(([eventName, handler]) => {
        eventName = eventName.replace("mouseenter", "mouseover").replace("mouseleave", "mouseout");
        const handlerWrap = (e) => {
          var _a;
          if (activatorIsString && ((_a = e.target) == null ? void 0 : _a.matches) && e.target.matches(this.activator))
            handler(e);
          else if (e.target === this.activatorEl || this.activatorEl.contains(e.target))
            handler(e);
        };
        document.addEventListener(eventName, handlerWrap);
        this.docEventListenersHandlers.push({ eventName, handler: handlerWrap });
      });
    }
  },
  mounted() {
    var _a;
    const wrapper = this.$el;
    if (this.$scopedSlots.activator)
      wrapper.parentNode.insertBefore(this.activatorEl, wrapper);
    else if (this.activator)
      this.bindActivatorEvents();
    else {
      this.$nextTick(() => {
        if (this.activator)
          this.bindActivatorEvents();
        if (this.value)
          this.open({ target: this.activatorEl });
      });
    }
    if (this.overlay) {
      this.overlayEl = (_a = this.$refs.overlay) == null ? void 0 : _a.$el;
      wrapper.parentNode.insertBefore(this.overlayEl, wrapper);
    }
    if (this.value && this.activator) {
      this.toggle({ type: this.shouldShowOnClick ? "click" : "mouseenter", target: this.activatorEl });
    } else if (this.value)
      this.open({ target: this.activatorEl });
  },
  beforeDestroy() {
    var _a;
    this.close();
    this.removeFromDOM();
    if (this.docEventListenersHandlers.length) {
      this.docEventListenersHandlers.forEach(({ eventName, handler }) => {
        document.removeEventListener(eventName, handler);
      });
    }
    if (this.overlay && this.overlayEl.parentNode)
      this.overlayEl.remove();
    if (((_a = this.activatorEl) == null ? void 0 : _a.parentNode) && this.$scopedSlots.activator)
      this.activatorEl.remove();
  },
  watch: {
    value(bool) {
      if (!!bool !== this.detachableVisible) {
        if (bool)
          this.open({ target: this.activatorEl });
        else
          this.close();
      }
    },
    appendTo() {
      this.removeFromDOM();
      this.insertInDOM();
    }
  }
};
var render$u = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-menu-wrap" }, [_vm._t("activator", null, { "on": _vm.activatorEventHandlers }), _c("transition", { attrs: { "name": _vm.transitionName, "appear": "" } }, [_vm.custom && _vm.detachableVisible ? _c("div", _vm._g({ ref: "detachable", staticClass: "w-menu", class: _vm.classes, style: _vm.styles, on: { "click": function($event) {
    _vm.hideOnMenuClick && _vm.close(true);
  }, "mouseenter": function($event) {
    _vm.showOnHover && (_vm.hoveringMenu = true);
  }, "mouseleave": function($event) {
    _vm.showOnHover && (_vm.hoveringMenu = false, _vm.close());
  } } }, _vm.$listeners), [_vm._t("default")], 2) : _vm.detachableVisible ? _c("w-card", _vm._g({ ref: "detachable", staticClass: "w-menu", class: _vm.classes, style: _vm.styles, attrs: { "tile": _vm.tile, "title-class": _vm.titleClasses, "content-class": _vm.contentClasses, "shadow": _vm.shadow, "no-border": _vm.noBorder }, nativeOn: { "click": function($event) {
    _vm.hideOnMenuClick && _vm.close(true);
  }, "mouseenter": function($event) {
    _vm.showOnHover && (_vm.hoveringMenu = true);
  }, "mouseleave": function($event) {
    _vm.showOnHover && (_vm.hoveringMenu = false, _vm.close());
  } }, scopedSlots: _vm._u([_vm.$slots.title ? { key: "title", fn: function() {
    return [_vm._t("title")];
  }, proxy: true } : null, _vm.$slots.actions ? { key: "actions", fn: function() {
    return [_vm._t("actions")];
  }, proxy: true } : null], null, true) }, _vm.$listeners), [_vm._t("default")], 2) : _vm._e()], 1), _vm.overlay ? _c("w-overlay", _vm._b({ ref: "overlay", class: _vm.overlayClasses, attrs: { "value": _vm.detachableVisible, "persistent": _vm.persistent, "z-index": (_vm.zIndex || 200) - 1 }, on: { "input": function($event) {
    _vm.detachableVisible = false;
  } } }, "w-overlay", _vm.overlayProps, false)) : _vm._e()], 2);
};
var staticRenderFns$u = [];
var wMenu_vue_vue_type_style_index_0_lang = "";
const __vue2_script$u = {
  name: "w-menu",
  mixins: [DetachableMixin],
  inheritAttrs: false,
  props: {
    value: {},
    showOnHover: { type: Boolean },
    hideOnMenuClick: { type: Boolean },
    color: { type: String },
    bgColor: { type: String },
    shadow: { type: Boolean },
    custom: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    noBorder: { type: Boolean },
    transition: { type: String },
    menuClass: { type: [String, Object, Array] },
    titleClass: { type: [String, Object, Array] },
    contentClass: { type: [String, Object, Array] },
    arrow: { type: Boolean },
    minWidth: { type: [Number, String] },
    maxWidth: { type: [Number, String] },
    overlay: { type: Boolean },
    overlayClass: { type: [String, Object, Array] },
    overlayProps: { type: Object },
    persistent: { type: Boolean },
    delay: { type: Number }
  },
  provide() {
    return {
      detachableDefaultRoot: () => {
        var _a;
        return ((_a = this.$refs.detachable) == null ? void 0 : _a.$el) || this.$refs.detachable || null;
      }
    };
  },
  emits: ["input", "update:modelValue", "open", "close"],
  data: () => ({
    detachableVisible: false,
    hoveringActivator: false,
    hoveringMenu: false,
    detachableCoords: {
      top: 0,
      left: 0
    },
    activatorWidth: 0,
    detachableEl: null,
    timeoutId: null
  }),
  computed: {
    transitionName() {
      return this.transition || "scale-fade";
    },
    menuMinWidth() {
      if (this.minWidth === "activator")
        return this.activatorWidth ? `${this.activatorWidth}px` : 0;
      else
        return isNaN(this.minWidth) ? this.minWidth : this.minWidth ? `${this.minWidth}px` : 0;
    },
    menuMaxWidth() {
      if (this.maxWidth === "activator")
        return this.activatorWidth ? `${this.activatorWidth}px` : 0;
      else
        return isNaN(this.maxWidth) ? this.maxWidth : this.maxWidth ? `${this.maxWidth}px` : 0;
    },
    menuClasses() {
      return objectifyClasses(this.menuClass);
    },
    titleClasses() {
      return objectifyClasses(this.titleClass);
    },
    contentClasses() {
      return objectifyClasses(this.contentClass);
    },
    overlayClasses() {
      return {
        ...objectifyClasses(this.overlayClass),
        "w-overlay--no-pointer-event": this.showOnHover
      };
    },
    classes() {
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        ...this.menuClasses,
        [`w-menu--${this.position}`]: !this.noPosition,
        [`w-menu--align-${this.alignment}`]: !this.noPosition && this.alignment,
        "w-menu--tile": this.tile,
        "w-menu--card": !this.custom,
        "w-menu--round": this.round,
        "w-menu--arrow": this.arrow,
        "w-menu--shadow": this.shadow,
        "w-menu--fixed": this.fixed
      };
    },
    styles() {
      return {
        zIndex: this.zIndex || this.zIndex === 0 || this.overlay && !this.zIndex && 200 || null,
        top: this.detachableCoords.top && `${~~this.detachableCoords.top}px` || null,
        left: this.detachableCoords.left && `${~~this.detachableCoords.left}px` || null,
        minWidth: this.minWidth && this.menuMinWidth || null,
        maxWidth: this.maxWidth && this.menuMaxWidth || null,
        "--w-menu-bg-color": this.arrow && (this.$waveui.colors[this.bgColor] || "rgb(var(--w-base-bg-color-rgb))")
      };
    },
    activatorEventHandlers() {
      let handlers = {};
      if (this.showOnHover) {
        handlers = {
          focus: this.toggle,
          blur: this.toggle,
          mouseenter: (e) => {
            this.hoveringActivator = true;
            this.open(e);
          },
          mouseleave: (e) => {
            this.hoveringActivator = false;
            setTimeout(() => {
              if (!this.hoveringMenu)
                this.close();
            }, 10);
          }
        };
        if (typeof window !== "undefined" && "ontouchstart" in window) {
          handlers.click = this.toggle;
        }
      } else
        handlers = { click: this.toggle };
      return handlers;
    }
  },
  methods: {
    toggle(e) {
      let shouldShowMenu = this.detachableVisible;
      if (typeof window !== "undefined" && "ontouchstart" in window && this.showOnHover && e.type === "click") {
        shouldShowMenu = !shouldShowMenu;
      } else if (e.type === "click" && !this.showOnHover)
        shouldShowMenu = !shouldShowMenu;
      else if (e.type === "mouseenter" && this.showOnHover) {
        this.hoveringActivator = true;
        shouldShowMenu = true;
      } else if (e.type === "mouseleave" && this.showOnHover) {
        this.hoveringActivator = false;
        shouldShowMenu = false;
      }
      this.timeoutId = clearTimeout(this.timeoutId);
      if (shouldShowMenu)
        this.open(e);
      else
        this.close();
    },
    async close(force = false) {
      this.openTimeout = clearTimeout(this.openTimeout);
      if (!this.detachableVisible)
        return;
      if (this.showOnHover && !force) {
        await new Promise((resolve) => setTimeout(resolve, 10));
        if (this.showOnHover && (this.hoveringMenu || this.hoveringActivator))
          return;
      }
      this.$emit("update:modelValue", this.detachableVisible = false);
      this.$emit("input", false);
      this.$emit("close");
      document.removeEventListener("mousedown", this.onOutsideMousedown);
      window.removeEventListener("resize", this.onResize);
    }
  }
};
const __cssModules$u = {};
var __component__$u = /* @__PURE__ */ normalizeComponent(
  __vue2_script$u,
  render$u,
  staticRenderFns$u,
  false,
  __vue2_injectStyles$u,
  null,
  null,
  null
);
function __vue2_injectStyles$u(context) {
  for (let o in __cssModules$u) {
    this[o] = __cssModules$u[o];
  }
}
var wMenu = /* @__PURE__ */ function() {
  return __component__$u.exports;
}();
var render$t = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { "name": _vm.transitionName, "appear": "" } }, [_vm.show ? _c("div", { staticClass: "w-notification", class: _vm.classes, style: _vm.styles }, [_c("w-alert", _vm._b({ class: _vm.alertClasses, on: { "input": function($event) {
    _vm.$emit("update:modelValue", false);
    _vm.$emit("input", false);
  } } }, "w-alert", _vm.alertProps, false), [_vm._t("default")], 2)], 1) : _vm._e()]);
};
var staticRenderFns$t = [];
var wNotification_vue_vue_type_style_index_0_lang = "";
const __vue2_script$t = {
  name: "w-notification",
  props: {
    value: { default: true },
    transition: { type: [String, Boolean], default: "" },
    timeout: { type: [Number, String], default: 0 },
    absolute: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    zIndex: { type: [Number, String, Boolean] },
    success: { type: Boolean },
    info: { type: Boolean },
    warning: { type: Boolean },
    error: { type: Boolean },
    color: { type: String },
    bgColor: { type: String },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    plain: { type: Boolean },
    noBorder: { type: Boolean },
    borderLeft: { type: Boolean },
    borderRight: { type: Boolean },
    borderTop: { type: Boolean },
    borderBottom: { type: Boolean },
    outline: { type: Boolean },
    dismiss: { type: Boolean },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "close"],
  data() {
    return {
      show: this.value,
      timeoutId: null
    };
  },
  computed: {
    transitionName() {
      if (this.transition === false)
        return "";
      if (!this.transition) {
        const opposites = { top: "down", bottom: "up", left: "right", right: "left" };
        return `slide-${opposites[this.position[this.position[1] === "center" ? 0 : 1]]}`;
      }
      return this.transition;
    },
    position() {
      let position = [];
      if (!this.top && !this.bottom && !this.left && !this.right)
        position = ["top", "right"];
      else {
        position = [
          this.top && "top" || this.bottom && "bottom" || "top",
          this.left && "left" || this.right && "right" || "center"
        ];
      }
      return position;
    },
    hasType() {
      return !!(this.success || this.info || this.warning || this.error);
    },
    alertProps() {
      return {
        value: this.show,
        success: this.success,
        info: this.info,
        warning: this.warning,
        error: this.error,
        color: this.color,
        bgColor: this.bgColor || !this.hasType && "white" || "",
        shadow: this.shadow,
        tile: this.tile,
        round: this.round,
        plain: this.plain,
        noBorder: this.noBorder,
        borderLeft: this.borderLeft,
        borderRight: this.borderRight,
        borderTop: this.borderTop,
        borderBottom: this.borderBottom,
        outline: this.outline,
        dismiss: this.dismiss,
        xs: this.xs,
        sm: this.sm,
        md: this.md,
        lg: this.lg,
        xl: this.xl
      };
    },
    classes() {
      return {
        "w-notification--absolute": this.absolute,
        [`w-notification--${this.position.join(" w-notification--")}`]: true
      };
    },
    alertClasses() {
      if (this.bgColor || (this.success || this.info || this.warning || this.error) && this.plain)
        return null;
      return "white--bg";
    },
    styles() {
      return {
        zIndex: this.zIndex || this.zIndex === 0 || null
      };
    },
    timeoutVal() {
      return parseInt(this.timeout);
    }
  },
  methods: {
    countdown() {
      this.timeoutId = setTimeout(() => {
        this.$emit("update:modelValue", this.show = false);
        this.$emit("input", false);
        this.$emit("close");
      }, this.timeoutVal);
    }
  },
  created() {
    if (this.value && this.timeoutVal)
      this.countdown();
  },
  watch: {
    value(value) {
      clearTimeout(this.timeoutId);
      this.show = value;
      if (value && this.timeoutVal)
        this.countdown();
    }
  }
};
const __cssModules$t = {};
var __component__$t = /* @__PURE__ */ normalizeComponent(
  __vue2_script$t,
  render$t,
  staticRenderFns$t,
  false,
  __vue2_injectStyles$t,
  null,
  null,
  null
);
function __vue2_injectStyles$t(context) {
  for (let o in __cssModules$t) {
    this[o] = __cssModules$t[o];
  }
}
var wNotification = /* @__PURE__ */ function() {
  return __component__$t.exports;
}();
var render$s = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { "name": "fade", "appear": "" }, on: { "after-leave": _vm.onClose } }, [_vm.showOverlay ? _c("div", { directives: [{ name: "focus", rawName: "v-focus" }], ref: "overlay", staticClass: "w-overlay", class: _vm.classes, style: _vm.styles || null, attrs: { "tabindex": "0" }, on: { "keydown": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "escape", void 0, $event.key, void 0)) {
      return null;
    }
    $event.stopPropagation();
    return _vm.onClick.apply(null, arguments);
  }, "click": _vm.onClick } }, [_vm._t("default")], 2) : _vm._e()]);
};
var staticRenderFns$s = [];
var wOverlay_vue_vue_type_style_index_0_lang = "";
const __vue2_script$s = {
  name: "w-overlay",
  props: {
    value: {},
    opacity: { type: [Number, String, Boolean] },
    bgColor: { type: String },
    absolute: { type: Boolean },
    zIndex: { type: [Number, String, Boolean] },
    persistent: { type: Boolean },
    persistentNoAnimation: { type: Boolean }
  },
  provide() {
    return {
      detachableDefaultRoot: () => this.$refs.overlay || null
    };
  },
  emits: ["input", "update:modelValue", "click", "before-close", "close"],
  data: () => ({
    persistentAnimate: false,
    showOverlay: false
  }),
  computed: {
    backgroundColor() {
      return this.bgColor || this.opacity && `rgba(0, 0, 0, ${this.opacity})` || false;
    },
    classes() {
      return {
        "w-overlay--persistent-animate": this.persistentAnimate,
        "w-overlay--absolute": this.absolute
      };
    },
    styles() {
      return {
        backgroundColor: this.backgroundColor,
        zIndex: this.zIndex || this.zIndex === 0 ? this.zIndex : false
      };
    }
  },
  methods: {
    onClick(e) {
      if (!e.target.classList.contains("w-overlay"))
        return;
      if (this.persistent && !this.persistentNoAnimation) {
        this.persistentAnimate = true;
        setTimeout(() => this.persistentAnimate = false, 150);
      } else if (!this.persistent) {
        this.showOverlay = false;
        this.$emit("before-close");
      }
      this.$emit("click", e);
    },
    onClose() {
      this.$emit("update:modelValue", false);
      this.$emit("input", false);
      this.$emit("close");
    }
  },
  created() {
    this.showOverlay = this.value;
  },
  watch: {
    value(bool) {
      if (this.showOverlay !== bool)
        this.showOverlay = bool;
    }
  }
};
const __cssModules$s = {};
var __component__$s = /* @__PURE__ */ normalizeComponent(
  __vue2_script$s,
  render$s,
  staticRenderFns$s,
  false,
  __vue2_injectStyles$s,
  null,
  null,
  null
);
function __vue2_injectStyles$s(context) {
  for (let o in __cssModules$s) {
    this[o] = __cssModules$s[o];
  }
}
var wOverlay = /* @__PURE__ */ function() {
  return __component__$s.exports;
}();
var render$r = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-parallax" });
};
var staticRenderFns$r = [];
var wParallax_vue_vue_type_style_index_0_lang = "";
const __vue2_script$r = {
  name: "w-parallax",
  props: {},
  emits: [],
  data: () => ({})
};
const __cssModules$r = {};
var __component__$r = /* @__PURE__ */ normalizeComponent(
  __vue2_script$r,
  render$r,
  staticRenderFns$r,
  false,
  __vue2_injectStyles$r,
  null,
  null,
  null
);
function __vue2_injectStyles$r(context) {
  for (let o in __cssModules$r) {
    this[o] = __cssModules$r[o];
  }
}
var wParallax = /* @__PURE__ */ function() {
  return __component__$r.exports;
}();
var render$q = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-progress", class: _vm.classes, style: _vm.styles }, [!_vm.circle ? _c("div", { staticClass: "w-progress__progress", class: { full: _vm.progressValue === 100 }, style: "width: " + _vm.progressValue + "%" }) : _c("svg", { attrs: { "viewBox": _vm.circleCenter / 2 + " " + _vm.circleCenter / 2 + " " + _vm.circleCenter + " " + _vm.circleCenter } }, [_vm.bgColor || this.progressValue > -1 ? _c("circle", { staticClass: "bg", class: _vm.bgColor || null, attrs: { "cx": _vm.circleCenter, "cy": _vm.circleCenter, "r": _vm.circleRadius, "fill": "transparent", "stroke-dasharray": _vm.circleCircumference, "stroke-width": _vm.stroke } }) : _vm._e(), _c("circle", { staticClass: "w-progress__progress", style: "stroke-dashoffset: " + (1 - _vm.progressValue / 100) * _vm.circleCircumference, attrs: { "cx": _vm.circleCenter, "cy": _vm.circleCenter, "r": _vm.circleRadius, "fill": "transparent", "stroke-width": _vm.stroke, "stroke-linecap": _vm.roundCap && "round", "stroke-dasharray": _vm.circleCircumference } })]), _vm.label || _vm.$slots.default ? _c("div", { staticClass: "w-progress__label", class: _vm.labelColor || false }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(Math.round(_vm.progressValue)) + _vm._s(_vm.circle ? "" : "%"))];
  })], 2) : _vm._e()]);
};
var staticRenderFns$q = [];
var wProgress_vue_vue_type_style_index_0_lang = "";
const circleSize = 40;
const circleRadius = circleSize / 2;
const circleCircumference = Math.round(circleSize * 3.14 * 100) / 100;
const __vue2_script$q = {
  name: "w-progress",
  props: {
    value: { type: [Number, String, Boolean], default: -1 },
    label: { type: Boolean },
    roundCap: { type: Boolean },
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    labelColor: { type: String },
    size: { type: [Number, String] },
    circle: { type: Boolean },
    stroke: { type: [Number, String], default: 4 },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    outline: { type: Boolean },
    stripes: { type: Boolean },
    absolute: { type: Boolean },
    fixed: { type: Boolean },
    top: { type: Boolean },
    bottom: { type: Boolean },
    zIndex: { type: [Number, String, Boolean] }
  },
  emits: [],
  data: () => ({
    circleSize,
    circleRadius,
    circleCircumference
  }),
  computed: {
    progressValue() {
      return parseFloat(this.value);
    },
    circleCenter() {
      return circleSize + this.stroke;
    },
    forcedSize() {
      return this.size && (!isNaN(this.size) ? `${this.size}px` : this.size);
    },
    position() {
      return this.top && "top" || this.bottom && "bottom" || "top";
    },
    classes() {
      return {
        [`w-progress--${this.circle ? "circular" : "linear"}`]: true,
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor && !this.circle,
        [`w-progress--${this.position}`]: !this.circle && (this.absolute || this.fixed),
        "w-progress--default-bg": !this.bgColor,
        "w-progress--indeterminate": this.value === -1,
        "w-progress--outline": !this.circle && this.outline,
        "w-progress--tile": !this.circle && this.tile,
        "w-progress--stripes": !this.circle && this.stripes,
        "w-progress--round": !this.circle && this.round,
        "w-progress--shadow": this.shadow,
        "w-progress--absolute": !this.circle && this.absolute,
        "w-progress--fixed": !this.circle && !this.absolute && this.fixed,
        [`w-progress--${this.roundCap ? "round" : "flat"}-cap`]: true
      };
    },
    styles() {
      return {
        [this.circle ? "width" : "height"]: this.forcedSize || null
      };
    }
  }
};
const __cssModules$q = {};
var __component__$q = /* @__PURE__ */ normalizeComponent(
  __vue2_script$q,
  render$q,
  staticRenderFns$q,
  false,
  __vue2_injectStyles$q,
  null,
  null,
  null
);
function __vue2_injectStyles$q(context) {
  for (let o in __cssModules$q) {
    this[o] = __cssModules$q[o];
  }
}
var wProgress = /* @__PURE__ */ function() {
  return __component__$q.exports;
}();
var render$p = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister && !_vm.wRadios ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.inputValue = null);
    _vm.$emit("input", null);
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.inputValue, disabled: _vm.isDisabled, readonly: _vm.isReadonly }, false), [_c("input", { ref: "input", attrs: { "id": "w-radio--" + _vm._uid, "type": "radio", "name": _vm.inputName, "disabled": _vm.isDisabled || _vm.isReadonly || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null, "aria-checked": _vm.inputValue || "false", "role": "radio" }, domProps: { "checked": _vm.inputValue || null }, on: { "focus": function($event) {
    return _vm.$emit("focus", $event);
  }, "change": function($event) {
    _vm.onInput($event);
  } } }), _vm.hasLabel && _vm.labelOnLeft ? [_vm.$slots.default ? _c("label", { staticClass: "w-radio__label w-form-el-shakable pr2", class: _vm.labelClasses, attrs: { "for": "w-radio--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm.label ? _c("label", { staticClass: "w-radio__label w-form-el-shakable pr2", class: _vm.labelClasses, attrs: { "for": "w-radio--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.label) } }) : _vm._e()] : _vm._e(), _c("div", { staticClass: "w-radio__input", class: this.color, on: { "click": function($event) {
    _vm.$refs.input.focus();
    _vm.$refs.input.click();
  } } }), _vm.hasLabel && !_vm.labelOnLeft ? [_vm.$slots.default ? _c("label", { staticClass: "w-radio__label w-form-el-shakable pl2", class: _vm.labelClasses, attrs: { "for": "w-radio--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm.label ? _c("label", { staticClass: "w-radio__label w-form-el-shakable pl2", class: _vm.labelClasses, attrs: { "for": "w-radio--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.label) } }) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns$p = [];
var wRadio_vue_vue_type_style_index_0_lang = "";
const __vue2_script$p = {
  name: "w-radio",
  mixins: [FormElementMixin],
  inject: { wRadios: { default: null } },
  props: {
    value: { default: false },
    returnValue: {},
    label: { type: String },
    labelOnLeft: { type: Boolean },
    color: { type: String, default: "primary" },
    labelColor: { type: String, default: "primary" },
    noRipple: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "focus"],
  data: () => ({
    inputValue: false,
    ripple: {
      start: false,
      end: false,
      timeout: null
    }
  }),
  computed: {
    hasLabel() {
      return this.$slots.default && this.$slots.default.length || this.label;
    },
    classes() {
      return {
        [`w-radio w-radio--${this.inputValue ? "checked" : "unchecked"}`]: true,
        "w-radio--disabled": this.isDisabled,
        "w-radio--readonly": this.isReadonly,
        "w-radio--ripple": this.ripple.start,
        "w-radio--rippled": this.ripple.end
      };
    }
  },
  methods: {
    toggleFromOutside() {
      this.inputValue = this.returnValue !== void 0 ? this.returnValue === this.value : this.value;
    },
    onInput(e) {
      this.inputValue = e.target.checked;
      const returnValue = this.inputValue && this.returnValue !== void 0 ? this.returnValue : this.inputValue;
      this.$emit("update:modelValue", returnValue);
      this.$emit("input", returnValue);
      if (!this.noRipple) {
        if (this.inputValue) {
          this.ripple.start = true;
          this.ripple.timeout = setTimeout(() => {
            this.ripple.start = false;
            this.ripple.end = true;
            setTimeout(() => this.ripple.end = false, 100);
          }, 700);
        } else {
          this.ripple.start = false;
          clearTimeout(this.ripple.timeout);
        }
      }
    }
  },
  created() {
    if (this.value !== void 0)
      this.toggleFromOutside();
  },
  watch: {
    value() {
      this.toggleFromOutside();
    }
  }
};
const __cssModules$p = {};
var __component__$p = /* @__PURE__ */ normalizeComponent(
  __vue2_script$p,
  render$p,
  staticRenderFns$p,
  false,
  __vue2_injectStyles$p,
  null,
  null,
  null
);
function __vue2_injectStyles$p(context) {
  for (let o in __cssModules$p) {
    this[o] = __cssModules$p[o];
  }
}
var wRadio = /* @__PURE__ */ function() {
  return __component__$p.exports;
}();
var render$o = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid, "column": !_vm.inline, "wrap": _vm.inline }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.inputValue = null);
    _vm.$emit("input", null);
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.inputValue, disabled: _vm.isDisabled }, false), _vm._l(_vm.radioItems, function(item, i) {
    return _c("w-radio", _vm._b({ key: i, class: { mt1: !_vm.inline && i }, attrs: { "name": _vm.inputName, "value": item.value === _vm.value, "disabled": _vm.isDisabled || null, "readonly": _vm.isReadonly || null }, on: { "input": function($event) {
      return _vm.onInput(item);
    }, "focus": function($event) {
      return _vm.$emit("focus", $event);
    } } }, "w-radio", { label: item.label, color: item.color, labelOnLeft: _vm.labelOnLeft, labelColor: _vm.labelColor }, false), [_vm.$scopedSlots["item." + (i + 1)] || _vm.$scopedSlots.item ? _vm._t(_vm.$scopedSlots["item." + (i + 1)] ? "item." + (i + 1) : "item", null, { "item": _vm.getOriginalItem(item), "index": i + 1, "checked": item.value === _vm.value }) : _vm._e()], 2);
  }), 1);
};
var staticRenderFns$o = [];
var wRadios_vue_vue_type_style_index_0_lang = "";
const __vue2_script$o = {
  name: "w-radios",
  mixins: [FormElementMixin],
  props: {
    items: { type: Array, required: true },
    value: { type: [String, Number, Boolean] },
    labelOnLeft: { type: Boolean },
    itemLabelKey: { type: String, default: "label" },
    itemValueKey: { type: String, default: "value" },
    itemColorKey: { type: String, default: "color" },
    inline: { type: Boolean },
    color: { type: String, default: "primary" },
    labelColor: { type: String, default: "primary" }
  },
  emits: ["input", "update:modelValue", "focus"],
  provide() {
    return { wRadios: true };
  },
  data: () => ({
    inputValue: null
  }),
  computed: {
    radioItems() {
      return (this.items || []).map((item, i) => ({
        ...item,
        _index: i,
        label: item[this.itemLabelKey],
        value: item[this.itemValueKey] === void 0 ? item[this.itemLabelKey] || i : item[this.itemValueKey],
        color: item[this.itemColorKey] || this.color
      }));
    },
    classes() {
      return [
        "w-radios",
        `w-radios--${this.inline ? "inline" : "column"}`
      ];
    }
  },
  methods: {
    onInput(item) {
      this.inputValue = true;
      this.$emit("update:modelValue", item.value);
      this.$emit("input", item.value);
    },
    getOriginalItem(item) {
      return this.items[item._index];
    }
  }
};
const __cssModules$o = {};
var __component__$o = /* @__PURE__ */ normalizeComponent(
  __vue2_script$o,
  render$o,
  staticRenderFns$o,
  false,
  __vue2_injectStyles$o,
  null,
  null,
  null
);
function __vue2_injectStyles$o(context) {
  for (let o in __cssModules$o) {
    this[o] = __cssModules$o[o];
  }
}
var wRadios = /* @__PURE__ */ function() {
  return __component__$o.exports;
}();
var render$n = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.rating = null);
    _vm.$emit("input", null);
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.rating, disabled: _vm.isDisabled, readonly: _vm.isReadonly }, false), [_c("input", { attrs: { "id": _vm.inputName, "name": _vm.inputName, "type": "hidden" }, domProps: { "value": _vm.rating } }), _vm._l(_vm.max, function(i) {
    return [_vm.$scopedSlots.item ? _vm._t("item", null, { "index": i + 1 }) : _vm._e(), _c("button", { key: i, staticClass: "w-rating__button", class: _vm.buttonClasses(i), attrs: { "disabled": _vm.isDisabled || _vm.isReadonly, "type": "button", "tabindex": i === 1 ? 0 : -1 }, on: { "mouseenter": function($event) {
      _vm.hover = i;
    }, "mouseleave": function($event) {
      _vm.hover = 0;
    }, "click": function($event) {
      return _vm.onButtonClick(i);
    }, "focus": _vm.onFocus, "blur": _vm.onBlur, "keydown": _vm.onKeydown } }, [i - 1 === ~~_vm.rating && _vm.rating - ~~_vm.rating ? _c("i", { staticClass: "w-icon", class: _vm.icon + " " + _vm.color, style: _vm.halfStarStyle, attrs: { "role": "icon", "aria-hidden": "true" } }) : _vm._e()])];
  })], 2);
};
var staticRenderFns$n = [];
var wRating_vue_vue_type_style_index_0_lang = "";
const __vue2_script$n = {
  name: "w-rating",
  mixins: [FormElementMixin],
  props: {
    value: {},
    max: { type: [Number, String], default: 5 },
    color: { type: String, default: "primary" },
    bgColor: { type: String, default: "grey-light4" },
    icon: { type: String, default: "wi-star" },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    noRipple: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "focus", "blur"],
  data() {
    return {
      rating: parseFloat(this.value || 0),
      hover: 0,
      hasFocus: 0,
      ripple: {
        start: false,
        end: false,
        timeout: null
      }
    };
  },
  computed: {
    size() {
      return this.xs && "xs" || this.sm && "sm" || this.lg && "lg" || this.xl && "xl" || "md";
    },
    classes() {
      return {
        "w-rating": true,
        "w-rating--focus": this.hasFocus,
        "w-rating--hover": this.hover,
        "w-rating--disabled": this.isDisabled,
        "w-rating--readonly": this.isReadonly,
        "w-rating--ripple": this.ripple.start,
        "w-rating--rippled": this.ripple.end
      };
    },
    halfStarStyle() {
      return {
        width: this.hover <= ~~this.rating && `${(this.rating - ~~this.rating) * 100}%`
      };
    }
  },
  methods: {
    onButtonClick(i) {
      this.rating = i;
      this.$emit("update:modelValue", this.rating);
      this.$emit("input", this.rating);
      if (!this.noRipple) {
        this.ripple.start = true;
        this.ripple.timeout = setTimeout(() => {
          this.ripple.start = false;
          this.ripple.end = true;
          setTimeout(() => this.ripple.end = false, 100);
        }, 700);
      }
    },
    onFocus(e) {
      this.hasFocus = true;
      this.$emit("focus", e);
    },
    onBlur(e) {
      this.hasFocus = false;
      this.$emit("blur", e);
    },
    onKeydown(e) {
      if ([37, 38, 39, 40].includes(e.keyCode)) {
        if ([39, 40].includes(e.keyCode))
          this.rating <= this.max - 1 && this.rating++;
        else if (this.rating > 1)
          this.rating--;
        const sibling = this.$el.querySelectorAll("button")[this.rating - 1];
        if (sibling) {
          sibling.focus();
          sibling.click();
        }
        e.preventDefault();
      }
    },
    buttonClasses(i) {
      const isHalf = i - 1 === ~~this.rating && this.rating - ~~this.rating;
      const isOn = this.hover >= i || !isHalf && this.hover === 0 && this.rating >= i;
      return {
        "w-rating__button--on": isOn,
        "w-rating__button--half": isHalf,
        [this.icon]: true,
        [`size--${this.size}`]: true,
        [this.color]: isOn,
        [this.bgColor]: this.bgColor && !isOn
      };
    }
  },
  watch: {
    value(value) {
      this.rating = parseFloat(value);
    }
  }
};
const __cssModules$n = {};
var __component__$n = /* @__PURE__ */ normalizeComponent(
  __vue2_script$n,
  render$n,
  staticRenderFns$n,
  false,
  __vue2_injectStyles$n,
  null,
  null,
  null
);
function __vue2_injectStyles$n(context) {
  for (let o in __cssModules$n) {
    this[o] = __cssModules$n[o];
  }
}
var wRating = /* @__PURE__ */ function() {
  return __component__$n.exports;
}();
var render$m = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", _vm._b({ ref: "scrollable", staticClass: "w-scrollable", class: _vm.scrollableClasses, style: _vm.scrollableStyles, on: { "mouseenter": _vm.onMouseEnter, "mouseleave": _vm.onMouseLeave, "mousewheel": _vm.onMouseWheel } }, "div", _vm.$attrs, false), [_vm._t("default"), _c("div", { ref: "track", staticClass: "w-scrollbar", class: _vm.scrollbarClasses, on: { "mousedown": _vm.onTrackMouseDown } }, [_c("div", { ref: "thumb", staticClass: "w-scrollbar__thumb", style: _vm.thumbStyles })])], 2);
};
var staticRenderFns$m = [];
var wScrollable_vue_vue_type_style_index_0_lang = "";
const domProps = {
  h: {
    horizOrVert: "horizontal",
    topOrLeft: "left",
    widthOrHeight: "width",
    offsetWidthOrHeight: "offsetWidth",
    maxWidthOrHeight: "max-width",
    scrollWidthOrHeight: "scrollWidth",
    clientXorY: "clientX",
    deltaXorY: "deltaX",
    scrollTopOrLeft: "scrollLeft"
  },
  v: {
    horizOrVert: "vertical",
    topOrLeft: "top",
    widthOrHeight: "height",
    offsetWidthOrHeight: "offsetHeight",
    maxWidthOrHeight: "max-height",
    scrollWidthOrHeight: "scrollHeight",
    clientXorY: "clientY",
    deltaXorY: "deltaY",
    scrollTopOrLeft: "scrollTop"
  }
};
const __vue2_script$m = {
  name: "w-scrollable",
  props: {
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    width: { type: [Number, String] },
    height: { type: [Number, String] }
  },
  emits: [],
  data: () => ({
    mounted: false,
    scrollable: {
      top: null,
      left: null,
      hovered: false
    },
    scrollValuePercent: 0
  }),
  computed: {
    isHorizontal() {
      var _a, _b, _c, _d;
      if (!this.mounted)
        return false;
      console.log("\u{1F482}\u200D\u2642\uFE0F", (_a = this.$refs.scrollable) == null ? void 0 : _a.scrollWidth, (_b = this.$refs.scrollable) == null ? void 0 : _b.offsetWidth);
      return this.width && !this.height || ((_c = this.$refs.scrollable) == null ? void 0 : _c.scrollWidth) > ((_d = this.$refs.scrollable) == null ? void 0 : _d.offsetWidth);
    },
    m() {
      return domProps[this.isHorizontal ? "h" : "v"];
    },
    scrollableClasses() {
      return {
        [`w-scrollable--${this.m.horizOrVert}`]: true
      };
    },
    scrollbarClasses() {
      return {
        [`w-scrollbar--${this.m.horizOrVert}`]: true
      };
    },
    thumbSizePercent() {
      var _a, _b;
      if (!this.mounted)
        return 0;
      console.log("\u{1F612}", this[this.m.widthOrHeight], this.$refs.scrollable[[this.m.offsetWidthOrHeight]]);
      const widthOrHeight = (_a = this[this.m.widthOrHeight]) != null ? _a : this.$refs.scrollable[[this.m.offsetWidthOrHeight]];
      return widthOrHeight * 100 / ((_b = this.$refs.scrollable) == null ? void 0 : _b[this.m.scrollWidthOrHeight]) || 0;
    },
    scrollableStyles() {
      return {
        [this.m.maxWidthOrHeight]: `${this[this.m.widthOrHeight]}px`
      };
    },
    thumbStyles() {
      let topOrLeftValue = this.scrollValuePercent;
      topOrLeftValue = Math.max(0, Math.min(topOrLeftValue, 100 - this.thumbSizePercent));
      return {
        [this.m.widthOrHeight]: `${this.thumbSizePercent}%`,
        [this.m.topOrLeft]: `${topOrLeftValue}%`
      };
    }
  },
  methods: {
    onTrackMouseDown(e) {
      if (this.isDisabled || this.isReadonly)
        return;
      if ("ontouchstart" in window && e.type === "mousedown")
        return;
      const { top, left, width, height } = this.$refs.track.getBoundingClientRect();
      if (this.isHorizontal) {
        this.$refs.track.width = width;
        this.$refs.track.left = left;
      } else {
        this.$refs.track.height = height;
        this.$refs.track.top = top;
      }
      this.dragging = true;
      this.computeScroll(e.type === "touchstart" ? e.touches[0][this.m.clientXorY] : e[this.m.clientXorY]);
      this.scroll();
      document.addEventListener(e.type === "touchstart" ? "touchmove" : "mousemove", this.onDrag);
      document.addEventListener(e.type === "touchstart" ? "touchend" : "mouseup", this.onMouseUp, { once: true });
    },
    onDrag(e) {
      this.computeScroll(e.type === "touchmove" ? e.touches[0][this.m.clientXorY] : e[this.m.clientXorY]);
      this.scroll();
    },
    onMouseUp(e) {
      this.dragging = false;
      document.removeEventListener(e.type === "touchend" ? "touchmove" : "mousemove", this.onDrag);
      if (this.$refs.thumb)
        this.$refs.thumb.focus();
    },
    onMouseEnter() {
      this.scrollable.hovered = true;
    },
    onMouseLeave() {
      this.scrollable.hovered = false;
    },
    onMouseWheel(e) {
      if (!this.scrollable.hovered)
        return;
      if (this.scrollValuePercent <= 0 && e[this.m.deltaXorY] < 0)
        return;
      else if (this.scrollValuePercent >= 100 - this.thumbSizePercent && e[this.m.deltaXorY] > 0)
        return;
      e.preventDefault();
      this.scrollValuePercent += e[this.m.deltaXorY] * 0.05;
      this.scrollValuePercent = Math.max(0, Math.min(this.scrollValuePercent, 100));
      this.scroll();
    },
    computeScroll(cursorPositionXorY) {
      const { top, left, width, height } = this.$refs.scrollable.getBoundingClientRect();
      const topOrLeft = this.isHorizontal ? left : top;
      const widthOrHeight = this.isHorizontal ? width : height;
      this.scrollValuePercent = Math.max(0, Math.min((cursorPositionXorY - topOrLeft) / widthOrHeight * 100, 100));
    },
    scroll() {
      var _a;
      this.$refs.scrollable[this.m.scrollTopOrLeft] = this.scrollValuePercent * ((_a = this.$refs.scrollable) == null ? void 0 : _a[this.m.scrollWidthOrHeight]) / 100;
      this.updateThumbPosition();
    },
    updateThumbPosition() {
      this.$refs.thumb.style[this.m.topOrLeft] = this.scrollValuePercent;
    }
  },
  mounted() {
    this.mounted = true;
    const { top, left } = this.$refs.scrollable.getBoundingClientRect();
    this.scrollable.top = top;
    this.scrollable.left = left;
    this.$el.parentNode.style.position = "relative";
    this.$el.parentNode.style[this.m.maxWidthOrHeight] = `${this[this.m.widthOrHeight]}px`;
  }
};
const __cssModules$m = {};
var __component__$m = /* @__PURE__ */ normalizeComponent(
  __vue2_script$m,
  render$m,
  staticRenderFns$m,
  false,
  __vue2_injectStyles$m,
  null,
  null,
  null
);
function __vue2_injectStyles$m(context) {
  for (let o in __cssModules$m) {
    this[o] = __cssModules$m[o];
  }
}
var wScrollable = /* @__PURE__ */ function() {
  return __component__$m.exports;
}();
var render$l = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid, "wrap": _vm.hasLabel && _vm.labelPosition !== "inside" }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": _vm.onReset } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.selectionString, disabled: _vm.isDisabled, readonly: _vm.isReadonly, isFocused: _vm.isFocused }, false), [_vm.labelPosition === "left" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-select__label w-select__label--left w-form-el-shakable", class: _vm.labelClasses, on: { "click": function($event) {
    return _vm.$refs["selection-input"].click();
  } } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e(), _c("w-menu", _vm._b({ attrs: { "menu-class": "w-select__menu " + (_vm.menuClass || ""), "transition": "slide-fade-down", "append-to": (_vm.menuProps || {}).appendTo !== void 0 ? (_vm.menuProps || {}).appendTo : void 0, "align-left": "", "custom": "", "min-width": "activator" }, on: { "close": _vm.closeMenu }, scopedSlots: _vm._u([{ key: "activator", fn: function() {
    return [_c("div", { staticClass: "w-select__selection-wrap", class: _vm.inputWrapClasses, attrs: { "role": "button", "aria-haspopup": "listbox", "aria-expanded": _vm.showMenu ? "true" : "false", "aria-owns": "w-select-menu--" + _vm._uid, "aria-activedescendant": "w-select-menu--" + _vm._uid + "_item-1" }, on: { "click": function($event) {
      !_vm.isDisabled && !_vm.isReadonly && _vm.onInputFieldClick();
    } } }, [_vm.innerIconLeft ? _c("w-icon", { staticClass: "w-select__icon w-select__icon--inner-left", attrs: { "tag": "label" }, on: { "click": function($event) {
      return _vm.$emit("click:inner-icon-left", $event);
    } } }, [_vm._v(_vm._s(_vm.innerIconLeft))]) : _vm._e(), _vm.$scopedSlots.selection ? _c("div", { staticClass: "w-select__selection-slot" }, [_vm._t("selection", null, { "item": _vm.multiple ? _vm.inputValue : _vm.inputValue[0] })], 2) : _vm._e(), _c("div", _vm._b({ ref: "selection-input", staticClass: "w-select__selection", domProps: { "innerHTML": _vm._s(_vm.selectionHtml) }, on: { "focus": function($event) {
      !_vm.isDisabled && !_vm.isReadonly && _vm.onFocus($event);
    }, "blur": _vm.onBlur, "keydown": function($event) {
      !_vm.isDisabled && !_vm.isReadonly && _vm.onKeydown($event);
    } } }, "div", _vm.selectionAttributes, false)), _vm._l(_vm.inputValue.length ? _vm.inputValue : [{}], function(val, i) {
      return _c("input", { key: i, attrs: { "type": "hidden", "name": _vm.inputName + (_vm.multiple ? "[]" : "") }, domProps: { "value": val.value === void 0 ? "" : val.value.toString() } });
    }), _vm.labelPosition === "inside" && _vm.showLabelInside ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-select__label w-select__label--inside w-form-el-shakable", class: _vm.labelClasses }, [_vm._t("default", function() {
      return [_vm._v(_vm._s(_vm.label))];
    })], 2) : _vm._e()] : _vm._e(), _vm.innerIconRight ? _c("w-icon", { staticClass: "w-select__icon w-select__icon--inner-right", attrs: { "tag": "label" }, on: { "click": function($event) {
      return _vm.$emit("click:inner-icon-right", $event);
    } } }, [_vm._v(_vm._s(_vm.innerIconRight))]) : _vm._e()], 2)];
  }, proxy: true }], null, true), model: { value: _vm.showMenu, callback: function($$v) {
    _vm.showMenu = $$v;
  }, expression: "showMenu" } }, "w-menu", _vm.menuProps || {}, false), [_c("w-list", { ref: "w-list", attrs: { "value": _vm.inputValue, "items": _vm.selectItems, "multiple": _vm.multiple, "arrows-navigation": "", "return-object": "", "no-unselect": _vm.noUnselect, "selection-color": _vm.selectionColor, "add-ids": "w-select-menu--" + _vm._uid, "item-color-key": _vm.itemColorKey, "role": "listbox", "tabindex": "-1" }, on: { "input": _vm.onInput, "item-click": function($event) {
    return _vm.$emit("item-click", $event);
  }, "item-select": _vm.onListItemSelect, "keydown:enter": function($event) {
    _vm.noUnselect && !_vm.multiple && _vm.closeMenu();
  }, "keydown:escape": function($event) {
    _vm.showMenu && (_vm.showMenu = false);
  } }, nativeOn: { "keydown": function($event) {
    return _vm.onWListKeydown.apply(null, arguments);
  } }, scopedSlots: _vm._u([_vm._l(_vm.items.length, function(i) {
    return { key: "item." + i, fn: function(ref) {
      var item = ref.item;
      var selected = ref.selected;
      var index2 = ref.index;
      return [_vm.$scopedSlots["item." + i] ? _vm._t("item." + i, function() {
        return [_vm._v(_vm._s(item[_vm.itemLabelKey]))];
      }, { "item": item, "selected": selected, "index": index2 }) : _vm._e()];
    } };
  }), { key: "item", fn: function(ref) {
    var item = ref.item;
    var selected = ref.selected;
    var index2 = ref.index;
    return [_vm._t("item", function() {
      return [_vm._v(_vm._s(item[_vm.itemLabelKey]))];
    }, { "item": item, "selected": selected, "index": index2 })];
  } }], null, true) })], 1), _vm.labelPosition === "right" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-select__label w-select__label--right w-form-el-shakable", class: _vm.labelClasses, on: { "click": function($event) {
    return _vm.$refs["selection-input"].click();
  } } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns$l = [];
var wSelect_vue_vue_type_style_index_0_lang = "";
const __vue2_script$l = {
  name: "w-select",
  mixins: [FormElementMixin],
  props: {
    items: { type: Array, required: true },
    value: {},
    multiple: { type: Boolean },
    placeholder: { type: String },
    label: { type: String },
    labelPosition: { type: String, default: "inside" },
    innerIconLeft: { type: String },
    innerIconRight: { type: String, default: "wi-triangle-down" },
    staticLabel: { type: Boolean },
    itemLabelKey: { type: String, default: "label" },
    itemColorKey: { type: String, default: "color" },
    itemValueKey: { type: String, default: "value" },
    itemClass: { type: String },
    menuClass: { type: String },
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    labelColor: { type: String, default: "primary" },
    selectionColor: { type: String, default: "primary" },
    outline: { type: Boolean },
    round: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    dark: { type: Boolean },
    returnObject: { type: Boolean },
    noUnselect: { type: Boolean },
    menuProps: { type: Object },
    fitToContent: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "focus", "blur", "item-click", "item-select", "click:inner-icon-left", "click:inner-icon-right"],
  data: () => ({
    inputValue: [],
    showMenu: false,
    menuMinWidth: 0,
    isFocused: false,
    selectionWrapRef: void 0,
    quickLookup: { string: "", timeout: null }
  }),
  computed: {
    selectItems() {
      return this.items.map((item, i) => {
        const obj = { ...item };
        obj.value = obj[this.itemValueKey] === void 0 ? obj[this.itemLabelKey] || i : obj[this.itemValueKey];
        obj.index = i;
        return obj;
      });
    },
    hasLabel() {
      return this.label || this.$slots.default;
    },
    showLabelInside() {
      return !this.staticLabel || !this.inputValue.length && !this.placeholder;
    },
    selectionAttributes() {
      var _a;
      return {
        class: { "w-select__selection--placeholder": !this.$scopedSlots.selection && !this.selectionString && this.placeholder },
        disabled: this.isDisabled || null,
        readonly: true,
        ariareadonly: "true",
        tabindex: (_a = this.tabindex) != null ? _a : null,
        contenteditable: this.isDisabled || this.isReadonly ? "false" : "true"
      };
    },
    selectionString() {
      return this.inputValue.map(
        (item) => {
          var _a;
          return item[this.itemValueKey] !== void 0 ? item[this.itemLabelKey] : (_a = item[this.itemLabelKey]) != null ? _a : item;
        }
      ).join(", ");
    },
    selectionHtml() {
      if (!this.inputValue.length)
        return this.placeholder || "";
      if (this.$scopedSlots.selection)
        return "";
      return this.selectionString;
    },
    classes() {
      return {
        "w-select": true,
        "w-select--disabled": this.isDisabled,
        "w-select--fit-to-content": this.fitToContent,
        "w-select--readonly": this.isReadonly,
        [`w-select--${this.inputValue.length ? "filled" : "empty"}`]: true,
        "w-select--focused": (this.isFocused || this.showMenu) && !this.isReadonly,
        "w-select--dark": this.dark,
        "w-select--floating-label": this.hasLabel && this.labelPosition === "inside" && !this.staticLabel,
        "w-select--no-padding": !this.outline && !this.bgColor && !this.shadow && !this.round,
        "w-select--has-placeholder": this.placeholder,
        "w-select--inner-icon-left": this.innerIconLeft,
        "w-select--inner-icon-right": this.innerIconRight,
        "w-select--open": this.showMenu
      };
    },
    inputWrapClasses() {
      return {
        [this.valid === false ? "error" : this.color]: this.color || this.valid === false,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-select__selection-wrap--round": this.round,
        "w-select__selection-wrap--tile": this.tile,
        "w-select__selection-wrap--box": this.outline || this.bgColor || this.shadow,
        "w-select__selection-wrap--underline": !this.outline,
        "w-select__selection-wrap--shadow": this.shadow,
        "w-select__selection-wrap--no-padding": !this.outline && !this.bgColor && !this.shadow && !this.round
      };
    }
  },
  methods: {
    onFocus(e) {
      if (this.isFocused)
        return;
      this.isFocused = true;
      this.$emit("focus", e);
      return false;
    },
    onBlur(e) {
      if (this.showMenu)
        return;
      this.isFocused = false;
      this.$emit("blur", e);
    },
    onKeydown(e) {
      if (!e.metaKey && !e.ctrlKey && e.keyCode !== 9)
        e.preventDefault();
      if (e.keyCode === 27 && this.showMenu)
        this.closeMenu();
      else if ([13, 32].includes(e.keyCode))
        this.openMenu();
      else if ([38, 40].includes(e.keyCode)) {
        if (this.multiple)
          this.openMenu();
        else {
          let { index: index2 } = this.inputValue[0] || {};
          const items = this.selectItems;
          if (index2 === void 0)
            index2 = e.keyCode === 38 ? items.length - 1 : 0;
          else {
            const direction = e.keyCode === 38 ? -1 : 1;
            index2 = (index2 + items.length + direction) % items.length;
          }
          let allItemsAreDisabled = false;
          if (items[index2].disabled) {
            const direction = e.keyCode === 38 ? -1 : 1;
            let newIndex = (index2 + direction + items.length) % items.length;
            const itemsCount = items.length;
            let loop = 0;
            while (loop < itemsCount && items[newIndex].disabled) {
              newIndex = (newIndex + items.length + direction) % items.length;
              loop++;
            }
            if (loop >= itemsCount)
              allItemsAreDisabled = true;
            index2 = newIndex;
          }
          if (!allItemsAreDisabled)
            this.onInput(items[index2]);
        }
      } else if (e.key.length === 1)
        this.focusItemOnQuickLookup(e);
    },
    onWListKeydown(e) {
      if (e.key.length === 1)
        this.focusItemOnQuickLookup(e);
    },
    focusItemOnQuickLookup(e) {
      var _a, _b, _c;
      if (this.quickLookup.timeout)
        clearTimeout(this.quickLookup.timeout);
      this.quickLookup.timeout = setTimeout(() => this.quickLookup.string = "", 1e3);
      this.quickLookup.string += e.key;
      const re = new RegExp(`^${this.quickLookup.string}`, "i");
      const itemIndexToFocus = this.selectItems.findIndex(
        (item) => !item.disabled && item[this.itemLabelKey].match(re)
      ) + 1;
      if (itemIndexToFocus) {
        const selector = `.w-list__item:nth-child(${itemIndexToFocus}) .w-list__item-label`;
        (_c = (_b = (_a = this.$refs["w-list"]) == null ? void 0 : _a.$el) == null ? void 0 : _b.querySelector(selector)) == null ? void 0 : _c.focus();
      }
    },
    onInput(items) {
      this.inputValue = items === null ? [] : this.multiple ? items : [items];
      items = this.inputValue.map((item) => this.returnObject ? this.items[item.index] : item.value);
      const selection = this.multiple ? items : items[0];
      this.$emit("update:modelValue", selection);
      this.$emit("input", selection);
    },
    onInputFieldClick() {
      if (this.showMenu)
        this.showMenu = false;
      else
        this.openMenu();
    },
    onListItemSelect(e) {
      this.$emit("item-select", e);
      if (!this.multiple)
        this.showMenu = false;
    },
    onReset() {
      this.inputValue = [];
      const selection = this.multiple ? [] : null;
      this.$emit("update:modelValue", selection);
      this.$emit("input", selection);
    },
    checkSelection(items) {
      items = Array.isArray(items) ? items : items !== void 0 ? [items] : [];
      const allValues = this.selectItems.map((item) => item.value);
      return items.map((item) => {
        var _a, _b;
        let value = item;
        if (item && typeof item === "object") {
          value = (_b = (_a = item[this.itemValueKey]) != null ? _a : item[this.itemLabelKey]) != null ? _b : item;
        }
        return this.selectItems[allValues.indexOf(value)];
      }).filter((item) => item !== void 0);
    },
    openMenu() {
      this.showMenu = true;
      setTimeout(() => {
        var _a;
        const itemIndex = this.inputValue.length ? this.inputValue[0].index : 0;
        (_a = this.$refs["w-list"].$el.querySelector(`#w-select-menu--${this._uid}_item-${itemIndex + 1}`)) == null ? void 0 : _a.focus();
      }, 100);
    },
    closeMenu() {
      var _a;
      if (((_a = this.menuProps) == null ? void 0 : _a.hideOnMenuClick) === false)
        return;
      this.showMenu = false;
      setTimeout(() => {
        var _a2;
        return (_a2 = this.$refs["selection-input"]) == null ? void 0 : _a2.focus();
      }, 50);
    }
  },
  created() {
    this.inputValue = this.checkSelection(this.value);
  },
  watch: {
    value(value) {
      if (value !== this.inputValue)
        this.inputValue = this.checkSelection(value);
    },
    items() {
      this.inputValue = this.checkSelection(this.value);
    }
  }
};
const __cssModules$l = {};
var __component__$l = /* @__PURE__ */ normalizeComponent(
  __vue2_script$l,
  render$l,
  staticRenderFns$l,
  false,
  __vue2_injectStyles$l,
  null,
  null,
  null
);
function __vue2_injectStyles$l(context) {
  for (let o in __cssModules$l) {
    this[o] = __cssModules$l[o];
  }
}
var wSelect = /* @__PURE__ */ function() {
  return __component__$l.exports;
}();
var render$k = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.wrapperClasses, attrs: { "valid": _vm.valid, "wrap": _vm.formRegister || null }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.rangeValuePercent = 0;
    _vm.updateRangeValueScaled();
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.rangeValueScaled, disabled: _vm.isDisabled, readonly: _vm.isReadonly }, false), [_vm.$slots["label-left"] ? _c("label", { staticClass: "w-slider__label w-slider__label--left w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "button--" + _vm._uid } }, [_vm._t("label-left")], 2) : _vm.labelLeft ? _c("label", { staticClass: "w-slider__label w-slider__label--left w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "button--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.labelLeft) } }) : _vm._e(), _c("div", { staticClass: "w-slider__track-wrap" }, [_c("div", { ref: "track", staticClass: "w-slider__track", class: _vm.trackClasses, attrs: { "role": "slider", "aria-label": "Slider", "aria-valuemin": _vm.minVal, "aria-valuemax": _vm.maxVal, "aria-valuenow": _vm.rangeValueScaled, "aria-readonly": _vm.isReadonly ? "true" : "false", "aria-orientation": "horizontal" }, on: { "mousedown": _vm.onTrackMouseDown, "touchstart": _vm.onTrackMouseDown } }, [_c("div", { staticClass: "w-slider__range", class: _vm.rangeClasses, style: _vm.rangeStyles }), _c("div", { staticClass: "w-slider__thumb", style: _vm.thumbStyles }, [_c("button", { ref: "thumb", staticClass: "w-slider__thumb-button", class: [_vm.color], attrs: { "id": "button--" + _vm._uid, "name": _vm.inputName, "value": _vm.rangeValueScaled, "disabled": _vm.isDisabled || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "tabindex": _vm.isDisabled || _vm.isReadonly ? -1 : null }, on: { "keydown": [function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "left", 37, $event.key, ["Left", "ArrowLeft"])) {
      return null;
    }
    if ("button" in $event && $event.button !== 0) {
      return null;
    }
    return _vm.onKeyDown($event, -1);
  }, function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "right", 39, $event.key, ["Right", "ArrowRight"])) {
      return null;
    }
    if ("button" in $event && $event.button !== 2) {
      return null;
    }
    return _vm.onKeyDown($event, 1);
  }], "focus": function($event) {
    return _vm.$emit("focus", $event);
  }, "click": function($event) {
    $event.preventDefault();
  } } }), _vm.thumbLabel ? _c("label", { staticClass: "w-slider__thumb-label", class: _vm.thumbClasses, attrs: { "for": "button--" + _vm._uid } }, [_vm.thumbLabel === "droplet" ? _c("div", [_vm._t("label", function() {
    return [_vm._v(_vm._s(~~_vm.rangeValueScaled))];
  }, { "value": _vm.rangeValueScaled })], 2) : _vm._t("label", function() {
    return [_vm._v(_vm._s(~~_vm.rangeValueScaled))];
  }, { "value": _vm.rangeValueScaled })], 2) : _vm._e()])]), _vm.stepLabels && _vm.step ? _c("div", { staticClass: "w-slider__step-labels" }, [_c("div", { staticClass: "w-slider__step-label", on: { "click": function($event) {
    return _vm.onStepLabelClick(0);
  } } }, [_vm._v(_vm._s(this.minVal))]), _vm._l(~~_vm.numberOfSteps, function(currStep) {
    return _c("div", { key: currStep, staticClass: "w-slider__step-label", style: "left: " + currStep * (100 / _vm.numberOfSteps) + "%", on: { "click": function($event) {
      _vm.onStepLabelClick(currStep * (100 / _vm.numberOfSteps));
    } } }, [_vm._v(_vm._s(_vm.percentToScaled(currStep * (100 / _vm.numberOfSteps))))]);
  }), ~~_vm.numberOfSteps !== _vm.numberOfSteps ? _c("div", { staticClass: "w-slider__step-label", staticStyle: { "left": "100%" }, on: { "click": function($event) {
    return _vm.onStepLabelClick(100);
  } } }, [_vm._v(_vm._s(this.maxVal))]) : _vm._e()], 2) : _vm._e()]), _vm.$slots["label-right"] ? _c("label", { staticClass: "w-slider__label w-slider__label--right w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "button--" + _vm._uid } }, [_vm._t("label-right")], 2) : _vm.labelRight ? _c("label", { staticClass: "w-slider__label w-slider__label--right w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "button--" + _vm._uid }, domProps: { "innerHTML": _vm._s(_vm.labelRight) } }) : _vm._e()]);
};
var staticRenderFns$k = [];
var wSlider_vue_vue_type_style_index_0_lang = "";
const __vue2_script$k = {
  name: "w-slider",
  mixins: [FormElementMixin],
  props: {
    value: { type: Number, default: 0 },
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    labelColor: { type: String, default: "primary" },
    stepLabels: { type: [Boolean, Array] },
    thumbLabel: { type: [Boolean, String] },
    thumbLabelClass: { type: String },
    trackClass: { type: String },
    rangeClass: { type: String },
    min: { type: [Number, String], default: 0 },
    max: { type: [Number, String], default: 100 },
    step: { type: [Number, String] },
    labelLeft: { type: String },
    labelRight: { type: String }
  },
  emits: ["input", "update:modelValue", "focus"],
  data: () => ({
    track: {
      el: null,
      left: 0,
      width: 0
    },
    dragging: false,
    rangeValuePercent: 0,
    rangeValueScaled: 0
  }),
  computed: {
    minVal() {
      return parseFloat(this.min);
    },
    maxVal() {
      return parseFloat(this.max);
    },
    stepValPercent() {
      return Math.min(parseFloat(this.step), this.scaledRange) / this.scaledRange * 100;
    },
    scaledRange() {
      return this.maxVal - this.minVal;
    },
    numberOfSteps() {
      return 100 / this.stepValPercent;
    },
    rangeStyles() {
      return {
        width: `${this.rangeValuePercent}%`
      };
    },
    thumbStyles() {
      return {
        left: `${this.rangeValuePercent}%`
      };
    },
    rangeClasses() {
      return {
        [`${this.color}--bg`]: this.color,
        [this.rangeClass]: this.rangeClass || null
      };
    },
    trackClasses() {
      return {
        [`${this.bgColor}--bg`]: this.bgColor,
        [this.trackClass]: this.trackClass || null
      };
    },
    thumbClasses() {
      return {
        [this.thumbLabelClass]: this.thumbLabelClass || null,
        "w-slider__thumb-label--droplet": this.thumbLabel === "droplet"
      };
    },
    wrapperClasses() {
      return {
        "w-slider": true,
        "w-slider--dragging": this.dragging,
        "w-slider--disabled": this.isDisabled,
        "w-slider--readonly": this.isReadonly,
        "w-slider--has-step-labels": this.step && this.stepLabels
      };
    }
  },
  methods: {
    scaledToPercent(value) {
      return Math.max(0, Math.min((value - this.minVal) / this.scaledRange * 100, 100));
    },
    percentToScaled(value) {
      return Math.round((value / 100 * this.scaledRange + this.minVal) * 100) / 100;
    },
    onTrackMouseDown(e) {
      if (this.isDisabled || this.isReadonly)
        return;
      if ("ontouchstart" in window && e.type === "mousedown")
        return;
      const { left, width } = this.track.el.getBoundingClientRect();
      this.track.width = width;
      this.track.left = left;
      this.dragging = true;
      this.updateRange(e.type === "touchstart" ? e.touches[0].clientX : e.clientX);
      document.addEventListener(e.type === "touchstart" ? "touchmove" : "mousemove", this.onDrag);
      document.addEventListener(e.type === "touchstart" ? "touchend" : "mouseup", this.onMouseUp, { once: true });
    },
    onDrag(e) {
      this.updateRange(e.type === "touchmove" ? e.touches[0].clientX : e.clientX);
    },
    onMouseUp(e) {
      this.dragging = false;
      document.removeEventListener(e.type === "touchend" ? "touchmove" : "mousemove", this.onDrag);
      if (this.$refs.thumb)
        this.$refs.thumb.focus();
    },
    onStepLabelClick(step) {
      this.rangeValuePercent = step;
      this.updateRangeValueScaled();
    },
    onKeyDown(e, direction) {
      if (this.isDisabled || this.isReadonly)
        return;
      this.rangeValuePercent += direction * (e.shiftKey ? 5 : 1) * (this.stepValPercent || 1);
      this.rangeValuePercent = Math.max(0, Math.min(this.rangeValuePercent, 100));
      this.updateRangeValueScaled();
    },
    updateRange(cursorPositionX) {
      this.rangeValuePercent = Math.max(0, Math.min((cursorPositionX - this.track.left) / this.track.width * 100, 100));
      if (this.step) {
        const valuePlusHalfStep = this.rangeValuePercent + this.stepValPercent / 2;
        this.rangeValuePercent = valuePlusHalfStep - valuePlusHalfStep % this.stepValPercent;
      }
      this.updateRangeValueScaled();
    },
    updateRangeValueScaled() {
      this.rangeValueScaled = this.percentToScaled(this.rangeValuePercent);
      this.$emit("update:modelValue", this.rangeValueScaled);
      this.$emit("input", this.rangeValueScaled);
    }
  },
  beforeMount() {
    this.$nextTick(() => {
      this.track.el = this.$refs.track;
      this.rangeValueScaled = this.value;
      this.rangeValuePercent = this.scaledToPercent(this.value);
    });
  },
  watch: {
    value(value) {
      if (this.rangeValueScaled !== value) {
        this.rangeValueScaled = value;
        this.rangeValuePercent = this.scaledToPercent(value);
      }
    }
  }
};
const __cssModules$k = {};
var __component__$k = /* @__PURE__ */ normalizeComponent(
  __vue2_script$k,
  render$k,
  staticRenderFns$k,
  false,
  __vue2_injectStyles$k,
  null,
  null,
  null
);
function __vue2_injectStyles$k(context) {
  for (let o in __cssModules$k) {
    this[o] = __cssModules$k[o];
  }
}
var wSlider = /* @__PURE__ */ function() {
  return __component__$k.exports;
}();
var render$j = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.value || _vm.value === void 0 ? _c("div", { staticClass: "w-spinner", class: _vm.classes, style: _vm.styles }, [_vm.isThreeDots ? _c("span") : _vm._e()]) : _vm._e();
};
var staticRenderFns$j = [];
var wSpinner_vue_vue_type_style_index_0_lang = "";
const __vue2_script$j = {
  name: "w-spinner",
  props: {
    value: {},
    color: { type: String, default: "primary" },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    size: { type: [Number, String] },
    bounce: { type: Boolean },
    fade: { type: Boolean }
  },
  emits: [],
  computed: {
    isThreeDots() {
      return !this.bounce && !this.fade;
    },
    forcedSize() {
      return this.size && (!isNaN(this.size) ? `${this.size}px` : this.size);
    },
    presetSize() {
      return this.xs && "xs" || this.sm && "sm" || this.md && "md" || this.lg && "lg" || this.xl && "xl" || null;
    },
    styles() {
      return this.forcedSize && `font-size: ${this.forcedSize}` || null;
    },
    classes() {
      return {
        [this.color]: this.color,
        [`size--${this.presetSize}`]: this.presetSize && !this.forcedSize,
        "w-spinner--bounce": this.bounce,
        "w-spinner--fade": this.fade,
        "w-spinner--three-dots": this.isThreeDots
      };
    }
  }
};
const __cssModules$j = {};
var __component__$j = /* @__PURE__ */ normalizeComponent(
  __vue2_script$j,
  render$j,
  staticRenderFns$j,
  false,
  __vue2_injectStyles$j,
  null,
  null,
  null
);
function __vue2_injectStyles$j(context) {
  for (let o in __cssModules$j) {
    this[o] = __cssModules$j[o];
  }
}
var wSpinner = /* @__PURE__ */ function() {
  return __component__$j.exports;
}();
var render$i = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-steps" });
};
var staticRenderFns$i = [];
var wSteps_vue_vue_type_style_index_0_lang = "";
const __vue2_script$i = {
  name: "w-steps",
  props: {},
  emits: [],
  data: () => ({})
};
const __cssModules$i = {};
var __component__$i = /* @__PURE__ */ normalizeComponent(
  __vue2_script$i,
  render$i,
  staticRenderFns$i,
  false,
  __vue2_injectStyles$i,
  null,
  null,
  null
);
function __vue2_injectStyles$i(context) {
  for (let o in __cssModules$i) {
    this[o] = __cssModules$i[o];
  }
}
var wSteps = /* @__PURE__ */ function() {
  return __component__$i.exports;
}();
var render$h = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.isOn = null);
    _vm.$emit("input", null);
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.isOn, disabled: _vm.isDisabled, readonly: _vm.isReadonly }, false), [_c("input", { ref: "input", attrs: { "id": "w-switch--" + _vm._uid, "type": "checkbox", "name": _vm.inputName, "disabled": _vm.isDisabled || _vm.isReadonly || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "required": _vm.required || null, "tabindex": _vm.tabindex || null, "aria-checked": _vm.isOn || "false", "role": "switch" }, domProps: { "checked": _vm.isOn }, on: { "change": function($event) {
    _vm.onInput();
  }, "focus": function($event) {
    return _vm.$emit("focus", $event);
  } } }), _vm.hasLabel && _vm.labelOnLeft ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-switch__label w-switch__label--left w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-switch--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e(), _c("div", _vm._g({ staticClass: "w-switch__input", class: _vm.inputClasses, on: { "click": function($event) {
    _vm.$refs.input.focus();
    _vm.$refs.input.click();
  } } }, _vm.$listeners), [_vm.$slots.track ? _c("div", { staticClass: "w-switch__track" }, [_vm._t("track")], 2) : _vm._e(), _vm.$slots.thumb || _vm.loading ? _c("div", { staticClass: "w-switch__thumb" }, [_vm.loading ? _c("w-progress", _vm._b({ attrs: { "circle": "", "color": "inherit" } }, "w-progress", typeof _vm.loading === "number" ? { value: _vm.loading } : {}, false)) : _vm._t("thumb")], 2) : _vm._e()]), _vm.hasLabel && !_vm.labelOnLeft ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-switch__label w-switch__label--right w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-switch--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns$h = [];
var wSwitch_vue_vue_type_style_index_0_lang = "";
const __vue2_script$h = {
  name: "w-switch",
  mixins: [FormElementMixin],
  props: {
    value: { default: false },
    label: { type: String, default: "" },
    labelOnLeft: { type: Boolean },
    color: { type: String, default: "primary" },
    labelColor: { type: String, default: "primary" },
    thin: { type: Boolean },
    noRipple: { type: Boolean },
    loading: { type: [Boolean, Number], default: false }
  },
  emits: ["input", "update:modelValue", "focus"],
  data() {
    return {
      isOn: this.value,
      ripple: {
        start: false,
        end: false,
        timeout: null
      }
    };
  },
  computed: {
    hasLabel() {
      return this.$slots.default && this.$slots.default.length || this.label;
    },
    classes() {
      return {
        [`w-switch w-switch--${this.isOn ? "on" : "off"}`]: true,
        "w-switch--thin": this.thin,
        "w-switch--disabled": this.isDisabled,
        "w-switch--readonly": this.isReadonly,
        "w-switch--ripple": this.ripple.start,
        "w-switch--custom-thumb": this.$slots.thumb,
        "w-switch--custom-track": this.$slots.track,
        "w-switch--loading": this.loading,
        "w-switch--rippled": this.ripple.end
      };
    },
    inputClasses() {
      const side = this.hasLabel && this.labelOnLeft ? "l" : "r";
      return [
        [this.color],
        this.hasLabel ? this.thin ? `m${side}3` : `m${side}2` : ""
      ];
    }
  },
  methods: {
    onInput() {
      this.isOn = !this.isOn;
      this.$emit("update:modelValue", this.isOn);
      this.$emit("input", this.isOn);
      if (!this.noRipple) {
        if (this.isOn) {
          this.ripple.start = true;
          this.ripple.timeout = setTimeout(() => {
            this.ripple.start = false;
            this.ripple.end = true;
            setTimeout(() => this.ripple.end = false, 100);
          }, 700);
        } else {
          this.ripple.start = false;
          clearTimeout(this.ripple.timeout);
        }
      }
    }
  },
  watch: {
    value(value) {
      this.isOn = value;
    }
  }
};
const __cssModules$h = {};
var __component__$h = /* @__PURE__ */ normalizeComponent(
  __vue2_script$h,
  render$h,
  staticRenderFns$h,
  false,
  __vue2_injectStyles$h,
  null,
  null,
  null
);
function __vue2_injectStyles$h(context) {
  for (let o in __cssModules$h) {
    this[o] = __cssModules$h[o];
  }
}
var wSwitch = /* @__PURE__ */ function() {
  return __component__$h.exports;
}();
var render$g = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-tabs__content" }, [_vm._t("default", null, { "item": _vm.item })], 2);
};
var staticRenderFns$g = [];
const __vue2_script$g = {
  name: "tab-content",
  props: { item: Object }
};
const __cssModules$g = {};
var __component__$g = /* @__PURE__ */ normalizeComponent(
  __vue2_script$g,
  render$g,
  staticRenderFns$g,
  false,
  __vue2_injectStyles$g,
  null,
  null,
  null
);
function __vue2_injectStyles$g(context) {
  for (let o in __cssModules$g) {
    this[o] = __cssModules$g[o];
  }
}
var TabContent = /* @__PURE__ */ function() {
  return __component__$g.exports;
}();
var render$f = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-tabs", class: _vm.tabsClasses }, [_c("div", { ref: "tabs-bar", staticClass: "w-tabs__bar", class: _vm.tabsBarClasses }, [_vm._l(_vm.tabs, function(tab, i) {
    return _c("div", { key: i, staticClass: "w-tabs__bar-item", class: _vm.barItemClasses(tab), attrs: { "tabindex": !tab._disabled && 0, "aria-selected": tab._uid === _vm.activeTabUid ? "true" : "false", "role": "tab" }, on: { "click": function($event) {
      !tab._disabled && tab._uid !== _vm.activeTabUid && _vm.openTab(tab._uid);
    }, "focus": function($event) {
      _vm.$emit("focus", _vm.getOriginalItem(tab));
    }, "keypress": function($event) {
      if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
        return null;
      }
      !tab._disabled && _vm.openTab(tab._uid);
    } } }, [_vm.$scopedSlots["item-title." + (tab.id || i + 1)] ? _vm._t("item-title." + (tab.id || i + 1), null, { "item": _vm.getOriginalItem(tab), "index": i + 1, "active": tab._uid === _vm.activeTabUid }) : _vm._t("item-title", function() {
      return [_c("div", { domProps: { "innerHTML": _vm._s(tab[_vm.itemTitleKey]) } })];
    }, { "item": _vm.getOriginalItem(tab), "index": i + 1, "active": tab._uid === _vm.activeTabUid })], 2);
  }), _vm.$scopedSlots["tabs-bar-extra"] ? _c("div", { staticClass: "w-tabs__bar-extra" }, [_vm._t("tabs-bar-extra")], 2) : _vm._e(), !_vm.noSlider && !_vm.card ? _c("div", { staticClass: "w-tabs__slider", class: _vm.sliderColor, style: _vm.sliderStyles }) : _vm._e()], 2), _vm.keepInDom ? _c("transition-group", { staticClass: "w-tabs__content-wrap", attrs: { "name": _vm.transitionName, "tag": "div" } }, _vm._l(_vm.tabs, function(tab, i) {
    return _c("tab-content", { directives: [{ name: "show", rawName: "v-show", value: tab._uid === _vm.activeTab._uid, expression: "tab._uid === activeTab._uid" }], key: tab._uid, class: _vm.contentClass, attrs: { "item": tab } }, [_vm.$scopedSlots["item-content." + (tab._index + 1)] ? _vm._t("item-content." + (tab._index + 1), null, { "item": _vm.getOriginalItem(tab), "index": tab._index + 1, "active": tab._index === _vm.activeTab._index }) : _vm._t("item-content", function() {
      return [tab[_vm.itemContentKey] ? _c("div", { domProps: { "innerHTML": _vm._s(tab[_vm.itemContentKey]) } }) : _vm._e()];
    }, { "item": _vm.getOriginalItem(tab), "index": tab._index + 1, "active": tab._index === _vm.activeTab._index })], 2);
  }), 1) : _c("div", { staticClass: "w-tabs__content-wrap" }, [_c("transition", { attrs: { "name": _vm.transitionName, "mode": _vm.transitionMode } }, [_c("keep-alive", { attrs: { "exclude": _vm.keepAlive ? "" : "tab-content" } }, [_c("tab-content", { key: _vm.activeTabUid, class: _vm.contentClass, attrs: { "item": _vm.activeTab }, scopedSlots: _vm._u([{ key: "default", fn: function(ref) {
    var item = ref.item;
    return [item ? [_vm.$scopedSlots["item-content." + (item._index + 1)] ? _vm._t("item-content." + (item._index + 1), null, { "item": _vm.getOriginalItem(item), "index": item._index + 1, "active": item._uid === _vm.activeTabUid }) : _vm._t("item-content", function() {
      return [item[_vm.itemContentKey] ? _c("div", { domProps: { "innerHTML": _vm._s(item[_vm.itemContentKey]) } }) : _vm._e()];
    }, { "item": _vm.getOriginalItem(item), "index": item._index + 1, "active": item._uid === _vm.activeTabUid })] : _vm._e()];
  } }], null, true) })], 1)], 1)], 1)], 1);
};
var staticRenderFns$f = [];
var index_vue_vue_type_style_index_0_lang = "";
let uid = 0;
const __vue2_script$f = {
  name: "w-tabs",
  props: {
    value: { type: [Number, String] },
    color: { type: String },
    bgColor: { type: String },
    items: { type: [Array, Number] },
    itemIdKey: { type: String, default: "id" },
    itemTitleKey: { type: String, default: "title" },
    itemContentKey: { type: String, default: "content" },
    titleClass: { type: String },
    activeClass: { type: String, default: "primary" },
    noSlider: { type: Boolean },
    pillSlider: { type: Boolean },
    sliderColor: { type: String, default: "primary" },
    contentClass: { type: String },
    transition: { type: [String, Boolean], default: "" },
    fillBar: { type: Boolean },
    center: { type: Boolean },
    right: { type: Boolean },
    card: { type: Boolean },
    keepAlive: { type: Boolean, default: true },
    keepInDom: { type: Boolean, default: false }
  },
  components: { TabContent },
  emits: ["input", "update:modelValue", "focus"],
  data: () => ({
    tabs: [],
    activeTabEl: null,
    activeTabUid: null,
    activeTabIndex: 0,
    prevTabIndex: -1,
    slider: {
      left: 0,
      width: 0
    },
    init: true
  }),
  computed: {
    transitionName() {
      if (this.transition === false)
        return "";
      return this.transition || `w-tabs-slide-${this.direction}`;
    },
    transitionMode() {
      return ["w-tabs-slide-left", "w-tabs-slide-right"].includes(this.transitionName) ? "" : "out-in";
    },
    direction() {
      return this.activeTab._index < this.prevTabIndex ? "right" : "left";
    },
    activeTab() {
      return this.tabsByUid[this.activeTabUid] || this.tabs[0] || {};
    },
    tabsByUid() {
      return this.tabs.reduce((obj, tab) => (obj[tab._uid] = tab) && obj, {});
    },
    tabsClasses() {
      return {
        "w-tabs--card": this.card,
        "w-tabs--no-slider": this.noSlider,
        "w-tabs--pill-slider": this.pillSlider,
        "w-tabs--fill-bar": this.fillBar,
        "w-tabs--init": this.init,
        "w-tabs--dark": this.dark,
        "w-tabs--light": this.light
      };
    },
    tabsBarClasses() {
      return {
        "w-tabs__bar--right": this.right,
        "w-tabs__bar--center": this.center
      };
    },
    sliderStyles() {
      return {
        left: this.slider.left,
        width: this.slider.width
      };
    }
  },
  methods: {
    addTab(item) {
      var _a, _b, _c;
      if (!((_b = (_a = item[this.itemIdKey]) != null ? _a : item._uid) != null ? _b : false))
        item._uid = +`${this._uid}${++uid}`;
      this.tabs.push({
        _uid: (_c = item[this.itemIdKey]) != null ? _c : item._uid,
        _index: this.tabs.length,
        ...item,
        _disabled: !!item.disabled
      });
    },
    refreshTabs() {
      let items = this.items;
      if (typeof items === "number")
        items = Array(items).fill().map((_, i) => this.tabs[i] || {});
      this.tabs = items.map((item, _index) => {
        var _a, _b, _c;
        if (!((_b = (_a = item[this.itemIdKey]) != null ? _a : item._uid) != null ? _b : false))
          item._uid = +`${this._uid}${++uid}`;
        return {
          ...item,
          _uid: (_c = item[this.itemIdKey]) != null ? _c : item._uid,
          _index,
          _disabled: !!item.disabled
        };
      });
    },
    reopenTheActiveTab() {
      var _a, _b, _c;
      if (this.tabs.length === 1)
        return this.openTab(this.tabs[0]._uid);
      let uid2 = (_a = this.tabsByUid[this.activeTabUid]) == null ? void 0 : _a._uid;
      if (!uid2)
        uid2 = (_b = this.tabs[this.activeTabIndex]) == null ? void 0 : _b._uid;
      if (!uid2)
        uid2 = (_c = this.tabs[Math.max(this.activeTabIndex - 1, this.tabs.length - 1)]) == null ? void 0 : _c._uid;
      if (uid2)
        this.openTab(uid2);
    },
    onResize() {
      this.updateSlider(false);
    },
    barItemClasses(item) {
      const isActive = item._index === this.activeTabIndex;
      return {
        [`${this.bgColor}--bg`]: this.bgColor,
        [this.color]: this.color && !item._disabled && !(this.activeClass && isActive),
        [`w-tabs__bar-item--active ${this.activeClass}`]: isActive,
        "w-tabs__bar-item--disabled": item._disabled,
        [this.titleClass]: this.titleClass
      };
    },
    openTab(uid2) {
      this.prevTabIndex = this.activeTabIndex;
      const tab = this.tabsByUid[uid2];
      this.activeTabIndex = tab._index;
      this.activeTabUid = tab._uid;
      this.$emit("update:modelValue", tab._index);
      this.$emit("input", tab._index);
      if (!this.noSlider)
        this.$nextTick(this.updateSlider);
    },
    updateSlider(domLookup = true) {
      if (domLookup) {
        const ref = this.$refs["tabs-bar"];
        this.activeTabEl = ref && ref.querySelector(".w-tabs__bar-item--active");
      }
      if (!this.fillBar && this.activeTabEl) {
        const { left, width } = this.activeTabEl.getBoundingClientRect();
        const tabsBar = this.activeTabEl.parentNode;
        const { left: parentLeft } = tabsBar.getBoundingClientRect();
        const { borderLeftWidth } = getComputedStyle(tabsBar);
        this.slider.left = `${left - parentLeft - parseInt(borderLeftWidth) + tabsBar.scrollLeft}px`;
        this.slider.width = `${width}px`;
      } else {
        this.slider.left = `${this.activeTab._index * 100 / this.tabs.length}%`;
        this.slider.width = `${100 / this.tabs.length}%`;
      }
    },
    updateActiveTab(index2) {
      var _a, _b;
      if (typeof index2 === "string")
        index2 = ~~index2;
      else if (isNaN(index2) || index2 < 0)
        index2 = 0;
      if ((_a = this.tabs[index2]) == null ? void 0 : _a._uid) {
        this.openTab((_b = this.tabs[index2]) == null ? void 0 : _b._uid);
        this.$nextTick(() => {
          const ref = this.$refs["tabs-bar"];
          this.activeTabEl = ref && ref.querySelector(`.w-tabs__bar-item:nth-child(${index2 + 1})`);
          if (this.activeTabEl) {
            this.activeTabEl.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "nearest" });
          }
        });
      }
    },
    getOriginalItem(item) {
      return this.items[item._index] || {};
    }
  },
  beforeMount() {
    var _a;
    this.tabs = [];
    const items = typeof this.items === "number" ? Array(this.items).fill().map(Object) : this.items;
    items.forEach(this.addTab);
    if ((_a = this.value) != null ? _a : false)
      this.updateActiveTab(this.value);
    this.$nextTick(() => {
      this.updateSlider();
      setTimeout(() => this.init = false, 0);
    });
    if (!this.noSlider)
      window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  watch: {
    value(index2) {
      if (index2 !== this.activeTabIndex)
        this.updateActiveTab(index2);
    },
    items: {
      handler() {
        this.refreshTabs();
        if (this.tabs.length)
          this.reopenTheActiveTab();
        if (!this.noSlider)
          this.$nextTick(this.updateSlider);
      },
      deep: true
    },
    fillBar() {
      if (!this.noSlider)
        this.$nextTick(this.updateSlider);
    },
    noSlider(value) {
      if (!value) {
        this.updateSlider();
        window.addEventListener("resize", this.onResize);
      } else
        window.removeEventListener("resize", this.onResize);
    }
  }
};
const __cssModules$f = {};
var __component__$f = /* @__PURE__ */ normalizeComponent(
  __vue2_script$f,
  render$f,
  staticRenderFns$f,
  false,
  __vue2_injectStyles$f,
  null,
  null,
  null
);
function __vue2_injectStyles$f(context) {
  for (let o in __cssModules$f) {
    this[o] = __cssModules$f[o];
  }
}
var index = /* @__PURE__ */ function() {
  return __component__$f.exports;
}();
var render$e = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-table w-table--wrap", class: _vm.classes }, [_c("div", { staticClass: "w-table__scroll-wrap" }, [_c("table", { staticClass: "w-table__table", on: { "mousedown": _vm.onMouseDown, "mouseover": _vm.onMouseOver, "mouseout": _vm.onMouseOut } }, [_c("colgroup", { ref: "colgroup" }, _vm._l(_vm.headers, function(header, i) {
    return _c("col", { key: i, staticClass: "w-table__col", class: _vm.colClasses[i], attrs: { "width": header.width || null } });
  }), 0), !_vm.noHeaders ? _c("thead", [_c("tr", _vm._l(_vm.headers, function(header, i) {
    return _c("th", { key: i, staticClass: "w-table__header", class: _vm.headerClasses(header), on: { "click": function($event) {
      !_vm.colResizing.dragging && header.sortable !== false && _vm.sortTable(header);
    } } }, [header.sortable !== false && header.align === "right" ? _c("w-icon", { staticClass: "w-table__header-sort", class: _vm.headerSortClasses(header) }, [_vm._v("wi-arrow-down")]) : _vm._e(), header.label ? [_vm.$scopedSlots["header-label"] ? _vm._t("header-label", function() {
      return [_vm._v(_vm._s(header.label || ""))];
    }, { "header": header, "label": header.label, "index": i + 1 }) : _c("span", { domProps: { "innerHTML": _vm._s(header.label || "") } })] : _vm._e(), header.sortable !== false && header.align !== "right" ? _c("w-icon", { staticClass: "w-table__header-sort", class: _vm.headerSortClasses(header) }, [_vm._v("wi-arrow-down")]) : _vm._e(), i < _vm.headers.length - 1 && _vm.resizableColumns ? _c("span", { staticClass: "w-table__col-resizer", class: { "w-table__col-resizer--hover": _vm.colResizing.hover === i, "w-table__col-resizer--active": _vm.colResizing.columnIndex === i }, on: { "click": function($event) {
      $event.stopPropagation();
    } } }) : _vm._e()], 2);
  }), 0), _c("w-transition-fade", [_vm.loading === "header" ? _c("tr", { staticClass: "w-table__progress-bar" }, [_c("td", { attrs: { "colspan": _vm.headers.length } }, [_c("w-progress", { attrs: { "tile": "" } })], 1)]) : _vm._e()])], 1) : _vm._e(), _c("tbody", [_vm.loading === true ? _c("tr", { staticClass: "w-table__progress-bar" }, [_c("td", { attrs: { "colspan": _vm.headers.length } }, [_c("w-progress", { attrs: { "tile": "" } }), _c("div", { staticClass: "w-table__loading-text" }, [_vm._t("loading", function() {
    return [_vm._v("Loading...")];
  })], 2)], 1)]) : !_vm.tableItems.length ? _c("tr", { staticClass: "no-data" }, [_c("td", { staticClass: "w-table__cell text-center", attrs: { "colspan": _vm.headers.length } }, [_vm._t("no-data", function() {
    return [_vm._v("No data to show.")];
  })], 2)]) : _vm._e(), _vm.tableItems.length && _vm.loading !== true ? [_vm._l(_vm.paginatedItems, function(item, i) {
    return [_vm.$scopedSlots.item ? _vm._t("item", null, { "item": item, "index": i + 1, "select": function() {
      return _vm.doSelectRow(item, i);
    }, "classes": { "w-table__row": true, "w-table__row--selected": _vm.selectedRowsByUid[item._uid] !== void 0, "w-table__row--expanded": _vm.expandedRowsByUid[item._uid] !== void 0 } }) : _c("tr", { key: i, staticClass: "w-table__row", class: { "w-table__row--selected": _vm.selectedRowsByUid[item._uid] !== void 0, "w-table__row--expanded": _vm.expandedRowsByUid[item._uid] !== void 0 }, on: { "click": function($event) {
      return _vm.doSelectRow(item, i);
    } } }, [_vm._l(_vm.headers, function(header, j) {
      var _obj, _obj$1;
      return [_vm.$scopedSlots["item-cell." + header.key] || _vm.$scopedSlots["item-cell." + (j + 1)] || _vm.$scopedSlots["item-cell"] ? _c("td", { key: j + "-a", staticClass: "w-table__cell", class: (_obj = {}, _obj["text-" + (header.align || "left")] = true, _obj["w-table__cell--sticky"] = header.sticky, _obj), attrs: { "data-label": header.label } }, [_vm.$scopedSlots["item-cell." + header.key] ? _vm._t("item-cell." + header.key, null, { "header": header, "item": item, "label": item[header.key] || "", "index": i + 1 }) : _vm.$scopedSlots["item-cell." + (j + 1)] ? _vm._t("item-cell." + (j + 1), null, { "header": header, "item": item, "label": item[header.key] || "", "index": i + 1 }) : _vm.$scopedSlots["item-cell"] ? _vm._t("item-cell", null, { "header": header, "item": item, "label": item[header.key] || "", "index": i + 1 }) : _vm._e(), j < _vm.headers.length - 1 && _vm.resizableColumns ? _c("span", { staticClass: "w-table__col-resizer", class: { "w-table__col-resizer--hover": _vm.colResizing.hover === j, "w-table__col-resizer--active": _vm.colResizing.columnIndex === j } }) : _vm._e()], 2) : _c("td", { key: j + "-b", staticClass: "w-table__cell", class: (_obj$1 = {}, _obj$1["text-" + (header.align || "left")] = true, _obj$1["w-table__cell--sticky"] = header.sticky, _obj$1), attrs: { "data-label": header.label } }, [_c("div", { domProps: { "innerHTML": _vm._s(item[header.key] || "") } }), j < _vm.headers.length - 1 && _vm.resizableColumns ? _c("span", { staticClass: "w-table__col-resizer", class: { "w-table__col-resizer--hover": _vm.colResizing.hover === j, "w-table__col-resizer--active": _vm.colResizing.columnIndex === j } }) : _vm._e()])];
    })], 2), _vm.expandedRowsByUid[item._uid] ? _c("tr", { staticClass: "w-table__row w-table__row--expansion" }, [_c("td", { staticClass: "w-table__cell", attrs: { "colspan": _vm.headers.length } }, [_c("w-transition-expand", { attrs: { "y": "" } }, [_vm.expandedRowsByUid[item._uid] ? _c("div", [_vm._t("row-expansion", null, { "item": item, "index": i + 1 })], 2) : _vm._e(), i < _vm.headers.length - 1 && _vm.resizableColumns ? _c("span", { staticClass: "w-table__col-resizer", class: { "w-table__col-resizer--hover": _vm.colResizing.hover === i, "w-table__col-resizer--active": _vm.colResizing.columnIndex === _vm.j } }) : _vm._e()])], 1)]) : _vm._e()];
  })] : _vm._e(), _vm.$slots["extra-row"] ? _c("div", { staticClass: "w-table__extra-row" }, [_vm._t("extra-row")], 2) : _vm._e()], 2), _vm.$slots.footer || _vm.$slots["footer-row"] ? _c("tfoot", { staticClass: "w-table__footer" }, [_vm.$slots["footer-row"] ? _vm._t("footer-row") : _vm.$slots.footer ? _c("tr", { staticClass: "w-table__row" }, [_c("td", { staticClass: "w-table__cell", attrs: { "colspan": _vm.headers.length } }, [_vm._t("footer")], 2)]) : _vm._e()], 2) : _vm._e()])]), _vm.pagination && _vm.paginationConfig ? _c("div", { staticClass: "w-table__pagination w-pagination" }, [_vm._t("pagination", function() {
    return [_vm.paginationConfig.itemsPerPageOptions ? _c("w-select", { staticClass: "w-pagination__items-per-page", attrs: { "items": _vm.paginationConfig.itemsPerPageOptions, "label-position": "left", "label": "Items per page", "label-color": "inherit" }, on: { "input": function($event) {
      return _vm.updatePaginationConfig({ itemsPerPage: _vm.paginationConfig.itemsPerPage });
    } }, model: { value: _vm.paginationConfig.itemsPerPage, callback: function($$v) {
      _vm.$set(_vm.paginationConfig, "itemsPerPage", $$v);
    }, expression: "paginationConfig.itemsPerPage" } }) : _vm._e(), _c("div", { staticClass: "pages-wrap" }, [_c("w-button", { staticClass: "w-pagination__arrow w-pagination__arrow--prev", attrs: { "disabled": _vm.paginationConfig.page <= 1, "icon": "wi-chevron-left", "text": "", "lg": "" }, on: { "click": function($event) {
      return _vm.goToPage("-1");
    } } }), _vm.paginationConfig.pagesCount > 7 ? [_vm._l(_vm.paginationConfig.pagesCount, function(i) {
      return [[1, _vm.paginationConfig.pagesCount, _vm.paginationConfig.page - 1, _vm.paginationConfig.page, _vm.paginationConfig.page + 1].includes(i) ? _c("w-button", { key: i, staticClass: "w-pagination__page", class: { "w-pagination__page--active": i === _vm.paginationConfig.page }, attrs: { "round": "", "lg": "" }, on: { "click": function($event) {
        i !== _vm.paginationConfig.page && _vm.goToPage(i);
      } } }, [_vm._v(_vm._s(i))]) : [1, _vm.paginationConfig.pagesCount, _vm.paginationConfig.page - 1, _vm.paginationConfig.page, _vm.paginationConfig.page + 1].includes(i - 1) ? _c("w-button", { key: i, staticClass: "w-pagination__page", class: { "w-pagination__page--active": i === _vm.paginationConfig.page }, attrs: { "round": "", "lg": "" }, on: { "click": function($event) {
        i !== _vm.paginationConfig.page && _vm.goToPage(i);
      } } }, [_vm._v("...")]) : _vm._e()];
    })] : _vm._l(_vm.paginationConfig.pagesCount, function(i) {
      return _c("w-button", { key: i, staticClass: "w-pagination__page", class: { "w-pagination__page--active": i === _vm.paginationConfig.page }, attrs: { "round": "", "lg": "" }, on: { "click": function($event) {
        i !== _vm.paginationConfig.page && _vm.goToPage(i);
      } } }, [_vm._v(_vm._s(i))]);
    }), _c("w-button", { staticClass: "w-pagination__arrow w-pagination__arrow--next", attrs: { "disabled": _vm.paginationConfig.page >= _vm.paginationConfig.pagesCount, "icon": "wi-chevron-right", "text": "", "lg": "" }, on: { "click": function($event) {
      return _vm.goToPage("+1");
    } } })], 2), _c("span", { staticClass: "w-pagination__results" }, [_vm._v(_vm._s(_vm.paginationConfig.start) + "-" + _vm._s(_vm.paginationConfig.end || _vm.paginationConfig.total) + " of " + _vm._s(_vm.paginationConfig.total))])];
  }, { "range": _vm.paginationConfig.start + "-" + _vm.paginationConfig.end, "total": _vm.paginationConfig.total, "pagesCount": _vm.paginationConfig.pagesCount, "page": _vm.paginationConfig.page, "goToPage": _vm.goToPage })], 2) : _vm._e()]);
};
var staticRenderFns$e = [];
var wTable_vue_vue_type_style_index_0_lang = "";
const minColumnWidth = 15;
const __vue2_script$e = {
  name: "w-table",
  props: {
    items: { type: Array, required: true },
    headers: { type: Array, required: true },
    noHeaders: { type: Boolean },
    fixedLayout: { type: Boolean },
    fixedHeaders: { type: Boolean },
    fixedFooter: { type: Boolean },
    loading: { type: [Boolean, String] },
    sort: { type: [String, Array] },
    sortFunction: { type: Function },
    filter: { type: Function },
    fetch: { type: Function },
    expandableRows: {
      validator: (value) => {
        if (![void 0, true, false, 1, "1", ""].includes(value)) {
          consoleError(
            `Wrong value for the w-table's \`expandableRows\` prop. Given: "${value}", expected one of: [undefined, true, false, 1, '1', ''].`
          );
        }
        return true;
      }
    },
    expandedRows: { type: Array },
    selectableRows: {
      validator: (value) => {
        if (![void 0, true, false, 1, "1", ""].includes(value)) {
          consoleError(
            `Wrong value for the w-table's \`selectableRows\` prop. Given: "${value}", expected one of: [undefined, true, false, 1, '1', ''].`
          );
        }
        return true;
      }
    },
    selectedRows: { type: Array },
    forceSelection: { type: Boolean },
    uidKey: { type: String, default: "id" },
    mobileBreakpoint: { type: Number, default: 0 },
    resizableColumns: { type: Boolean },
    pagination: {
      type: [Boolean, Object, String],
      validator: (object) => {
        if (!object)
          return true;
        else if (typeof object === "object" && (!object.itemsPerPage || object.page && isNaN(object.page))) {
          consoleError(
            "Wrong pagination config received in the w-table's `pagination` prop (received: `" + JSON.stringify(object) + "`). \nExpected object: { itemsPerPage: Integer, page: Integer } or { itemsPerPage: Integer, start: Integer }."
          );
          return false;
        }
        return true;
      }
    }
  },
  emits: [
    "row-select",
    "row-expand",
    "row-click",
    "update:sort",
    "update:selected-rows",
    "update:expanded-rows",
    "column-resize"
  ],
  data: () => ({
    activeSorting: [],
    selectedRowsInternal: [],
    expandedRowsInternal: [],
    colResizing: {
      dragging: false,
      hover: false,
      columnIndex: null,
      startCursorX: null,
      colWidth: null,
      nextColWidth: null,
      columnEl: null,
      nextColumnEl: null
    },
    paginationConfig: {
      itemsPerPage: 0,
      itemsPerPageOptions: {},
      start: void 0,
      end: void 0,
      page: 1,
      total: 0
    }
  }),
  computed: {
    tableItems() {
      return this.items.map((item, i) => {
        var _a;
        item._uid = (_a = item[this.uidKey]) != null ? _a : i;
        return item;
      });
    },
    filteredItems() {
      return typeof this.filter === "function" ? this.tableItems.filter(this.filter) : this.tableItems;
    },
    sortedItems() {
      if (!this.activeSorting.length || this.sortFunction || this.fetch)
        return this.filteredItems;
      const sortKey1 = this.activeSorting[0].replace(/^[+-]/, "");
      const sortDesc1 = this.activeSorting[0][0] === "-";
      return [...this.filteredItems].sort((a, b) => {
        a = a[sortKey1];
        b = b[sortKey1];
        if (!isNaN(a) && !isNaN(b)) {
          a = parseFloat(a);
          b = parseFloat(b);
        }
        return (a > b ? 1 : -1) * (sortDesc1 ? -1 : 1);
      });
    },
    paginatedItems() {
      return typeof this.fetch === "function" ? this.sortedItems : this.sortedItems.slice(this.paginationConfig.start - 1, this.paginationConfig.end);
    },
    activeSortingKeys() {
      return this.activeSorting.reduce((obj, item) => {
        obj[item.replace(/^[+-]/, "")] = item[0];
        return obj;
      }, {});
    },
    classes() {
      return {
        "w-table--loading": this.loading,
        "w-table--loading-in-header": this.loading === "header",
        "w-table--fixed-layout": this.fixedLayout || this.resizableColumns || this.hasStickyColumn,
        "w-table--mobile": this.isMobile || null,
        "w-table--resizable-cols": this.resizableColumns || null,
        "w-table--resizing": this.colResizing.dragging,
        "w-table--fixed-header": this.fixedHeaders,
        "w-table--fixed-footer": this.fixedFooter,
        "w-table--sticky-column": this.hasStickyColumn
      };
    },
    colClasses() {
      return this.headers.map((header) => {
        return { "w-table__col--highlighted": this.activeSortingKeys[header.key] };
      }) || [];
    },
    isMobile() {
      return ~~this.mobileBreakpoint && this.$waveui.breakpoint.width <= ~~this.mobileBreakpoint;
    },
    hasStickyColumn() {
      return this.headers.find((header) => header.sticky);
    },
    selectedRowsByUid() {
      return this.selectedRowsInternal.reduce((obj, uid2) => (obj[uid2] = true) && obj, {});
    },
    expandedRowsByUid() {
      return this.expandedRowsInternal.reduce((obj, uid2) => (obj[uid2] = true) && obj, {});
    }
  },
  methods: {
    headerClasses(header) {
      return {
        "w-table__header--sortable": header.sortable !== false,
        "w-table__header--sticky": header.sticky,
        "w-table__header--resizable": !!this.resizableColumns,
        [`text-${header.align || "left"}`]: true
      };
    },
    headerSortClasses(header) {
      const headerSorting = this.activeSortingKeys[header.key];
      return [
        `w-table__header-sort--${headerSorting ? "active" : "inactive"}`,
        `w-table__header-sort--${headerSorting === "-" ? "desc" : "asc"}`,
        `m${header.align === "right" ? "r" : "l"}1`
      ];
    },
    async sortTable(header) {
      const alreadySortingThis = this.activeSortingKeys[header.key];
      if (alreadySortingThis && this.activeSortingKeys[header.key] === "-") {
        this.activeSorting = [];
      } else
        this.$set(this.activeSorting, 0, (alreadySortingThis ? "-" : "+") + header.key);
      this.$emit("update:sort", this.activeSorting);
      if (typeof this.sortFunction === "function")
        await this.sortFunction(this.activeSorting);
      else if (typeof this.fetch === "function")
        await this.callApiFetch();
    },
    doSelectRow(item, index2) {
      const expandable = this.expandableRows === "" ? true : this.expandableRows;
      const selectable = this.selectableRows === "" ? true : this.selectableRows;
      if (expandable) {
        const isExpanding = this.expandedRowsByUid[item._uid] === void 0;
        if (isExpanding) {
          if (this.expandableRows.toString() === "1")
            this.expandedRowsInternal = [item._uid];
          else
            this.expandedRowsInternal.push(item._uid);
        } else
          this.expandedRowsInternal = this.expandedRowsInternal.filter((uid2) => uid2 !== item._uid);
        this.$emit(
          "row-expand",
          {
            item,
            index: index2,
            expanded: isExpanding,
            expandedRows: this.expandedRowsInternal.map((uid2) => this.filteredItems[uid2])
          }
        );
        this.$emit("update:expanded-rows", this.expandedRowsInternal);
      } else if (selectable) {
        let updated = false;
        const isSelecting = this.selectedRowsByUid[item._uid] === void 0;
        if (isSelecting) {
          if (this.selectableRows.toString() === "1")
            this.selectedRowsInternal = [item._uid];
          else
            this.selectedRowsInternal.push(item._uid);
          updated = true;
        } else if (!this.forceSelection || this.selectedRowsInternal.length > 1) {
          this.selectedRowsInternal = this.selectedRowsInternal.filter((uid2) => uid2 !== item._uid);
          updated = true;
        }
        if (updated) {
          this.$emit(
            "row-select",
            {
              item,
              index: index2,
              selected: isSelecting,
              selectedRows: this.selectedRowsInternal.map((uid2) => this.filteredItems[uid2])
            }
          );
          this.$emit("update:selected-rows", this.selectedRowsInternal);
        }
      }
      this.$emit("row-click", { item, index: index2 });
    },
    onMouseDown(e) {
      if (e.target.classList.contains("w-table__col-resizer")) {
        this.colResizing.columnIndex = +e.target.parentNode.cellIndex;
        this.colResizing.startCursorX = e.pageX;
        this.colResizing.columnEl = this.$el.querySelector(`col:nth-child(${this.colResizing.columnIndex + 1})`);
        this.colResizing.nextColumnEl = this.colResizing.columnEl.nextSibling;
        this.colResizing.colWidth = this.colResizing.columnEl.offsetWidth;
        this.colResizing.nextColWidth = this.colResizing.nextColumnEl.offsetWidth;
        document.addEventListener("mousemove", this.onResizerMouseMove);
        document.addEventListener("mouseup", this.onResizerMouseUp);
      }
    },
    onMouseOver({ target }) {
      if (target.classList.contains("w-table__col-resizer")) {
        this.colResizing.hover = +target.parentNode.cellIndex;
      }
    },
    onMouseOut({ target }) {
      if (target.classList.contains("w-table__col-resizer"))
        this.colResizing.hover = false;
    },
    onResizerMouseMove(e) {
      const { startCursorX, columnEl, nextColumnEl, colWidth, nextColWidth } = this.colResizing;
      this.colResizing.dragging = true;
      const deltaX = e.pageX - startCursorX;
      const maxWidth = colWidth + nextColWidth;
      const newColWidth = colWidth + deltaX;
      const newNextColWidth = nextColWidth - deltaX;
      columnEl.style.width = colWidth + deltaX + "px";
      nextColumnEl.style.width = nextColWidth - deltaX + "px";
      const minWidthReached = deltaX < 0 && columnEl.offsetWidth > newColWidth || columnEl.offsetWidth <= minColumnWidth;
      const maxWidthReached = deltaX > 0 && nextColumnEl.offsetWidth > newNextColWidth;
      if (minWidthReached) {
        const newWidth = Math.max(columnEl.offsetWidth, minColumnWidth);
        columnEl.style.width = newWidth + "px";
        nextColumnEl.style.width = maxWidth - newWidth + "px";
      } else if (maxWidthReached) {
        columnEl.style.width = maxWidth - nextColumnEl.offsetWidth + "px";
        nextColumnEl.style.width = nextColumnEl.offsetWidth + "px";
      }
    },
    onResizerMouseUp() {
      document.removeEventListener("mousemove", this.onResizerMouseMove);
      document.removeEventListener("mouseup", this.onResizerMouseUp);
      setTimeout(() => {
        const widths = [...this.$refs.colgroup.children].map((column) => {
          var _a;
          return ((_a = column.style) == null ? void 0 : _a.width) || column.offsetWidth;
        });
        this.$emit("column-resize", { index: this.colResizing.columnIndex, widths });
        this.colResizing.dragging = false;
        this.colResizing.columnIndex = null;
        this.colResizing.startCursorX = null;
        this.colResizing.columnEl = null;
        this.colResizing.nextColumnEl = null;
        this.colResizing.colWidth = null;
        this.colResizing.nextColWidth = null;
      }, 0);
    },
    initPagination() {
      var _a, _b, _c;
      const itemsPerPage = (_b = (_a = this.pagination) == null ? void 0 : _a.itemsPerPage) != null ? _b : 20;
      const itemsPerPageOptions = ((_c = this.pagination) == null ? void 0 : _c.itemsPerPageOptions) || [20, 100, { label: "All", value: 0 }];
      if (!itemsPerPageOptions.find((item) => {
        var _a2;
        return ((_a2 = item == null ? void 0 : item.value) != null ? _a2 : item) === +itemsPerPage;
      })) {
        itemsPerPageOptions.push(itemsPerPage);
      }
      this.paginationConfig.itemsPerPageOptions = itemsPerPageOptions.map((item) => {
        var _a2;
        return {
          label: ["string", "number"].includes(typeof item) ? item.toString() : item.label || item.value,
          value: ["string", "number"].includes(typeof item) ? ~~item : (_a2 = item.value) != null ? _a2 : item.label
        };
      });
      this.paginationConfig.itemsPerPageOptions.sort((a, b) => a.value < b.value ? -1 : 1);
      const optionAll = this.paginationConfig.itemsPerPageOptions.shift();
      this.paginationConfig.itemsPerPageOptions.push(optionAll);
      this.updatePaginationConfig({
        itemsPerPage,
        page: this.pagination.page || 1,
        total: this.pagination.total || this.items.length
      });
    },
    updatePaginationConfig({ itemsPerPage, page, total }) {
      if (total)
        this.paginationConfig.total = total;
      if (itemsPerPage !== void 0) {
        this.paginationConfig.itemsPerPage = itemsPerPage;
        itemsPerPage = itemsPerPage || this.paginationConfig.total;
        this.paginationConfig.page = page || this.paginationConfig.page || 1;
        page = this.paginationConfig.page;
        total = this.paginationConfig.total;
        this.paginationConfig.start = 1;
        this.paginationConfig.end = total >= itemsPerPage * page ? itemsPerPage * page : total % (itemsPerPage * page);
        this.paginationConfig.pagesCount = Math.ceil(total / itemsPerPage);
      }
      if (page)
        this.goToPage(page);
    },
    async goToPage(page) {
      if (["-1", "+1"].includes(page))
        this.paginationConfig.page += +page;
      else
        this.paginationConfig.page = page;
      const { itemsPerPage, total } = this.paginationConfig;
      this.paginationConfig.page = Math.max(1, this.paginationConfig.page);
      this.paginationConfig.start = itemsPerPage * (this.paginationConfig.page - 1) + 1;
      this.paginationConfig.end = this.paginationConfig.start - 1 + (itemsPerPage || total);
      if (typeof this.fetch === "function")
        await this.callApiFetch();
    },
    async callApiFetch() {
      const { page, start, end, total, itemsPerPage } = this.paginationConfig;
      return await this.fetch({
        page,
        start,
        end: end || total,
        total,
        itemsPerPage: itemsPerPage || total,
        sorting: this.activeSorting
      });
    }
  },
  created() {
    if (!this.sort)
      this.activeSorting = [];
    else
      this.activeSorting = Array.isArray(this.sort) ? this.sort : [this.sort];
    if ((this.expandedRows || []).length)
      this.expandedRowsInternal = this.expandedRows;
    if ((this.selectedRows || []).length)
      this.selectedRowsInternal = this.selectedRows;
    if (this.pagination)
      this.initPagination();
  },
  watch: {
    sort(sorting) {
      if (!sorting)
        this.activeSorting = [];
      else
        this.activeSorting = Array.isArray(sorting) ? sorting : [sorting];
    },
    expandableRows(value) {
      if (!value)
        this.expandedRowsInternal = [];
      else if (value.toString() === "1")
        this.expandedRowsInternal = this.expandedRowsInternal.slice(0, 1);
    },
    expandedRows(array) {
      this.expandedRowsInternal = Array.isArray(array) && array.length ? this.expandedRows : [];
    },
    selectableRows(value) {
      if (!value)
        this.selectedRowsInternal = [];
      else if (value.toString() === "1")
        this.selectedRowsInternal = this.selectedRowsInternal.slice(0, 1);
    },
    selectedRows(array) {
      this.selectedRowsInternal = Array.isArray(array) && array.length ? this.selectedRows : [];
    },
    "pagination.page"(page) {
      this.updatePaginationConfig({ page });
    },
    "pagination.itemsPerPage"(itemsPerPage) {
      this.updatePaginationConfig({ itemsPerPage });
    },
    "pagination.total"(total) {
      this.updatePaginationConfig({ total });
    }
  }
};
const __cssModules$e = {};
var __component__$e = /* @__PURE__ */ normalizeComponent(
  __vue2_script$e,
  render$e,
  staticRenderFns$e,
  false,
  __vue2_injectStyles$e,
  null,
  null,
  null
);
function __vue2_injectStyles$e(context) {
  for (let o in __cssModules$e) {
    this[o] = __cssModules$e[o];
  }
}
var wTable = /* @__PURE__ */ function() {
  return __component__$e.exports;
}();
var render$d = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("span", _vm._g({ staticClass: "w-tag", class: _vm.classes, style: _vm.styles, attrs: { "role": _vm.value !== -1 && "button", "aria-pressed": _vm.value !== -1 && (_vm.value ? "true" : "false"), "tabindex": _vm.value !== -1 && 0 }, on: { "click": function($event) {
    _vm.$emit("update:modelValue", !_vm.value);
    _vm.$emit("input", !_vm.value);
  }, "keypress": function($event) {
    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
      return null;
    }
    _vm.$emit("update:modelValue", !_vm.value);
    _vm.$emit("input", !_vm.value);
  } } }, _vm.$listeners), [_vm._t("default"), _vm.closable && _vm.value ? _c("i", { staticClass: "w-icon w-tag__closable wi-cross", attrs: { "role": "icon", "aria-hidden": "true" }, on: { "click": function($event) {
    $event.stopPropagation();
    _vm.$emit("update:modelValue", false);
    _vm.$emit("input", false);
  } } }) : _vm._e()], 2);
};
var staticRenderFns$d = [];
var wTag_vue_vue_type_style_index_0_lang = "";
const __vue2_script$d = {
  name: "w-tag",
  props: {
    value: { type: [Boolean, Number], default: -1 },
    color: { type: String },
    bgColor: { type: String },
    dark: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    closable: { type: Boolean },
    outline: { type: Boolean },
    noBorder: { type: Boolean },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    width: { type: [Number, String] },
    height: { type: [Number, String] }
  },
  emits: ["input", "update:modelValue"],
  computed: {
    presetSize() {
      return this.xs && "xs" || this.sm && "sm" || this.lg && "lg" || this.xl && "xl" || "md";
    },
    classes() {
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        [`size--${this.presetSize}`]: true,
        "w-tag--dark": this.dark && !this.outline,
        "w-tag--clickable": this.value !== -1,
        "w-tag--outline": this.outline,
        "w-tag--no-border": this.noBorder || this.shadow,
        "w-tag--tile": this.tile,
        "w-tag--round": this.round,
        "w-tag--shadow": this.shadow
      };
    },
    styles() {
      return {
        width: (!isNaN(this.width) ? `${this.width}px` : this.width) || null,
        height: (!isNaN(this.height) ? `${this.height}px` : this.height) || null
      };
    }
  }
};
const __cssModules$d = {};
var __component__$d = /* @__PURE__ */ normalizeComponent(
  __vue2_script$d,
  render$d,
  staticRenderFns$d,
  false,
  __vue2_injectStyles$d,
  null,
  null,
  null
);
function __vue2_injectStyles$d(context) {
  for (let o in __cssModules$d) {
    this[o] = __cssModules$d[o];
  }
}
var wTag = /* @__PURE__ */ function() {
  return __component__$d.exports;
}();
var render$c = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(_vm.formRegister ? "w-form-element" : "div", _vm._b({ ref: "formEl", tag: "component", class: _vm.classes, attrs: { "valid": _vm.valid, "wrap": _vm.hasLabel && _vm.labelPosition !== "inside" }, on: { "update:valid": function($event) {
    _vm.valid = $event;
  }, "reset": function($event) {
    _vm.$emit("update:modelValue", _vm.inputValue = "");
    _vm.$emit("input", "");
  } } }, "component", _vm.formRegister && { validators: _vm.validators, inputValue: _vm.inputValue, disabled: _vm.isDisabled, readonly: _vm.isReadonly, isFocused: _vm.isFocused }, false), [_vm.labelPosition === "left" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-textarea__label w-textarea__label--left w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-textarea--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e(), _c("div", { staticClass: "w-textarea__textarea-wrap", class: _vm.inputWrapClasses }, [_vm.innerIconLeft ? _c("w-icon", { staticClass: "w-textarea__icon w-textarea__icon--inner-left", attrs: { "tag": "label", "for": "w-textarea--" + _vm._uid }, on: { "click": function($event) {
    return _vm.$emit("click:inner-icon-left", $event);
  } } }, [_vm._v(_vm._s(_vm.innerIconLeft))]) : _vm._e(), _c("textarea", _vm._g({ directives: [{ name: "model", rawName: "v-model", value: _vm.inputValue, expression: "inputValue" }], ref: "textarea", staticClass: "w-textarea__textarea", attrs: { "id": "w-textarea--" + _vm._uid, "name": _vm.inputName, "placeholder": _vm.placeholder || null, "rows": _vm.rows || null, "cols": _vm.cols || null, "readonly": _vm.isReadonly || null, "aria-readonly": _vm.isReadonly ? "true" : "false", "disabled": _vm.isDisabled || null, "required": _vm.required || null, "tabindex": _vm.tabindex || null }, domProps: { "value": _vm.inputValue }, on: { "input": [function($event) {
    if ($event.target.composing) {
      return;
    }
    _vm.inputValue = $event.target.value;
  }, _vm.onInput], "focus": _vm.onFocus, "blur": _vm.onBlur } }, _vm.listeners)), _vm.labelPosition === "inside" && _vm.showLabelInside ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-textarea__label w-textarea__label--inside w-form-el-shakable", class: _vm.labelClasses }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e(), _vm.innerIconRight ? _c("w-icon", { staticClass: "w-textarea__icon w-textarea__icon--inner-right", attrs: { "tag": "label", "for": "w-textarea--" + _vm._uid }, on: { "click": function($event) {
    return _vm.$emit("click:inner-icon-right", $event);
  } } }, [_vm._v(_vm._s(_vm.innerIconRight))]) : _vm._e()], 2), _vm.labelPosition === "right" ? [_vm.$slots.default || _vm.label ? _c("label", { staticClass: "w-textarea__label w-textarea__label--right w-form-el-shakable", class: _vm.labelClasses, attrs: { "for": "w-textarea--" + _vm._uid } }, [_vm._t("default", function() {
    return [_vm._v(_vm._s(_vm.label))];
  })], 2) : _vm._e()] : _vm._e()], 2);
};
var staticRenderFns$c = [];
var wTextarea_vue_vue_type_style_index_0_lang = "";
const __vue2_script$c = {
  name: "w-textarea",
  mixins: [FormElementMixin],
  props: {
    value: { default: "" },
    label: { type: String },
    labelPosition: { type: String, default: "inside" },
    innerIconLeft: { type: String },
    innerIconRight: { type: String },
    staticLabel: { type: Boolean },
    placeholder: { type: String },
    color: { type: String, default: "primary" },
    bgColor: { type: String },
    labelColor: { type: String, default: "primary" },
    dark: { type: Boolean },
    outline: { type: Boolean },
    shadow: { type: Boolean },
    noAutogrow: { type: Boolean },
    resizable: { type: Boolean },
    tile: { type: Boolean },
    rows: { type: [Number, String], default: 3 },
    cols: { type: [Number, String] }
  },
  emits: ["input", "update:modelValue", "focus", "blur", "click:inner-icon-left", "click:inner-icon-right"],
  data() {
    return {
      inputValue: this.value,
      isFocused: false,
      height: null,
      lineHeight: null,
      paddingY: null
    };
  },
  computed: {
    listeners() {
      const { input, focus, blur, ...listeners } = this.$listeners;
      return listeners;
    },
    hasValue() {
      return this.inputValue || this.inputValue === 0;
    },
    hasLabel() {
      return this.label || this.$slots.default;
    },
    showLabelInside() {
      return !this.staticLabel || !this.hasValue && !this.placeholder;
    },
    classes() {
      return {
        "w-textarea": true,
        "w-textarea--disabled": this.isDisabled,
        "w-textarea--readonly": this.isReadonly,
        [`w-textarea--${this.hasValue ? "filled" : "empty"}`]: true,
        "w-textarea--focused": this.isFocused && !this.isReadonly,
        "w-textarea--dark": this.dark,
        "w-textarea--resizable": this.resizable,
        "w-textarea--floating-label": this.hasLabel && this.labelPosition === "inside" && !this.staticLabel,
        "w-textarea--no-padding": !this.outline && !this.bgColor && !this.shadow,
        "w-textarea--has-placeholder": this.placeholder,
        "w-textarea--inner-icon-left": this.innerIconLeft,
        "w-textarea--inner-icon-right": this.innerIconRight
      };
    },
    inputWrapClasses() {
      return {
        [this.valid === false ? this.validationColor : this.color]: this.color || this.valid === false,
        [`${this.bgColor}--bg`]: this.bgColor,
        "w-textarea__textarea-wrap--tile": this.tile,
        "w-textarea__textarea-wrap--box": this.outline || this.bgColor || this.shadow,
        "w-textarea__textarea-wrap--underline": !this.outline,
        "w-textarea__textarea-wrap--shadow": this.shadow,
        "w-textarea__textarea-wrap--no-padding": !this.outline && !this.bgColor && !this.shadow
      };
    },
    textareaStyles() {
      if (this.noAutogrow || this.resizable)
        return {};
      return {
        height: this.height ? `${this.height}px` : null
      };
    }
  },
  methods: {
    onInput() {
      if (!this.noAutogrow && !this.resizable)
        this.computeHeight();
      this.$emit("update:modelValue", this.inputValue);
      this.$emit("input", this.inputValue);
    },
    onFocus(e) {
      this.isFocused = true;
      this.$emit("focus", e);
    },
    onBlur(e) {
      this.isFocused = false;
      this.$emit("blur", e);
    },
    computeHeight() {
      this.$refs.textarea.style.height = "";
      const linesCount = (this.$refs.textarea.scrollHeight - this.paddingY) / this.lineHeight;
      const height = Math.max(linesCount, this.rows) * this.lineHeight + this.paddingY;
      this.$refs.textarea.style.height = height + "px";
    },
    getLineHeight() {
      const computedStyles = window.getComputedStyle(this.$refs.textarea, null);
      this.lineHeight = parseFloat(computedStyles.getPropertyValue("line-height"));
      this.paddingY = parseFloat(computedStyles.getPropertyValue("padding-top"));
      this.paddingY += parseFloat(computedStyles.getPropertyValue("padding-bottom"));
    }
  },
  mounted() {
    if (!this.noAutogrow && !this.resizable) {
      this.getLineHeight();
      this.computeHeight();
    }
  },
  watch: {
    value(value) {
      this.inputValue = value;
      this.$nextTick(this.computeHeight);
    },
    resizable(value) {
      if (value)
        this.height = null;
      else if (!this.noAutogrow)
        this.getLineHeight();
    },
    noAutogrow(value) {
      if (value)
        this.getLineHeight();
      else
        this.height = null;
    }
  }
};
const __cssModules$c = {};
var __component__$c = /* @__PURE__ */ normalizeComponent(
  __vue2_script$c,
  render$c,
  staticRenderFns$c,
  false,
  __vue2_injectStyles$c,
  null,
  null,
  null
);
function __vue2_injectStyles$c(context) {
  for (let o in __cssModules$c) {
    this[o] = __cssModules$c[o];
  }
}
var wTextarea = /* @__PURE__ */ function() {
  return __component__$c.exports;
}();
var render$b = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", { staticClass: "w-timeline" }, _vm._l(_vm.items, function(item, i) {
    var _obj;
    return _c("li", { key: i, staticClass: "w-timeline-item" }, [_c(item[_vm.itemIconKey] || _vm.icon ? "w-icon" : "div", { tag: "component", staticClass: "w-timeline-item__bullet", class: (_obj = {}, _obj[item[_vm.itemColorKey] || _vm.color] = item[_vm.itemColorKey] || _vm.color, _obj) }, [_vm._v(_vm._s(item[_vm.itemIconKey] || _vm.icon))]), !_vm.$scopedSlots["item." + (i + 1)] ? _vm._t("item", function() {
      var _obj2;
      return [_c("div", { staticClass: "w-timeline-item__title", class: (_obj2 = {}, _obj2[item[_vm.itemColorKey] || _vm.color] = item[_vm.itemColorKey] || _vm.color, _obj2), domProps: { "innerHTML": _vm._s(item[_vm.itemTitleKey]) } }), _c("div", { staticClass: "w-timeline-item__content", domProps: { "innerHTML": _vm._s(item[_vm.itemContentKey]) } })];
    }, { "item": item, "index": i + 1 }) : _vm._t("item." + (i + 1), null, { "item": item, "index": i + 1 })], 2);
  }), 0);
};
var staticRenderFns$b = [];
var wTimeline_vue_vue_type_style_index_0_lang = "";
const __vue2_script$b = {
  name: "w-timeline",
  props: {
    items: { type: [Array, Number], required: true },
    color: { type: String },
    icon: { type: String },
    itemTitleKey: { type: String, default: "title" },
    itemContentKey: { type: String, default: "content" },
    itemIconKey: { type: String, default: "icon" },
    itemColorKey: { type: String, default: "color" }
  },
  emits: []
};
const __cssModules$b = {};
var __component__$b = /* @__PURE__ */ normalizeComponent(
  __vue2_script$b,
  render$b,
  staticRenderFns$b,
  false,
  __vue2_injectStyles$b,
  null,
  null,
  null
);
function __vue2_injectStyles$b(context) {
  for (let o in __cssModules$b) {
    this[o] = __cssModules$b[o];
  }
}
var wTimeline = /* @__PURE__ */ function() {
  return __component__$b.exports;
}();
var render$a = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-toolbar", class: _vm.classes, style: _vm.styles }, [_vm._t("default")], 2);
};
var staticRenderFns$a = [];
var wToolbar_vue_vue_type_style_index_0_lang = "";
const __vue2_script$a = {
  name: "w-toolbar",
  props: {
    color: { type: String },
    bgColor: { type: String },
    absolute: { type: Boolean },
    fixed: { type: Boolean },
    bottom: { type: Boolean },
    vertical: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    width: { type: [Number, String], default: null },
    height: { type: [Number, String], default: null },
    noBorder: { type: Boolean },
    shadow: { type: Boolean }
  },
  emits: [],
  computed: {
    toolbarHeight() {
      const h = this.height;
      return h && parseInt(h) == h ? h + "px" : h;
    },
    toolbarWidth() {
      const w = this.width;
      return w && parseInt(w) == w ? w + "px" : w;
    },
    classes() {
      return {
        [this.color]: !!this.color,
        [`${this.bgColor}--bg`]: !!this.bgColor,
        "w-toolbar--absolute": !!this.absolute,
        "w-toolbar--fixed": !!this.fixed,
        [`w-toolbar--${this.bottom ? "bottom" : "top"}`]: !this.vertical,
        [`w-toolbar--vertical w-toolbar--${this.right ? "right" : "left"}`]: this.vertical,
        "w-toolbar--no-border": this.noBorder,
        "w-toolbar--shadow": !!this.shadow
      };
    },
    styles() {
      return {
        height: this.height && !this.vertical ? this.toolbarHeight : null,
        width: this.width && this.vertical ? this.toolbarWidth : null
      };
    }
  }
};
const __cssModules$a = {};
var __component__$a = /* @__PURE__ */ normalizeComponent(
  __vue2_script$a,
  render$a,
  staticRenderFns$a,
  false,
  __vue2_injectStyles$a,
  null,
  null,
  null
);
function __vue2_injectStyles$a(context) {
  for (let o in __cssModules$a) {
    this[o] = __cssModules$a[o];
  }
}
var wToolbar = /* @__PURE__ */ function() {
  return __component__$a.exports;
}();
var render$9 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", { staticClass: "w-tooltip-wrap" }, [_vm._t("activator", null, { "on": _vm.activatorEventHandlers }), _c("transition", { attrs: { "name": _vm.transitionName, "appear": "" } }, [_vm.detachableVisible ? _c("div", { key: _vm._uid, ref: "detachable", staticClass: "w-tooltip", class: _vm.classes, style: _vm.styles }, [_vm._t("default")], 2) : _vm._e()])], 2);
};
var staticRenderFns$9 = [];
var wTooltip_vue_vue_type_style_index_0_lang = "";
const __vue2_script$9 = {
  name: "w-tooltip",
  mixins: [DetachableMixin],
  props: {
    value: {},
    showOnClick: { type: Boolean },
    color: { type: String },
    bgColor: { type: String },
    noBorder: { type: Boolean },
    shadow: { type: Boolean },
    tile: { type: Boolean },
    round: { type: Boolean },
    transition: { type: String },
    tooltipClass: { type: [String, Object, Array] },
    persistent: { type: Boolean },
    delay: { type: Number },
    caption: { type: Boolean },
    xs: { type: Boolean },
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    xl: { type: Boolean },
    enableTouch: { type: Boolean }
  },
  emits: ["input", "update:modelValue", "open", "close"],
  data: () => ({
    detachableVisible: false,
    hoveringActivator: false,
    detachableCoords: {
      top: 0,
      left: 0
    },
    detachableEl: null,
    timeoutId: null
  }),
  computed: {
    tooltipClasses() {
      return objectifyClasses(this.tooltipClass);
    },
    transitionName() {
      const direction = this.position.replace(/top|bottom/, (m) => ({ top: "up", bottom: "down" })[m]);
      return this.transition || `w-tooltip-slide-fade-${direction}`;
    },
    size() {
      return this.xs && "xs" || this.sm && "sm" || this.sm && "md" || this.lg && "lg" || this.xl && "xl" || (this.caption ? "sm" : "md");
    },
    classes() {
      return {
        [this.color]: this.color,
        [`${this.bgColor}--bg`]: this.bgColor,
        ...this.tooltipClasses,
        [`w-tooltip--${this.position}`]: !this.noPosition,
        [`w-tooltip--align-${this.alignment}`]: !this.noPosition && this.alignment,
        "w-tooltip--tile": this.tile,
        "w-tooltip--round": this.round,
        caption: this.caption,
        [`size--${this.size}`]: true,
        "w-tooltip--shadow": this.shadow,
        "w-tooltip--fixed": this.fixed,
        "w-tooltip--no-border": this.noBorder || this.bgColor,
        "w-tooltip--custom-transition": this.transition
      };
    },
    styles() {
      return {
        zIndex: this.zIndex || this.zIndex === 0 || null,
        top: this.detachableCoords.top && `${~~this.detachableCoords.top}px` || null,
        left: this.detachableCoords.left && `${~~this.detachableCoords.left}px` || null,
        "--w-tooltip-bg-color": this.$waveui.colors[this.bgColor] || "rgb(var(--w-base-bg-color-rgb))"
      };
    },
    activatorEventHandlers() {
      let handlers = {};
      const isTouchDevice = typeof window !== "undefined" && "ontouchstart" in window;
      if (!this.showOnClick && !isTouchDevice) {
        handlers = {
          focus: this.open,
          blur: this.close,
          mouseenter: (e) => {
            this.hoveringActivator = true;
            this.open(e);
          },
          mouseleave: (e) => {
            this.hoveringActivator = false;
            this.close();
          }
        };
      } else if (this.enableTouch || this.showOnClick)
        handlers = { click: this.toggle };
      return handlers;
    }
  },
  methods: {
    toggle(e) {
      let shouldShowTooltip = this.detachableVisible;
      if (typeof window !== "undefined" && "ontouchstart" in window) {
        if (!this.enableTouch && !this.showOnClick)
          shouldShowTooltip = false;
        else
          shouldShowTooltip = !shouldShowTooltip;
      } else if (e.type === "click" && this.showOnClick)
        shouldShowTooltip = !shouldShowTooltip;
      else if (["mouseenter", "focus"].includes(e.type) && !this.showOnClick)
        shouldShowTooltip = true;
      else if (["mouseleave", "blur"].includes(e.type) && !this.showOnClick)
        shouldShowTooltip = false;
      this.timeoutId = clearTimeout(this.timeoutId);
      if (shouldShowTooltip)
        this.open(e);
      else
        this.close();
    },
    async close(force = false) {
      if (!this.detachableVisible)
        return;
      if (this.showOnHover && !force) {
        await new Promise((resolve) => setTimeout(resolve, 10));
        if (this.showOnHover && this.hoveringActivator)
          return;
      }
      this.$emit("update:modelValue", this.detachableVisible = false);
      this.$emit("input", false);
      this.$emit("close");
      document.removeEventListener("mousedown", this.onOutsideMousedown);
      window.removeEventListener("resize", this.onResize);
    }
  }
};
const __cssModules$9 = {};
var __component__$9 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$9,
  render$9,
  staticRenderFns$9,
  false,
  __vue2_injectStyles$9,
  null,
  null,
  null
);
function __vue2_injectStyles$9(context) {
  for (let o in __cssModules$9) {
    this[o] = __cssModules$9[o];
  }
}
var wTooltip = /* @__PURE__ */ function() {
  return __component__$9.exports;
}();
var render$8 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": "bounce" } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$8 = [];
const __vue2_script$8 = {
  name: "w-transition-bounce",
  props: {
    appear: { type: Boolean },
    duration: { type: [Number, String] }
  }
};
const __cssModules$8 = {};
var __component__$8 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$8,
  render$8,
  staticRenderFns$8,
  false,
  __vue2_injectStyles$8,
  null,
  null,
  null
);
function __vue2_injectStyles$8(context) {
  for (let o in __cssModules$8) {
    this[o] = __cssModules$8[o];
  }
}
var wTransitionBounce = /* @__PURE__ */ function() {
  return __component__$8.exports;
}();
var render$7 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", { attrs: { "name": "expand", "mode": "out-in", "css": false }, on: { "before-appear": _vm.beforeAppear, "appear": _vm.appear, "after-appear": _vm.afterAppear, "before-enter": _vm.beforeEnter, "enter": _vm.enter, "after-enter": _vm.afterEnter, "before-leave": _vm.beforeLeave, "leave": _vm.leave, "after-leave": _vm.afterLeave } }, [_vm._t("default")], 2);
};
var staticRenderFns$7 = [];
const __vue2_script$7 = {
  name: "w-transition-expand",
  props: {
    x: { type: Boolean },
    y: { type: Boolean },
    duration: { type: Number, default: 250 }
  },
  data: () => ({
    el: {
      savedState: false,
      originalStyles: "",
      width: 0,
      height: 0,
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: 0,
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0,
      borderTopWidth: 0,
      borderBottomWidth: 0
    },
    cleanTransitionCycle: true
  }),
  computed: {
    animX() {
      return this.x || !this.y;
    },
    animY() {
      return this.y || !this.x;
    }
  },
  methods: {
    beforeAppear(el) {
      if (this.cleanTransitionCycle)
        this.saveOriginalInlineStyles(el);
      this.cleanTransitionCycle = false;
    },
    appear(el, done) {
      this.show(el);
      setTimeout(done, this.duration);
      this.cleanTransitionCycle = false;
    },
    afterAppear(el) {
      this.applyOriginalStyles(el);
      el.style.cssText = el.style.cssText.replace("display: none;", "");
      this.cleanTransitionCycle = false;
    },
    beforeEnter(el) {
      if (this.cleanTransitionCycle)
        this.saveOriginalInlineStyles(el);
      this.cleanTransitionCycle = false;
    },
    enter(el, done) {
      this.show(el);
      setTimeout(done, this.duration);
      this.cleanTransitionCycle = false;
    },
    afterEnter(el) {
      this.applyOriginalStyles(el);
      el.style.cssText = el.style.cssText.replace("display: none;", "");
      this.cleanTransitionCycle = false;
    },
    beforeLeave(el) {
      if (!this.el.savedState)
        this.saveComputedStyles(el);
      this.beforeHide(el);
      this.cleanTransitionCycle = false;
    },
    leave(el, done) {
      this.hide(el);
      setTimeout(done, this.duration);
      this.cleanTransitionCycle = false;
    },
    afterLeave(el) {
      this.applyOriginalStyles(el);
      this.cleanTransitionCycle = true;
      this.el.savedState = false;
    },
    applyHideStyles(el) {
      if (this.animX) {
        el.style.width = 0;
        el.style.marginLeft = 0;
        el.style.marginRight = 0;
        el.style.paddingLeft = 0;
        el.style.paddingRight = 0;
        el.style.borderLeftWidth = 0;
        el.style.borderRightWidth = 0;
      }
      if (this.animY) {
        el.style.height = 0;
        el.style.marginTop = 0;
        el.style.marginBottom = 0;
        el.style.paddingTop = 0;
        el.style.paddingBottom = 0;
        el.style.borderTopWidth = 0;
        el.style.borderBottomWidth = 0;
      }
      el.style.overflow = "hidden";
    },
    applyShowStyles(el) {
      if (this.animX) {
        el.style.width = this.el.width + "px";
        el.style.marginLeft = this.el.marginLeft;
        el.style.marginRight = this.el.marginRight;
        el.style.paddingLeft = this.el.paddingLeft;
        el.style.paddingRight = this.el.paddingRight;
        el.style.borderLeftWidth = this.el.borderLeftWidth;
        el.style.borderRightWidth = this.el.borderRightWidth;
      }
      if (this.animY) {
        el.style.height = this.el.height + "px";
        el.style.marginTop = this.el.marginTop;
        el.style.marginBottom = this.el.marginBottom;
        el.style.paddingTop = this.el.paddingTop;
        el.style.paddingBottom = this.el.paddingBottom;
        el.style.borderTopWidth = this.el.borderTopWidth;
        el.style.borderBottomWidth = this.el.borderBottomWidth;
      }
      el.style.transition = this.duration + "ms ease-in-out";
    },
    applyOriginalStyles(el) {
      el.style.cssText = this.el.originalStyles;
    },
    saveOriginalInlineStyles(el) {
      this.el.originalStyles = el.style.cssText;
    },
    show(el) {
      this.saveComputedStyles(el);
      this.applyHideStyles(el);
      setTimeout(() => this.applyShowStyles(el), 20);
    },
    beforeHide(el) {
      this.applyShowStyles(el);
    },
    hide(el) {
      setTimeout(() => this.applyHideStyles(el), 20);
    },
    saveComputedStyles(el) {
      const computedStyles = window.getComputedStyle(el, null);
      if (this.animX) {
        this.el.width = el.offsetWidth;
        this.el.marginLeft = computedStyles.getPropertyValue("marginLeft");
        this.el.marginRight = computedStyles.getPropertyValue("marginRight");
        this.el.paddingLeft = computedStyles.getPropertyValue("paddingLeft");
        this.el.paddingRight = computedStyles.getPropertyValue("paddingRight");
        this.el.borderLeftWidth = computedStyles.getPropertyValue("borderLeftWidth");
        this.el.borderRightWidth = computedStyles.getPropertyValue("borderRightWidth");
      }
      if (this.animY) {
        this.el.height = el.offsetHeight;
        this.el.marginTop = computedStyles.getPropertyValue("marginTop");
        this.el.marginBottom = computedStyles.getPropertyValue("marginBottom");
        this.el.paddingTop = computedStyles.getPropertyValue("paddingTop");
        this.el.paddingBottom = computedStyles.getPropertyValue("paddingBottom");
        this.el.borderTopWidth = computedStyles.getPropertyValue("borderTopWidth");
        this.el.borderBottomWidth = computedStyles.getPropertyValue("borderBottomWidth");
      }
      this.el.savedState = true;
    }
  }
};
const __cssModules$7 = {};
var __component__$7 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$7,
  render$7,
  staticRenderFns$7,
  false,
  __vue2_injectStyles$7,
  null,
  null,
  null
);
function __vue2_injectStyles$7(context) {
  for (let o in __cssModules$7) {
    this[o] = __cssModules$7[o];
  }
}
var wTransitionExpand = /* @__PURE__ */ function() {
  return __component__$7.exports;
}();
var render$6 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": "fade" } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$6 = [];
const __vue2_script$6 = {
  name: "w-transition-fade",
  props: {
    appear: { type: Boolean },
    duration: { type: [Number, String] }
  }
};
const __cssModules$6 = {};
var __component__$6 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$6,
  render$6,
  staticRenderFns$6,
  false,
  __vue2_injectStyles$6,
  null,
  null,
  null
);
function __vue2_injectStyles$6(context) {
  for (let o in __cssModules$6) {
    this[o] = __cssModules$6[o];
  }
}
var wTransitionFade = /* @__PURE__ */ function() {
  return __component__$6.exports;
}();
var render$5 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": "scale" } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$5 = [];
const __vue2_script$5 = {
  name: "w-transition-scale",
  props: {
    appear: { type: Boolean },
    duration: { type: [Number, String] }
  }
};
const __cssModules$5 = {};
var __component__$5 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$5,
  render$5,
  staticRenderFns$5,
  false,
  __vue2_injectStyles$5,
  null,
  null,
  null
);
function __vue2_injectStyles$5(context) {
  for (let o in __cssModules$5) {
    this[o] = __cssModules$5[o];
  }
}
var wTransitionScale = /* @__PURE__ */ function() {
  return __component__$5.exports;
}();
var render$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": "scale-fade" } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$4 = [];
const __vue2_script$4 = {
  name: "w-transition-scale-fade",
  props: {
    appear: { type: Boolean },
    duration: { type: [Number, String] }
  }
};
const __cssModules$4 = {};
var __component__$4 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$4,
  render$4,
  staticRenderFns$4,
  false,
  __vue2_injectStyles$4,
  null,
  null,
  null
);
function __vue2_injectStyles$4(context) {
  for (let o in __cssModules$4) {
    this[o] = __cssModules$4[o];
  }
}
var wTransitionScaleFade = /* @__PURE__ */ function() {
  return __component__$4.exports;
}();
var render$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": _vm.transitionName } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$3 = [];
const __vue2_script$3 = {
  name: "w-transition-slide",
  props: {
    appear: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    up: { type: Boolean },
    down: { type: Boolean },
    duration: { type: [Number, String] }
  },
  computed: {
    direction() {
      return this.up && "up" || this.down && "down" || this.left && "left" || this.right && "right" || "down";
    },
    transitionName() {
      return `slide-${this.direction}`;
    }
  }
};
const __cssModules$3 = {};
var __component__$3 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$3,
  render$3,
  staticRenderFns$3,
  false,
  __vue2_injectStyles$3,
  null,
  null,
  null
);
function __vue2_injectStyles$3(context) {
  for (let o in __cssModules$3) {
    this[o] = __cssModules$3[o];
  }
}
var wTransitionSlide = /* @__PURE__ */ function() {
  return __component__$3.exports;
}();
var render$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": _vm.transitionName } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$2 = [];
const __vue2_script$2 = {
  name: "w-transition-slide-fade",
  props: {
    appear: { type: Boolean },
    left: { type: Boolean },
    right: { type: Boolean },
    up: { type: Boolean },
    down: { type: Boolean },
    duration: { type: [Number, String] }
  },
  computed: {
    direction() {
      return this.up && "up" || this.down && "down" || this.left && "left" || this.right && "right" || "down";
    },
    transitionName() {
      return `slide-fade-${this.direction}`;
    }
  }
};
const __cssModules$2 = {};
var __component__$2 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$2,
  render$2,
  staticRenderFns$2,
  false,
  __vue2_injectStyles$2,
  null,
  null,
  null
);
function __vue2_injectStyles$2(context) {
  for (let o in __cssModules$2) {
    this[o] = __cssModules$2[o];
  }
}
var wTransitionSlideFade = /* @__PURE__ */ function() {
  return __component__$2.exports;
}();
var render$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("transition", _vm._b({ attrs: { "name": "twist" } }, "transition", _vm.$props, false), [_vm._t("default")], 2);
};
var staticRenderFns$1 = [];
const __vue2_script$1 = {
  name: "w-transition-twist",
  props: {
    appear: { type: Boolean },
    duration: { type: [Number, String] }
  }
};
const __cssModules$1 = {};
var __component__$1 = /* @__PURE__ */ normalizeComponent(
  __vue2_script$1,
  render$1,
  staticRenderFns$1,
  false,
  __vue2_injectStyles$1,
  null,
  null,
  null
);
function __vue2_injectStyles$1(context) {
  for (let o in __cssModules$1) {
    this[o] = __cssModules$1[o];
  }
}
var wTransitionTwist = /* @__PURE__ */ function() {
  return __component__$1.exports;
}();
var render = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", { staticClass: "w-tree", class: _vm.classes }, _vm._l(_vm.currentDepthItems, function(item, i) {
    var _obj;
    return _c("li", { key: i, staticClass: "w-tree__item", class: _vm.itemClasses(item) }, [_c(_vm.getTreeItemComponent(item), _vm._b({ tag: "component", staticClass: "w-tree__item-label", attrs: { "tabindex": _vm.getTreeItemTabindex(item) }, on: { "click": function($event) {
      !_vm.disabled && !item.disabled && _vm.onLabelClick(item, $event);
    }, "keydown": function($event) {
      !_vm.disabled && !item.disabled && _vm.onLabelKeydown(item, $event);
    } } }, "component", item.route && (_obj = {}, _obj[!_vm.$router || _vm.hasExternalLink(item) ? "href" : "to"] = item.route, _obj), false), [(item.children || item.branch) && (_vm.expandOpenIcon && item.open || _vm.expandIcon) && !(_vm.unexpandableEmpty && !item.children) ? _c("w-button", { staticClass: "w-tree__item-expand", attrs: { "color": "inherit", "icon": item.open && _vm.expandOpenIcon || _vm.expandIcon, "icon-props": { rotate90a: !item.open }, "tabindex": -1, "disabled": _vm.disabled || item.disabled, "text": "", "sm": "" }, on: { "click": function($event) {
      $event.stopPropagation();
      !_vm.disabled && !item.disabled && _vm.onLabelClick(item, $event);
    } } }) : _vm._e(), _vm._t("item", function() {
      return [_vm.itemIcon(item) ? _c("w-icon", { staticClass: "w-tree__item-icon", attrs: { "color": item.originalItem[_vm.itemIconColorKey] || _vm.iconColor } }, [_vm._v(_vm._s(_vm.itemIcon(item)))]) : _vm._e(), _c("span", { domProps: { "innerHTML": _vm._s(item.label) } }), _vm.counts && (item.children || item.branch) ? _c("span", { staticClass: "ml1" }, [_vm._v("(" + _vm._s(item.originalItem.children ? item.originalItem.children.length : 0) + ")")]) : _vm._e()];
    }, { "item": item.originalItem, "depth": _vm.depth, "path": item.path, "open": item.open })], 2), _c(_vm.noTransition ? "div" : "w-transition-expand", { tag: "component", attrs: { "y": !_vm.noTransition || null }, on: { "after-enter": function($event) {
      _vm.$emit("open", _vm.emitPayload(item));
    }, "after-leave": function($event) {
      _vm.$emit("close", _vm.emitPayload(item));
    } } }, [item.children && item.open ? _c("w-tree", _vm._b({ attrs: { "depth": _vm.depth + 1, "data": item.originalItem.children, "parent": item }, on: { "before-open": function($event) {
      return _vm.$emit("before-open", $event);
    }, "open": function($event) {
      return _vm.$emit("open", $event);
    }, "before-close": function($event) {
      return _vm.$emit("before-close", $event);
    }, "close": function($event) {
      return _vm.$emit("close", $event);
    }, "click": function($event) {
      return _vm.$emit("click", $event);
    }, "select": function($event) {
      return _vm.$emit("select", $event);
    }, "input": function($event) {
      return _vm.$emit("input", $event);
    } }, scopedSlots: _vm._u([{ key: "item", fn: function(ref) {
      var item2 = ref.item;
      var depth = ref.depth;
      var path = ref.path;
      var open = ref.open;
      return [_vm._t("item", null, { "item": item2, "depth": depth, "path": path, "open": open })];
    } }], null, true) }, "w-tree", _vm.$props, false)) : _vm._e()], 1)], 1);
  }), 0);
};
var staticRenderFns = [];
var wTree_vue_vue_type_style_index_0_lang = "";
const __vue2_script = {
  name: "w-tree",
  props: {
    value: { type: [Object, Array] },
    data: { type: [Object, Array], required: true },
    depth: { type: Number, default: 0 },
    parent: { type: Object, default: null },
    branchClass: { type: String },
    leafClass: { type: String },
    branchIcon: { type: String },
    branchOpenIcon: { type: String },
    leafIcon: { type: String },
    expandIcon: { type: [Boolean, String], default: "wi-triangle-down" },
    expandOpenIcon: { type: [Boolean, String] },
    expandAll: { type: Boolean },
    unexpandableEmpty: { type: Boolean },
    disabled: { type: Boolean },
    noTransition: { type: Boolean },
    selectable: { type: Boolean },
    deepReactivity: { type: Boolean },
    counts: { type: Boolean },
    itemIconKey: { type: String, default: "icon" },
    iconColor: { type: String },
    itemLabelKey: { type: String, default: "label" },
    itemIconColorKey: { type: String, default: "iconColor" },
    itemRouteKey: { type: String, default: "route" },
    itemDisabledKey: { type: String, default: "disabled" },
    itemOpenKey: { type: String, default: "open" }
  },
  emits: ["input", "before-open", "open", "before-close", "close", "click", "select"],
  data: () => ({
    currentDepthItems: [],
    dataPropUnwatch: null
  }),
  computed: {
    classes() {
      return {
        [`w-tree--depth${this.depth}`]: true,
        "w-tree--expand-icon": this.expandIcon && !this.depth,
        "w-tree--selectable": this.selectable,
        "w-tree--disabled": this.disabled && !this.depth,
        "w-tree--no-expand-button": !this.expandIcon
      };
    }
  },
  methods: {
    updateCurrentDepthTree(items, oldItems = []) {
      this.currentDepthItems = [];
      if (!Array.isArray(items) && typeof items !== "object") {
        return consoleWarn(`[w-tree] the tree items must be of type array or object, ${typeof items} received.`);
      }
      if (!Array.isArray(items))
        items = [items];
      items.forEach((item, i) => {
        var _a, _b;
        const itemWrapper = {
          originalItem: item,
          _uid: this.depth.toString() + (i + 1),
          label: item[this.itemLabelKey],
          children: !!item.children,
          branch: item.branch,
          route: item[this.itemRouteKey],
          disabled: item[this.itemDisabledKey],
          selected: ((_a = oldItems[i]) == null ? void 0 : _a.selected) || false,
          depth: this.depth,
          open: !!(((_b = oldItems[i]) == null ? void 0 : _b.open) || this.expandAll || item[this.itemOpenKey]),
          parent: this.parent || null,
          path: []
        };
        itemWrapper.path = this.getTreeItemPath(itemWrapper);
        this.currentDepthItems.push(itemWrapper);
      });
    },
    getTreeItemComponent(item) {
      return !this.disabled && !item.disabled && item.route ? !this.$router || this.hasExternalLink(item) ? "a" : "router-link" : "div";
    },
    getTreeItemTabindex(item) {
      return !this.disabled && !item.disabled && (item.children || item.branch || this.selectable) && !(this.unexpandableEmpty && !item.children) ? 0 : null;
    },
    getTreeItemPath(item) {
      const ancestorsPath = [item];
      let ancestor = item.parent;
      while (ancestor) {
        ancestorsPath.push(ancestor);
        ancestor = ancestor.parent;
      }
      ancestorsPath.reverse();
      return ancestorsPath;
    },
    getTreeItemPathForOutput(item) {
      return item.path.map((item2) => item2.originalItem);
    },
    expandDepth(item, open) {
      if (typeof open === "boolean")
        item.open = open;
      else
        item.open = !item.open;
      const emitPayload = this.emitPayload(item);
      this.$emit(item.open ? "before-open" : "before-close", emitPayload);
      if (!this.unexpandableEmpty && !item.children) {
        this.$emit(item.open ? "open" : "close", emitPayload);
      }
      return true;
    },
    onLabelClick(item, e) {
      const route = item[this.itemRouteKey];
      if (route && this.$router && !this.hasExternalLink(item))
        e.preventDefault();
      if (item.children || item.branch && !this.unexpandableEmpty)
        this.expandDepth(item);
      if (this.selectable)
        item.selected = !item.selected;
      const emitPayload = this.emitPayload(item, e);
      this.$emit("click", emitPayload);
      this.emitItemSelection(item, e);
    },
    onLabelKeydown(item, e) {
      if (!(e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) && [13, 32, 37, 38, 39, 40].includes(e.keyCode)) {
        if (item.children || item.branch) {
          if ([13, 32].includes(e.keyCode))
            this.expandDepth(item) && e.preventDefault();
          else if (e.keyCode === 37)
            this.expandDepth(item, false) && e.preventDefault();
          else if (e.keyCode === 39)
            this.expandDepth(item, true) && e.preventDefault();
        }
        if ([38, 40].includes(e.keyCode)) {
          const treeRoot = this.$el.closest(".w-tree--depth0");
          const treeTabbableItems = treeRoot.querySelectorAll('.w-tree__item-label[tabindex="0"]');
          const currLabel = e.target.closest(".w-tree__item-label");
          const indexModifier = e.keyCode === 38 ? -1 : 1;
          [...treeTabbableItems].some((item2, i) => {
            if (item2.isSameNode(currLabel)) {
              treeTabbableItems[i + indexModifier] && treeTabbableItems[i + indexModifier].focus();
              return true;
            }
            return false;
          });
        }
      }
      if (e.keyCode === 13) {
        if (this.selectable)
          item.selected = !item.selected;
        this.emitItemSelection(item, e);
      }
    },
    emitItemSelection(item, e) {
      const emitPayload = this.emitPayload(item, e);
      this.$emit("update:model-value", emitPayload);
      if (this.selectable)
        this.$emit("select", emitPayload);
    },
    emitPayload(item, e) {
      const emitPayload = {
        item: item.originalItem,
        depth: this.depth,
        path: this.getTreeItemPathForOutput(item)
      };
      if (e)
        emitPayload.e = e;
      if (item.children || item.branch && !this.unexpandableEmpty)
        emitPayload.open = item.open;
      if (this.selectable)
        emitPayload.selected = item.selected;
      return emitPayload;
    },
    getPreviousSibling(node, selector) {
      while (selector && (node = node.previousElementSibling)) {
        if (node.matches(selector))
          return node;
      }
      return false;
    },
    getNextSibling(node, selector) {
      while (selector && (node = node.nextElementSibling)) {
        if (node.matches(selector))
          return node;
      }
      return false;
    },
    focusTreeItem(liNode) {
      liNode && liNode.querySelector(".w-tree__item-label").focus();
    },
    itemIcon(item) {
      return item.originalItem[this.itemIconKey] || !item.children && !item.branch && this.leafIcon || (item.children || item.branch) && (item.open && this.branchOpenIcon || this.branchIcon);
    },
    hasExternalLink(item) {
      return /^(https?:)?\/\/|mailto:|tel:/.test(item[this.itemRouteKey]);
    },
    itemClasses(item) {
      return {
        [item.children || item.branch ? "w-tree__item--branch" : "w-tree__item--leaf"]: true,
        "w-tree__item--disabled": item[this.itemDisabledKey],
        "w-tree__item--selected": item.selected,
        "w-tree__item--empty": item.branch && !item.children,
        "w-tree__item--unexpandable": item.branch && !item.children && this.unexpandableEmpty
      };
    }
  },
  created() {
    this.updateCurrentDepthTree(this.data);
    this.dataPropUnwatch = this.$watch(
      "data",
      (items) => this.updateCurrentDepthTree(items, this.currentDepthItems),
      { deep: !!this.deepReactivity }
    );
  },
  destroyed() {
    this.dataPropUnwatch();
  }
};
const __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(
  __vue2_script,
  render,
  staticRenderFns,
  false,
  __vue2_injectStyles,
  null,
  null,
  null
);
function __vue2_injectStyles(context) {
  for (let o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var wTree = /* @__PURE__ */ function() {
  return __component__.exports;
}();
var components = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  WAccordion: wAccordion,
  WAlert: wAlert,
  WAutocomplete: wAutocomplete,
  WApp: wApp,
  WBadge: wBadge,
  WBreadcrumbs: wBreadcrumbs,
  WButton: index$1,
  WCard: wCard,
  WCheckbox: wCheckbox,
  WCheckboxes: wCheckboxes,
  WConfirm: wConfirm,
  WDatePicker: wDatePicker,
  WDialog: wDialog,
  WDivider: wDivider,
  WDrawer: wDrawer,
  WFlex: wFlex,
  WForm: wForm,
  WFormElement: wFormElement,
  WGrid: wGrid,
  WIcon: wIcon,
  WImage: wImage,
  WInput: wInput,
  WList: wList,
  WMenu: wMenu,
  WNotification: wNotification,
  WOverlay: wOverlay,
  WParallax: wParallax,
  WProgress: wProgress,
  WRadio: wRadio,
  WRadios: wRadios,
  WRating: wRating,
  WScrollable: wScrollable,
  WSelect: wSelect,
  WSlider: wSlider,
  WSpinner: wSpinner,
  WSteps: wSteps,
  WSwitch: wSwitch,
  WTabs: index,
  WTable: wTable,
  WTag: wTag,
  WTextarea: wTextarea,
  WTimeline: wTimeline,
  WToolbar: wToolbar,
  WTooltip: wTooltip,
  WTransitionBounce: wTransitionBounce,
  WTransitionExpand: wTransitionExpand,
  WTransitionFade: wTransitionFade,
  WTransitionScale: wTransitionScale,
  WTransitionScaleFade: wTransitionScaleFade,
  WTransitionSlide: wTransitionSlide,
  WTransitionSlideFade: wTransitionSlideFade,
  WTransitionTwist: wTransitionTwist,
  WTree: wTree
}, Symbol.toStringTag, { value: "Module" }));
const install = WaveUI.install;
WaveUI.install = (Vue2, options = {}) => install.call(WaveUI, Vue2, { components, ...options });
if (typeof window !== "undefined" && window.Vue)
  window.Vue.use(WaveUI);
export { WaveUI as default };
